import { useQuery, UseQueryOptions, useMutation, UseMutationOptions } from 'react-query';
import { fetchData } from '../api/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Input type for dynamic zone data of ApprovalStep */
  ApprovalStepDataDynamicZoneInput: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Ability = {
  __typename?: 'Ability';
  action?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  house?: Maybe<House>;
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  received_mail?: Maybe<ReceivedMail>;
  role?: Maybe<UsersPermissionsRole>;
  targetModelId: Scalars['Int'];
  targetModelName?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
};

export type AbilityAggregator = {
  __typename?: 'AbilityAggregator';
  avg?: Maybe<AbilityAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AbilityAggregatorMax>;
  min?: Maybe<AbilityAggregatorMin>;
  sum?: Maybe<AbilityAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AbilityAggregatorAvg = {
  __typename?: 'AbilityAggregatorAvg';
  targetModelId?: Maybe<Scalars['Float']>;
};

export type AbilityAggregatorMax = {
  __typename?: 'AbilityAggregatorMax';
  targetModelId?: Maybe<Scalars['Float']>;
};

export type AbilityAggregatorMin = {
  __typename?: 'AbilityAggregatorMin';
  targetModelId?: Maybe<Scalars['Float']>;
};

export type AbilityAggregatorSum = {
  __typename?: 'AbilityAggregatorSum';
  targetModelId?: Maybe<Scalars['Float']>;
};

export type AbilityConnection = {
  __typename?: 'AbilityConnection';
  aggregate?: Maybe<AbilityAggregator>;
  groupBy?: Maybe<AbilityGroupBy>;
  values?: Maybe<Array<Maybe<Ability>>>;
};

export type AbilityConnectionAction = {
  __typename?: 'AbilityConnectionAction';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AbilityConnectionCreated_At = {
  __typename?: 'AbilityConnectionCreated_at';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AbilityConnectionHouse = {
  __typename?: 'AbilityConnectionHouse';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AbilityConnectionId = {
  __typename?: 'AbilityConnectionId';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AbilityConnectionReason = {
  __typename?: 'AbilityConnectionReason';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AbilityConnectionReceived_Mail = {
  __typename?: 'AbilityConnectionReceived_mail';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AbilityConnectionRole = {
  __typename?: 'AbilityConnectionRole';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AbilityConnectionTargetModelId = {
  __typename?: 'AbilityConnectionTargetModelId';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type AbilityConnectionTargetModelName = {
  __typename?: 'AbilityConnectionTargetModelName';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AbilityConnectionUpdated_At = {
  __typename?: 'AbilityConnectionUpdated_at';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AbilityConnectionUser = {
  __typename?: 'AbilityConnectionUser';
  connection?: Maybe<AbilityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AbilityGroupBy = {
  __typename?: 'AbilityGroupBy';
  action?: Maybe<Array<Maybe<AbilityConnectionAction>>>;
  created_at?: Maybe<Array<Maybe<AbilityConnectionCreated_At>>>;
  house?: Maybe<Array<Maybe<AbilityConnectionHouse>>>;
  id?: Maybe<Array<Maybe<AbilityConnectionId>>>;
  reason?: Maybe<Array<Maybe<AbilityConnectionReason>>>;
  received_mail?: Maybe<Array<Maybe<AbilityConnectionReceived_Mail>>>;
  role?: Maybe<Array<Maybe<AbilityConnectionRole>>>;
  targetModelId?: Maybe<Array<Maybe<AbilityConnectionTargetModelId>>>;
  targetModelName?: Maybe<Array<Maybe<AbilityConnectionTargetModelName>>>;
  updated_at?: Maybe<Array<Maybe<AbilityConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<AbilityConnectionUser>>>;
};

export type AbilityInput = {
  action?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  house?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<Scalars['String']>;
  received_mail?: InputMaybe<Scalars['ID']>;
  role?: InputMaybe<Scalars['ID']>;
  targetModelId: Scalars['Int'];
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type AddEntityCommentInput = {
  content: Scalars['String'];
  targetModelId: Scalars['ID'];
  targetModelName: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  receivedMails?: Maybe<Array<Maybe<SentMail>>>;
  received_mails?: Maybe<Array<Maybe<ReceivedMail>>>;
  street?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  zip?: Maybe<Scalars['String']>;
};


export type AddressReceivedMailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type AddressReceived_MailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type AddressAggregator = {
  __typename?: 'AddressAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AddressConnection = {
  __typename?: 'AddressConnection';
  aggregate?: Maybe<AddressAggregator>;
  groupBy?: Maybe<AddressGroupBy>;
  values?: Maybe<Array<Maybe<Address>>>;
};

export type AddressConnectionCity = {
  __typename?: 'AddressConnectionCity';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AddressConnectionCountry = {
  __typename?: 'AddressConnectionCountry';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AddressConnectionCreated_At = {
  __typename?: 'AddressConnectionCreated_at';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AddressConnectionEmail = {
  __typename?: 'AddressConnectionEmail';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AddressConnectionId = {
  __typename?: 'AddressConnectionId';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AddressConnectionMobile = {
  __typename?: 'AddressConnectionMobile';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AddressConnectionName = {
  __typename?: 'AddressConnectionName';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AddressConnectionPhone = {
  __typename?: 'AddressConnectionPhone';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AddressConnectionStreet = {
  __typename?: 'AddressConnectionStreet';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AddressConnectionUpdated_At = {
  __typename?: 'AddressConnectionUpdated_at';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AddressConnectionZip = {
  __typename?: 'AddressConnectionZip';
  connection?: Maybe<AddressConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AddressGroupBy = {
  __typename?: 'AddressGroupBy';
  city?: Maybe<Array<Maybe<AddressConnectionCity>>>;
  country?: Maybe<Array<Maybe<AddressConnectionCountry>>>;
  created_at?: Maybe<Array<Maybe<AddressConnectionCreated_At>>>;
  email?: Maybe<Array<Maybe<AddressConnectionEmail>>>;
  id?: Maybe<Array<Maybe<AddressConnectionId>>>;
  mobile?: Maybe<Array<Maybe<AddressConnectionMobile>>>;
  name?: Maybe<Array<Maybe<AddressConnectionName>>>;
  phone?: Maybe<Array<Maybe<AddressConnectionPhone>>>;
  street?: Maybe<Array<Maybe<AddressConnectionStreet>>>;
  updated_at?: Maybe<Array<Maybe<AddressConnectionUpdated_At>>>;
  zip?: Maybe<Array<Maybe<AddressConnectionZip>>>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  receivedMails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  received_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  street?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  firstname: Scalars['String'];
  id: Scalars['ID'];
  lastname: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type Announcment = {
  __typename?: 'Announcment';
  content?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  published_at?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type AnnouncmentAggregator = {
  __typename?: 'AnnouncmentAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AnnouncmentConnection = {
  __typename?: 'AnnouncmentConnection';
  aggregate?: Maybe<AnnouncmentAggregator>;
  groupBy?: Maybe<AnnouncmentGroupBy>;
  values?: Maybe<Array<Maybe<Announcment>>>;
};

export type AnnouncmentConnectionContent = {
  __typename?: 'AnnouncmentConnectionContent';
  connection?: Maybe<AnnouncmentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AnnouncmentConnectionCreated_At = {
  __typename?: 'AnnouncmentConnectionCreated_at';
  connection?: Maybe<AnnouncmentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AnnouncmentConnectionId = {
  __typename?: 'AnnouncmentConnectionId';
  connection?: Maybe<AnnouncmentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AnnouncmentConnectionPublished_At = {
  __typename?: 'AnnouncmentConnectionPublished_at';
  connection?: Maybe<AnnouncmentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AnnouncmentConnectionTitle = {
  __typename?: 'AnnouncmentConnectionTitle';
  connection?: Maybe<AnnouncmentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AnnouncmentConnectionUpdated_At = {
  __typename?: 'AnnouncmentConnectionUpdated_at';
  connection?: Maybe<AnnouncmentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AnnouncmentGroupBy = {
  __typename?: 'AnnouncmentGroupBy';
  content?: Maybe<Array<Maybe<AnnouncmentConnectionContent>>>;
  created_at?: Maybe<Array<Maybe<AnnouncmentConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<AnnouncmentConnectionId>>>;
  published_at?: Maybe<Array<Maybe<AnnouncmentConnectionPublished_At>>>;
  title?: Maybe<Array<Maybe<AnnouncmentConnectionTitle>>>;
  updated_at?: Maybe<Array<Maybe<AnnouncmentConnectionUpdated_At>>>;
};

export type AnnouncmentInput = {
  content?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type ApprovalProcess = {
  __typename?: 'ApprovalProcess';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  manager?: Maybe<UsersPermissionsUser>;
  start?: Maybe<Scalars['DateTime']>;
  startOfCurrentPhaseIndex?: Maybe<Scalars['Int']>;
  startedBy?: Maybe<UsersPermissionsUser>;
  status?: Maybe<Enum_Approvalprocess_Status>;
  steps?: Maybe<Array<Maybe<ApprovalStep>>>;
  targetModelId?: Maybe<Scalars['String']>;
  targetModelName?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  waitingOn?: Maybe<UsersPermissionsUser>;
};


export type ApprovalProcessStepsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type ApprovalProcessAggregator = {
  __typename?: 'ApprovalProcessAggregator';
  avg?: Maybe<ApprovalProcessAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<ApprovalProcessAggregatorMax>;
  min?: Maybe<ApprovalProcessAggregatorMin>;
  sum?: Maybe<ApprovalProcessAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ApprovalProcessAggregatorAvg = {
  __typename?: 'ApprovalProcessAggregatorAvg';
  startOfCurrentPhaseIndex?: Maybe<Scalars['Float']>;
};

export type ApprovalProcessAggregatorMax = {
  __typename?: 'ApprovalProcessAggregatorMax';
  startOfCurrentPhaseIndex?: Maybe<Scalars['Float']>;
};

export type ApprovalProcessAggregatorMin = {
  __typename?: 'ApprovalProcessAggregatorMin';
  startOfCurrentPhaseIndex?: Maybe<Scalars['Float']>;
};

export type ApprovalProcessAggregatorSum = {
  __typename?: 'ApprovalProcessAggregatorSum';
  startOfCurrentPhaseIndex?: Maybe<Scalars['Float']>;
};

export type ApprovalProcessConnection = {
  __typename?: 'ApprovalProcessConnection';
  aggregate?: Maybe<ApprovalProcessAggregator>;
  groupBy?: Maybe<ApprovalProcessGroupBy>;
  values?: Maybe<Array<Maybe<ApprovalProcess>>>;
};

export type ApprovalProcessConnectionCreated_At = {
  __typename?: 'ApprovalProcessConnectionCreated_at';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ApprovalProcessConnectionId = {
  __typename?: 'ApprovalProcessConnectionId';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ApprovalProcessConnectionManager = {
  __typename?: 'ApprovalProcessConnectionManager';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ApprovalProcessConnectionStart = {
  __typename?: 'ApprovalProcessConnectionStart';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ApprovalProcessConnectionStartOfCurrentPhaseIndex = {
  __typename?: 'ApprovalProcessConnectionStartOfCurrentPhaseIndex';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type ApprovalProcessConnectionStartedBy = {
  __typename?: 'ApprovalProcessConnectionStartedBy';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ApprovalProcessConnectionStatus = {
  __typename?: 'ApprovalProcessConnectionStatus';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ApprovalProcessConnectionTargetModelId = {
  __typename?: 'ApprovalProcessConnectionTargetModelId';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ApprovalProcessConnectionTargetModelName = {
  __typename?: 'ApprovalProcessConnectionTargetModelName';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ApprovalProcessConnectionUpdated_At = {
  __typename?: 'ApprovalProcessConnectionUpdated_at';
  connection?: Maybe<ApprovalProcessConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ApprovalProcessDisputeResolutionOption = {
  __typename?: 'ApprovalProcessDisputeResolutionOption';
  code?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  targetModelName?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type ApprovalProcessDisputeResolutionOptionAggregator = {
  __typename?: 'ApprovalProcessDisputeResolutionOptionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ApprovalProcessDisputeResolutionOptionConnection = {
  __typename?: 'ApprovalProcessDisputeResolutionOptionConnection';
  aggregate?: Maybe<ApprovalProcessDisputeResolutionOptionAggregator>;
  groupBy?: Maybe<ApprovalProcessDisputeResolutionOptionGroupBy>;
  values?: Maybe<Array<Maybe<ApprovalProcessDisputeResolutionOption>>>;
};

export type ApprovalProcessDisputeResolutionOptionConnectionCode = {
  __typename?: 'ApprovalProcessDisputeResolutionOptionConnectionCode';
  connection?: Maybe<ApprovalProcessDisputeResolutionOptionConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ApprovalProcessDisputeResolutionOptionConnectionCreated_At = {
  __typename?: 'ApprovalProcessDisputeResolutionOptionConnectionCreated_at';
  connection?: Maybe<ApprovalProcessDisputeResolutionOptionConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ApprovalProcessDisputeResolutionOptionConnectionId = {
  __typename?: 'ApprovalProcessDisputeResolutionOptionConnectionId';
  connection?: Maybe<ApprovalProcessDisputeResolutionOptionConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ApprovalProcessDisputeResolutionOptionConnectionName = {
  __typename?: 'ApprovalProcessDisputeResolutionOptionConnectionName';
  connection?: Maybe<ApprovalProcessDisputeResolutionOptionConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ApprovalProcessDisputeResolutionOptionConnectionTargetModelName = {
  __typename?: 'ApprovalProcessDisputeResolutionOptionConnectionTargetModelName';
  connection?: Maybe<ApprovalProcessDisputeResolutionOptionConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ApprovalProcessDisputeResolutionOptionConnectionUpdated_At = {
  __typename?: 'ApprovalProcessDisputeResolutionOptionConnectionUpdated_at';
  connection?: Maybe<ApprovalProcessDisputeResolutionOptionConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ApprovalProcessDisputeResolutionOptionGroupBy = {
  __typename?: 'ApprovalProcessDisputeResolutionOptionGroupBy';
  code?: Maybe<Array<Maybe<ApprovalProcessDisputeResolutionOptionConnectionCode>>>;
  created_at?: Maybe<Array<Maybe<ApprovalProcessDisputeResolutionOptionConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<ApprovalProcessDisputeResolutionOptionConnectionId>>>;
  name?: Maybe<Array<Maybe<ApprovalProcessDisputeResolutionOptionConnectionName>>>;
  targetModelName?: Maybe<Array<Maybe<ApprovalProcessDisputeResolutionOptionConnectionTargetModelName>>>;
  updated_at?: Maybe<Array<Maybe<ApprovalProcessDisputeResolutionOptionConnectionUpdated_At>>>;
};

export type ApprovalProcessDisputeResolutionOptionInput = {
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type ApprovalProcessGroupBy = {
  __typename?: 'ApprovalProcessGroupBy';
  created_at?: Maybe<Array<Maybe<ApprovalProcessConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<ApprovalProcessConnectionId>>>;
  manager?: Maybe<Array<Maybe<ApprovalProcessConnectionManager>>>;
  start?: Maybe<Array<Maybe<ApprovalProcessConnectionStart>>>;
  startOfCurrentPhaseIndex?: Maybe<Array<Maybe<ApprovalProcessConnectionStartOfCurrentPhaseIndex>>>;
  startedBy?: Maybe<Array<Maybe<ApprovalProcessConnectionStartedBy>>>;
  status?: Maybe<Array<Maybe<ApprovalProcessConnectionStatus>>>;
  targetModelId?: Maybe<Array<Maybe<ApprovalProcessConnectionTargetModelId>>>;
  targetModelName?: Maybe<Array<Maybe<ApprovalProcessConnectionTargetModelName>>>;
  updated_at?: Maybe<Array<Maybe<ApprovalProcessConnectionUpdated_At>>>;
};

export type ApprovalProcessInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  manager?: InputMaybe<Scalars['ID']>;
  start?: InputMaybe<Scalars['DateTime']>;
  startOfCurrentPhaseIndex?: InputMaybe<Scalars['Int']>;
  startedBy?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Approvalprocess_Status>;
  steps?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export enum ApprovalProcessSupportedModels {
  Invoice = 'Invoice',
  TestStep = 'TestStep'
}

export type ApprovalProcessUpdateReturn = {
  __typename?: 'ApprovalProcessUpdateReturn';
  approval_process?: Maybe<ApprovalProcess>;
};

export type ApprovalStep = {
  __typename?: 'ApprovalStep';
  approval_process?: Maybe<ApprovalProcess>;
  at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  data?: Maybe<Array<Maybe<ApprovalStepDataDynamicZone>>>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  next?: Maybe<ApprovalStep>;
  note?: Maybe<Scalars['String']>;
  previous?: Maybe<ApprovalStep>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
};

export type ApprovalStepAggregator = {
  __typename?: 'ApprovalStepAggregator';
  avg?: Maybe<ApprovalStepAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<ApprovalStepAggregatorMax>;
  min?: Maybe<ApprovalStepAggregatorMin>;
  sum?: Maybe<ApprovalStepAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ApprovalStepAggregatorAvg = {
  __typename?: 'ApprovalStepAggregatorAvg';
  index?: Maybe<Scalars['Float']>;
};

export type ApprovalStepAggregatorMax = {
  __typename?: 'ApprovalStepAggregatorMax';
  index?: Maybe<Scalars['Float']>;
};

export type ApprovalStepAggregatorMin = {
  __typename?: 'ApprovalStepAggregatorMin';
  index?: Maybe<Scalars['Float']>;
};

export type ApprovalStepAggregatorSum = {
  __typename?: 'ApprovalStepAggregatorSum';
  index?: Maybe<Scalars['Float']>;
};

export type ApprovalStepConnection = {
  __typename?: 'ApprovalStepConnection';
  aggregate?: Maybe<ApprovalStepAggregator>;
  groupBy?: Maybe<ApprovalStepGroupBy>;
  values?: Maybe<Array<Maybe<ApprovalStep>>>;
};

export type ApprovalStepConnectionApproval_Process = {
  __typename?: 'ApprovalStepConnectionApproval_process';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ApprovalStepConnectionAt = {
  __typename?: 'ApprovalStepConnectionAt';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ApprovalStepConnectionCreated_At = {
  __typename?: 'ApprovalStepConnectionCreated_at';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ApprovalStepConnectionId = {
  __typename?: 'ApprovalStepConnectionId';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ApprovalStepConnectionIndex = {
  __typename?: 'ApprovalStepConnectionIndex';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type ApprovalStepConnectionNext = {
  __typename?: 'ApprovalStepConnectionNext';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ApprovalStepConnectionNote = {
  __typename?: 'ApprovalStepConnectionNote';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ApprovalStepConnectionPrevious = {
  __typename?: 'ApprovalStepConnectionPrevious';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ApprovalStepConnectionPublished_At = {
  __typename?: 'ApprovalStepConnectionPublished_at';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ApprovalStepConnectionUpdated_At = {
  __typename?: 'ApprovalStepConnectionUpdated_at';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ApprovalStepConnectionUser = {
  __typename?: 'ApprovalStepConnectionUser';
  connection?: Maybe<ApprovalStepConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ApprovalStepDataDynamicZone = ComponentApprovalProcessApprovalProcessControlStep | ComponentApprovalProcessDisputeResolutionStep | ComponentApprovalProcessInformStep;

export enum ApprovalStepDecisionOption {
  Approve = 'approve',
  Reject = 'reject'
}

export type ApprovalStepGroupBy = {
  __typename?: 'ApprovalStepGroupBy';
  approval_process?: Maybe<Array<Maybe<ApprovalStepConnectionApproval_Process>>>;
  at?: Maybe<Array<Maybe<ApprovalStepConnectionAt>>>;
  created_at?: Maybe<Array<Maybe<ApprovalStepConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<ApprovalStepConnectionId>>>;
  index?: Maybe<Array<Maybe<ApprovalStepConnectionIndex>>>;
  next?: Maybe<Array<Maybe<ApprovalStepConnectionNext>>>;
  note?: Maybe<Array<Maybe<ApprovalStepConnectionNote>>>;
  previous?: Maybe<Array<Maybe<ApprovalStepConnectionPrevious>>>;
  published_at?: Maybe<Array<Maybe<ApprovalStepConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<ApprovalStepConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<ApprovalStepConnectionUser>>>;
};

export type ApprovalStepInput = {
  approval_process?: InputMaybe<Scalars['ID']>;
  at?: InputMaybe<Scalars['DateTime']>;
  created_by?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<Array<Scalars['ApprovalStepDataDynamicZoneInput']>>;
  index?: InputMaybe<Scalars['Int']>;
  next?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ApproveOrRejectApprovalStepInput = {
  decision: ApprovalStepDecisionOption;
  id: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type AuditLogRecord = {
  __typename?: 'AuditLogRecord';
  action?: Maybe<Scalars['String']>;
  child_records?: Maybe<Array<Maybe<AuditLogRecord>>>;
  created_at: Scalars['DateTime'];
  difference?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  latitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  longitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  newData?: Maybe<Scalars['JSON']>;
  operatingSystemOfInitiatingDevice?: Maybe<Scalars['String']>;
  parent_record?: Maybe<AuditLogRecord>;
  previousData?: Maybe<Scalars['JSON']>;
  targetModelId?: Maybe<Scalars['Int']>;
  targetModelName?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
};


export type AuditLogRecordChild_RecordsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type AuditLogRecordAggregator = {
  __typename?: 'AuditLogRecordAggregator';
  avg?: Maybe<AuditLogRecordAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AuditLogRecordAggregatorMax>;
  min?: Maybe<AuditLogRecordAggregatorMin>;
  sum?: Maybe<AuditLogRecordAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AuditLogRecordAggregatorAvg = {
  __typename?: 'AuditLogRecordAggregatorAvg';
  latitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  longitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  targetModelId?: Maybe<Scalars['Float']>;
};

export type AuditLogRecordAggregatorMax = {
  __typename?: 'AuditLogRecordAggregatorMax';
  latitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  longitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  targetModelId?: Maybe<Scalars['Float']>;
};

export type AuditLogRecordAggregatorMin = {
  __typename?: 'AuditLogRecordAggregatorMin';
  latitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  longitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  targetModelId?: Maybe<Scalars['Float']>;
};

export type AuditLogRecordAggregatorSum = {
  __typename?: 'AuditLogRecordAggregatorSum';
  latitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  longitudeOfInitiatingDevice?: Maybe<Scalars['Float']>;
  targetModelId?: Maybe<Scalars['Float']>;
};

export type AuditLogRecordConnection = {
  __typename?: 'AuditLogRecordConnection';
  aggregate?: Maybe<AuditLogRecordAggregator>;
  groupBy?: Maybe<AuditLogRecordGroupBy>;
  values?: Maybe<Array<Maybe<AuditLogRecord>>>;
};

export type AuditLogRecordConnectionAction = {
  __typename?: 'AuditLogRecordConnectionAction';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AuditLogRecordConnectionCreated_At = {
  __typename?: 'AuditLogRecordConnectionCreated_at';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AuditLogRecordConnectionDifference = {
  __typename?: 'AuditLogRecordConnectionDifference';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type AuditLogRecordConnectionId = {
  __typename?: 'AuditLogRecordConnectionId';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AuditLogRecordConnectionLatitudeOfInitiatingDevice = {
  __typename?: 'AuditLogRecordConnectionLatitudeOfInitiatingDevice';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type AuditLogRecordConnectionLongitudeOfInitiatingDevice = {
  __typename?: 'AuditLogRecordConnectionLongitudeOfInitiatingDevice';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type AuditLogRecordConnectionNewData = {
  __typename?: 'AuditLogRecordConnectionNewData';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type AuditLogRecordConnectionOperatingSystemOfInitiatingDevice = {
  __typename?: 'AuditLogRecordConnectionOperatingSystemOfInitiatingDevice';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AuditLogRecordConnectionParent_Record = {
  __typename?: 'AuditLogRecordConnectionParent_record';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AuditLogRecordConnectionPreviousData = {
  __typename?: 'AuditLogRecordConnectionPreviousData';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type AuditLogRecordConnectionTargetModelId = {
  __typename?: 'AuditLogRecordConnectionTargetModelId';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type AuditLogRecordConnectionTargetModelName = {
  __typename?: 'AuditLogRecordConnectionTargetModelName';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AuditLogRecordConnectionTimestamp = {
  __typename?: 'AuditLogRecordConnectionTimestamp';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AuditLogRecordConnectionUpdated_At = {
  __typename?: 'AuditLogRecordConnectionUpdated_at';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AuditLogRecordConnectionUser = {
  __typename?: 'AuditLogRecordConnectionUser';
  connection?: Maybe<AuditLogRecordConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AuditLogRecordGroupBy = {
  __typename?: 'AuditLogRecordGroupBy';
  action?: Maybe<Array<Maybe<AuditLogRecordConnectionAction>>>;
  created_at?: Maybe<Array<Maybe<AuditLogRecordConnectionCreated_At>>>;
  difference?: Maybe<Array<Maybe<AuditLogRecordConnectionDifference>>>;
  id?: Maybe<Array<Maybe<AuditLogRecordConnectionId>>>;
  latitudeOfInitiatingDevice?: Maybe<Array<Maybe<AuditLogRecordConnectionLatitudeOfInitiatingDevice>>>;
  longitudeOfInitiatingDevice?: Maybe<Array<Maybe<AuditLogRecordConnectionLongitudeOfInitiatingDevice>>>;
  newData?: Maybe<Array<Maybe<AuditLogRecordConnectionNewData>>>;
  operatingSystemOfInitiatingDevice?: Maybe<Array<Maybe<AuditLogRecordConnectionOperatingSystemOfInitiatingDevice>>>;
  parent_record?: Maybe<Array<Maybe<AuditLogRecordConnectionParent_Record>>>;
  previousData?: Maybe<Array<Maybe<AuditLogRecordConnectionPreviousData>>>;
  targetModelId?: Maybe<Array<Maybe<AuditLogRecordConnectionTargetModelId>>>;
  targetModelName?: Maybe<Array<Maybe<AuditLogRecordConnectionTargetModelName>>>;
  timestamp?: Maybe<Array<Maybe<AuditLogRecordConnectionTimestamp>>>;
  updated_at?: Maybe<Array<Maybe<AuditLogRecordConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<AuditLogRecordConnectionUser>>>;
};

export type AuditLogRecordInput = {
  action?: InputMaybe<Scalars['String']>;
  child_records?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  difference?: InputMaybe<Scalars['JSON']>;
  latitudeOfInitiatingDevice?: InputMaybe<Scalars['Float']>;
  longitudeOfInitiatingDevice?: InputMaybe<Scalars['Float']>;
  newData?: InputMaybe<Scalars['JSON']>;
  operatingSystemOfInitiatingDevice?: InputMaybe<Scalars['String']>;
  parent_record?: InputMaybe<Scalars['ID']>;
  previousData?: InputMaybe<Scalars['JSON']>;
  targetModelId?: InputMaybe<Scalars['Int']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type BuseventInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  emitted?: InputMaybe<Scalars['DateTime']>;
  eventType?: InputMaybe<Enum_Eventbusbusevent_Eventtype>;
  genesis?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  payload: Scalars['JSON'];
  traceId?: InputMaybe<Scalars['String']>;
  uid: Scalars['String'];
  updated_by?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type City = {
  __typename?: 'City';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type CityAggregator = {
  __typename?: 'CityAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CityConnection = {
  __typename?: 'CityConnection';
  aggregate?: Maybe<CityAggregator>;
  groupBy?: Maybe<CityGroupBy>;
  values?: Maybe<Array<Maybe<City>>>;
};

export type CityConnectionCreated_At = {
  __typename?: 'CityConnectionCreated_at';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CityConnectionId = {
  __typename?: 'CityConnectionId';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CityConnectionName = {
  __typename?: 'CityConnectionName';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CityConnectionUpdated_At = {
  __typename?: 'CityConnectionUpdated_at';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CityGroupBy = {
  __typename?: 'CityGroupBy';
  created_at?: Maybe<Array<Maybe<CityConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<CityConnectionId>>>;
  name?: Maybe<Array<Maybe<CityConnectionName>>>;
  updated_at?: Maybe<Array<Maybe<CityConnectionUpdated_At>>>;
};

export type CityInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type Comment = {
  __typename?: 'Comment';
  author?: Maybe<UsersPermissionsUser>;
  content?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  isSubcomment?: Maybe<Scalars['Boolean']>;
  parentComment?: Maybe<Comment>;
  subcomments?: Maybe<Array<Maybe<Comment>>>;
  targetModelId?: Maybe<Scalars['String']>;
  targetModelName?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};


export type CommentSubcommentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type CommentAggregator = {
  __typename?: 'CommentAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  aggregate?: Maybe<CommentAggregator>;
  groupBy?: Maybe<CommentGroupBy>;
  values?: Maybe<Array<Maybe<Comment>>>;
};

export type CommentConnectionAuthor = {
  __typename?: 'CommentConnectionAuthor';
  connection?: Maybe<CommentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CommentConnectionContent = {
  __typename?: 'CommentConnectionContent';
  connection?: Maybe<CommentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CommentConnectionCreated_At = {
  __typename?: 'CommentConnectionCreated_at';
  connection?: Maybe<CommentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CommentConnectionId = {
  __typename?: 'CommentConnectionId';
  connection?: Maybe<CommentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CommentConnectionIsSubcomment = {
  __typename?: 'CommentConnectionIsSubcomment';
  connection?: Maybe<CommentConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type CommentConnectionParentComment = {
  __typename?: 'CommentConnectionParentComment';
  connection?: Maybe<CommentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CommentConnectionTargetModelId = {
  __typename?: 'CommentConnectionTargetModelId';
  connection?: Maybe<CommentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CommentConnectionTargetModelName = {
  __typename?: 'CommentConnectionTargetModelName';
  connection?: Maybe<CommentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CommentConnectionUpdated_At = {
  __typename?: 'CommentConnectionUpdated_at';
  connection?: Maybe<CommentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CommentGroupBy = {
  __typename?: 'CommentGroupBy';
  author?: Maybe<Array<Maybe<CommentConnectionAuthor>>>;
  content?: Maybe<Array<Maybe<CommentConnectionContent>>>;
  created_at?: Maybe<Array<Maybe<CommentConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<CommentConnectionId>>>;
  isSubcomment?: Maybe<Array<Maybe<CommentConnectionIsSubcomment>>>;
  parentComment?: Maybe<Array<Maybe<CommentConnectionParentComment>>>;
  targetModelId?: Maybe<Array<Maybe<CommentConnectionTargetModelId>>>;
  targetModelName?: Maybe<Array<Maybe<CommentConnectionTargetModelName>>>;
  updated_at?: Maybe<Array<Maybe<CommentConnectionUpdated_At>>>;
};

export type CommentInput = {
  author?: InputMaybe<Scalars['ID']>;
  content?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  isSubcomment?: InputMaybe<Scalars['Boolean']>;
  parentComment?: InputMaybe<Scalars['ID']>;
  subcomments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type CompanyModule = {
  __typename?: 'CompanyModule';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};

export type CompanyModuleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type CompanyPartner = {
  __typename?: 'CompanyPartner';
  addresses?: Maybe<Array<Maybe<Address>>>;
  archived?: Maybe<Scalars['Boolean']>;
  bankCode?: Maybe<Scalars['String']>;
  businessId?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Maybe<SharedContactPerson>>>;
  created_at: Scalars['DateTime'];
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  name?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<Project>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  receivedMailSentTo?: Maybe<Array<Maybe<SentMail>>>;
  sentMail?: Maybe<Array<Maybe<ReceivedMail>>>;
  taxId?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  vatId?: Maybe<Scalars['String']>;
};


export type CompanyPartnerAddressesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type CompanyPartnerContactsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type CompanyPartnerInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type CompanyPartnerProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type CompanyPartnerReceivedMailSentToArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type CompanyPartnerSentMailArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type CompanyPartnerAggregator = {
  __typename?: 'CompanyPartnerAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CompanyPartnerConnection = {
  __typename?: 'CompanyPartnerConnection';
  aggregate?: Maybe<CompanyPartnerAggregator>;
  groupBy?: Maybe<CompanyPartnerGroupBy>;
  values?: Maybe<Array<Maybe<CompanyPartner>>>;
};

export type CompanyPartnerConnectionArchived = {
  __typename?: 'CompanyPartnerConnectionArchived';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type CompanyPartnerConnectionBankCode = {
  __typename?: 'CompanyPartnerConnectionBankCode';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CompanyPartnerConnectionBusinessId = {
  __typename?: 'CompanyPartnerConnectionBusinessId';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CompanyPartnerConnectionCreated_At = {
  __typename?: 'CompanyPartnerConnectionCreated_at';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CompanyPartnerConnectionIban = {
  __typename?: 'CompanyPartnerConnectionIban';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CompanyPartnerConnectionId = {
  __typename?: 'CompanyPartnerConnectionId';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CompanyPartnerConnectionName = {
  __typename?: 'CompanyPartnerConnectionName';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CompanyPartnerConnectionPublished_At = {
  __typename?: 'CompanyPartnerConnectionPublished_at';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CompanyPartnerConnectionTaxId = {
  __typename?: 'CompanyPartnerConnectionTaxId';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CompanyPartnerConnectionUpdated_At = {
  __typename?: 'CompanyPartnerConnectionUpdated_at';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CompanyPartnerConnectionVatId = {
  __typename?: 'CompanyPartnerConnectionVatId';
  connection?: Maybe<CompanyPartnerConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CompanyPartnerGroupBy = {
  __typename?: 'CompanyPartnerGroupBy';
  archived?: Maybe<Array<Maybe<CompanyPartnerConnectionArchived>>>;
  bankCode?: Maybe<Array<Maybe<CompanyPartnerConnectionBankCode>>>;
  businessId?: Maybe<Array<Maybe<CompanyPartnerConnectionBusinessId>>>;
  created_at?: Maybe<Array<Maybe<CompanyPartnerConnectionCreated_At>>>;
  iban?: Maybe<Array<Maybe<CompanyPartnerConnectionIban>>>;
  id?: Maybe<Array<Maybe<CompanyPartnerConnectionId>>>;
  name?: Maybe<Array<Maybe<CompanyPartnerConnectionName>>>;
  published_at?: Maybe<Array<Maybe<CompanyPartnerConnectionPublished_At>>>;
  taxId?: Maybe<Array<Maybe<CompanyPartnerConnectionTaxId>>>;
  updated_at?: Maybe<Array<Maybe<CompanyPartnerConnectionUpdated_At>>>;
  vatId?: Maybe<Array<Maybe<CompanyPartnerConnectionVatId>>>;
};

export type CompanyPartnerInput = {
  addresses?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  bankCode?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  iban?: InputMaybe<Scalars['String']>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  receivedMailSentTo?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sentMail?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  taxId?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vatId?: InputMaybe<Scalars['String']>;
};

export type ComponentApprovalProcessApprovalProcessControlStep = {
  __typename?: 'ComponentApprovalProcessApprovalProcessControlStep';
  controlType?: Maybe<Enum_Componentapprovalprocessapprovalprocesscontrolstep_Controltype>;
  decisionReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  reasonRequired?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Componentapprovalprocessapprovalprocesscontrolstep_Status>;
};

export type ComponentApprovalProcessApprovalProcessControlStepInput = {
  controlType?: InputMaybe<Enum_Componentapprovalprocessapprovalprocesscontrolstep_Controltype>;
  decisionReason?: InputMaybe<Scalars['String']>;
  reasonRequired?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Enum_Componentapprovalprocessapprovalprocesscontrolstep_Status>;
};

export type ComponentApprovalProcessApprovalProcessDisputeResolutionStep = {
  __typename?: 'ComponentApprovalProcessApprovalProcessDisputeResolutionStep';
  id: Scalars['ID'];
  resolution?: Maybe<ApprovalProcessDisputeResolutionOption>;
  status?: Maybe<Enum_Componentapprovalprocessapprovalprocessdisputeresolutionstep_Status>;
};

export type ComponentApprovalProcessApprovalProcessDisputeResolutionStepInput = {
  resolution?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Componentapprovalprocessapprovalprocessdisputeresolutionstep_Status>;
};

export type ComponentApprovalProcessDisputeResolutionStep = {
  __typename?: 'ComponentApprovalProcessDisputeResolutionStep';
  id: Scalars['ID'];
  reinitializeApprovalProcess?: Maybe<Scalars['Boolean']>;
  resolution?: Maybe<ApprovalProcessDisputeResolutionOption>;
  status?: Maybe<Enum_Componentapprovalprocessdisputeresolutionstep_Status>;
};

export type ComponentApprovalProcessDisputeResolutionStepInput = {
  reinitializeApprovalProcess?: InputMaybe<Scalars['Boolean']>;
  resolution?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Componentapprovalprocessdisputeresolutionstep_Status>;
};

export type ComponentApprovalProcessInformStep = {
  __typename?: 'ComponentApprovalProcessInformStep';
  id: Scalars['ID'];
  meta?: Maybe<Scalars['JSON']>;
  type?: Maybe<Enum_Componentapprovalprocessinformstep_Type>;
};

export type ComponentApprovalProcessInformStepInput = {
  meta?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<Enum_Componentapprovalprocessinformstep_Type>;
};

export type ComponentNotificationTagInput = {
  label?: InputMaybe<Scalars['String']>;
};

export type ComponentNotificationTags = {
  __typename?: 'ComponentNotificationTags';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
};

export type ComponentSharedHouseAbility = {
  __typename?: 'ComponentSharedHouseAbility';
  house?: Maybe<House>;
  id: Scalars['ID'];
};

export type ComponentSharedHouseAbilityInput = {
  house?: InputMaybe<Scalars['ID']>;
};

export type ComponentTravelLogDateInput = {
  date?: InputMaybe<Scalars['Date']>;
};

export type ComponentTravelLogDates = {
  __typename?: 'ComponentTravelLogDates';
  date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
};

export type ComponentTravelLogDestinationTravelLimit = {
  __typename?: 'ComponentTravelLogDestinationTravelLimit';
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  place?: Maybe<TravelLogPlace>;
};

export type ComponentTravelLogDestinationTravelLimitInput = {
  limit?: InputMaybe<Scalars['Int']>;
  place?: InputMaybe<Scalars['ID']>;
};

export type ComponentTravelLogRouteInput = {
  maxUseLimit?: InputMaybe<Scalars['Int']>;
  route?: InputMaybe<Scalars['ID']>;
};

export type ComponentTravelLogRoutes = {
  __typename?: 'ComponentTravelLogRoutes';
  id: Scalars['ID'];
  maxUseLimit?: Maybe<Scalars['Int']>;
  route?: Maybe<TravelLogRoute>;
};

export type ComponentTravelLogTravelLogLeg = {
  __typename?: 'ComponentTravelLogTravelLogLeg';
  date?: Maybe<Scalars['Date']>;
  distance?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['String']>;
  finish?: Maybe<TravelLogPlace>;
  finishTime?: Maybe<Scalars['Time']>;
  id: Scalars['ID'];
  journeyUuid?: Maybe<Scalars['String']>;
  reason?: Maybe<TravelLogUserJourneyReason>;
  start?: Maybe<TravelLogPlace>;
  startTime?: Maybe<Scalars['Time']>;
  travelCompensation?: Maybe<Scalars['Float']>;
  workFinishTime?: Maybe<Scalars['Time']>;
  workStartTime?: Maybe<Scalars['Time']>;
};

export type ComponentTravelLogTravelLogLegInput = {
  date?: InputMaybe<Scalars['Date']>;
  distance?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['String']>;
  finish?: InputMaybe<Scalars['ID']>;
  finishTime?: InputMaybe<Scalars['Time']>;
  journeyUuid?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['ID']>;
  start?: InputMaybe<Scalars['ID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  travelCompensation?: InputMaybe<Scalars['Float']>;
  workFinishTime?: InputMaybe<Scalars['Time']>;
  workStartTime?: InputMaybe<Scalars['Time']>;
};

export type ComponentTravelLogTravelLogRouteLegInput = {
  distance?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['ID']>;
  to?: InputMaybe<Scalars['ID']>;
};

export type ComponentTravelLogTravelLogRouteLegs = {
  __typename?: 'ComponentTravelLogTravelLogRouteLegs';
  distance?: Maybe<TravelLogPlacesDistance>;
  from?: Maybe<TravelLogPlace>;
  id: Scalars['ID'];
  to?: Maybe<TravelLogPlace>;
};

export type CreateVehicleRouteInput = {
  address?: InputMaybe<Scalars['String']>;
  balancing?: InputMaybe<Scalars['Boolean']>;
  cityCode?: InputMaybe<Scalars['String']>;
  defaultMonthLimit: Scalars['Int'];
  destinationName?: InputMaybe<Scalars['String']>;
  existingDestination?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  vehicle: Scalars['ID'];
  workDurationFrom: Scalars['Float'];
  workDurationTo: Scalars['Float'];
};

export type CreatedBy = {
  __typename?: 'CreatedBy';
  blocked?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  preferedLanguage?: Maybe<Scalars['String']>;
  registrationToken?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type Department = {
  __typename?: 'Department';
  administrators?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  created_at: Scalars['DateTime'];
  employees?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  financialDecisionMaker?: Maybe<UsersPermissionsUser>;
  head?: Maybe<UsersPermissionsUser>;
  head_assistant?: Maybe<UsersPermissionsUser>;
  id: Scalars['ID'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  maxInvoiceSumAllowedForDepartmentManager?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<Project>>>;
  received_mails?: Maybe<Array<Maybe<ReceivedMail>>>;
  updated_at: Scalars['DateTime'];
};


export type DepartmentAdministratorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type DepartmentEmployeesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type DepartmentInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type DepartmentProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type DepartmentReceived_MailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type DepartmentAggregator = {
  __typename?: 'DepartmentAggregator';
  avg?: Maybe<DepartmentAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<DepartmentAggregatorMax>;
  min?: Maybe<DepartmentAggregatorMin>;
  sum?: Maybe<DepartmentAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DepartmentAggregatorAvg = {
  __typename?: 'DepartmentAggregatorAvg';
  maxInvoiceSumAllowedForDepartmentManager?: Maybe<Scalars['Float']>;
};

export type DepartmentAggregatorMax = {
  __typename?: 'DepartmentAggregatorMax';
  maxInvoiceSumAllowedForDepartmentManager?: Maybe<Scalars['Float']>;
};

export type DepartmentAggregatorMin = {
  __typename?: 'DepartmentAggregatorMin';
  maxInvoiceSumAllowedForDepartmentManager?: Maybe<Scalars['Float']>;
};

export type DepartmentAggregatorSum = {
  __typename?: 'DepartmentAggregatorSum';
  maxInvoiceSumAllowedForDepartmentManager?: Maybe<Scalars['Float']>;
};

export type DepartmentConnection = {
  __typename?: 'DepartmentConnection';
  aggregate?: Maybe<DepartmentAggregator>;
  groupBy?: Maybe<DepartmentGroupBy>;
  values?: Maybe<Array<Maybe<Department>>>;
};

export type DepartmentConnectionCreated_At = {
  __typename?: 'DepartmentConnectionCreated_at';
  connection?: Maybe<DepartmentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type DepartmentConnectionFinancialDecisionMaker = {
  __typename?: 'DepartmentConnectionFinancialDecisionMaker';
  connection?: Maybe<DepartmentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type DepartmentConnectionHead = {
  __typename?: 'DepartmentConnectionHead';
  connection?: Maybe<DepartmentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type DepartmentConnectionHead_Assistant = {
  __typename?: 'DepartmentConnectionHead_assistant';
  connection?: Maybe<DepartmentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type DepartmentConnectionId = {
  __typename?: 'DepartmentConnectionId';
  connection?: Maybe<DepartmentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type DepartmentConnectionMaxInvoiceSumAllowedForDepartmentManager = {
  __typename?: 'DepartmentConnectionMaxInvoiceSumAllowedForDepartmentManager';
  connection?: Maybe<DepartmentConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type DepartmentConnectionName = {
  __typename?: 'DepartmentConnectionName';
  connection?: Maybe<DepartmentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type DepartmentConnectionUpdated_At = {
  __typename?: 'DepartmentConnectionUpdated_at';
  connection?: Maybe<DepartmentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type DepartmentGroupBy = {
  __typename?: 'DepartmentGroupBy';
  created_at?: Maybe<Array<Maybe<DepartmentConnectionCreated_At>>>;
  financialDecisionMaker?: Maybe<Array<Maybe<DepartmentConnectionFinancialDecisionMaker>>>;
  head?: Maybe<Array<Maybe<DepartmentConnectionHead>>>;
  head_assistant?: Maybe<Array<Maybe<DepartmentConnectionHead_Assistant>>>;
  id?: Maybe<Array<Maybe<DepartmentConnectionId>>>;
  maxInvoiceSumAllowedForDepartmentManager?: Maybe<Array<Maybe<DepartmentConnectionMaxInvoiceSumAllowedForDepartmentManager>>>;
  name?: Maybe<Array<Maybe<DepartmentConnectionName>>>;
  updated_at?: Maybe<Array<Maybe<DepartmentConnectionUpdated_At>>>;
};

export type DepartmentInput = {
  administrators?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  financialDecisionMaker?: InputMaybe<Scalars['ID']>;
  head?: InputMaybe<Scalars['ID']>;
  head_assistant?: InputMaybe<Scalars['ID']>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  maxInvoiceSumAllowedForDepartmentManager?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  received_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type Distances = {
  __typename?: 'Distances';
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  distanceInKm?: Maybe<Scalars['Float']>;
  durationInSeconds?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
};

export type DropboxFolderItem = {
  __typename?: 'DropboxFolderItem';
  client_modified?: Maybe<Scalars['String']>;
  content_hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  is_downloadable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parent_shared_folder_id?: Maybe<Scalars['String']>;
  path_display?: Maybe<Scalars['String']>;
  path_lower?: Maybe<Scalars['String']>;
  rev?: Maybe<Scalars['String']>;
  server_modified?: Maybe<Scalars['String']>;
  sharing_info?: Maybe<SharingInfo>;
  size?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
};

export type DropboxListFolderFilesInput = {
  path: Scalars['String'];
};

export type DropboxUploadInput = {
  key?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
};

export enum Enum_Approvalprocess_Status {
  DisputeResolution = 'disputeResolution',
  Finished = 'finished',
  FinishedRejected = 'finishedRejected',
  InProgress = 'inProgress',
  NotStarted = 'notStarted'
}

export enum Enum_Componentapprovalprocessapprovalprocesscontrolstep_Controltype {
  DepartmentFinancialDecisionMakerControl = 'departmentFinancialDecisionMakerControl',
  DepartmentHeadControl = 'departmentHeadControl',
  FormalControl = 'formalControl',
  ProjectManagerControl = 'projectManagerControl'
}

export enum Enum_Componentapprovalprocessapprovalprocesscontrolstep_Status {
  Activated = 'activated',
  Approved = 'approved',
  Queued = 'queued',
  Rejected = 'rejected'
}

export enum Enum_Componentapprovalprocessapprovalprocessdisputeresolutionstep_Status {
  Pending = 'pending',
  Resolved = 'resolved'
}

export enum Enum_Componentapprovalprocessdisputeresolutionstep_Status {
  Pending = 'pending',
  Resolved = 'resolved'
}

export enum Enum_Componentapprovalprocessinformstep_Type {
  DocumentApproved = 'documentApproved',
  DocumentRejected = 'documentRejected',
  DocumentUploadedToDropbox = 'documentUploadedToDropbox'
}

export enum Enum_Eventbusbusevent_Eventtype {
  Command = 'command',
  Event = 'event'
}

export enum Enum_Event_Eventtype {
  Command = 'command',
  Event = 'event'
}

export enum Enum_House_Enum {
  One = 'one',
  Three = 'three',
  Two = 'two'
}

export enum Enum_Invoicereadmodel_Approvalprocesscurrentsteptype {
  ApprovalProcessControlStep = 'approval_process_control_step',
  DisputeResolutionStep = 'dispute_resolution_step',
  InformStep = 'inform_step'
}

export enum Enum_Invoicereadmodel_Approvalprocessstatus {
  DisputeResolution = 'disputeResolution',
  Finished = 'finished',
  FinishedRejected = 'finishedRejected',
  InProgress = 'inProgress',
  NotStarted = 'notStarted'
}

export enum Enum_Invoicereadmodel_Status {
  Idle = 'idle',
  Locked = 'locked'
}

export enum Enum_Invoicereadmodel_Type {
  Advance = 'advance',
  Regular = 'regular'
}

export enum Enum_Invoice_Status {
  Idle = 'idle',
  Locked = 'locked'
}

export enum Enum_Invoice_Type {
  Advance = 'advance',
  Regular = 'regular'
}

export enum Enum_Notification_Type {
  AddedToDocumentWatchList = 'addedToDocumentWatchList',
  CommentAdded = 'commentAdded',
  EmailAssigned = 'emailAssigned',
  InvoiceApprovalRequired = 'invoiceApprovalRequired',
  MentionedInComment = 'mentionedInComment'
}

export enum Enum_Receivedmail_Contents {
  AdvanceInvoice = 'advanceInvoice',
  BankStatement = 'bankStatement',
  Insurance = 'insurance',
  Invoice = 'invoice',
  Missive = 'missive',
  Other = 'other',
  PaymentDemandNote = 'paymentDemandNote'
}

export enum Enum_Receivedmail_Status {
  Done = 'done',
  InProgress = 'inProgress',
  Open = 'open'
}

export enum Enum_Receivedmail_Typeofdelivery {
  Email = 'email',
  InPerson = 'inPerson',
  Mail = 'mail'
}

export enum Enum_Sentmail_Contents {
  AdvanceInvoice = 'advanceInvoice',
  BankStatement = 'bankStatement',
  Insurance = 'insurance',
  Invoice = 'invoice',
  Missive = 'missive',
  Other = 'other',
  PaymentDemandNote = 'paymentDemandNote'
}

export type Event = {
  __typename?: 'Event';
  created_at: Scalars['DateTime'];
  emitted?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<Enum_Event_Eventtype>;
  id: Scalars['ID'];
  payload: Scalars['JSON'];
  traceId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  uid: Scalars['String'];
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
};

export type EventAggregator = {
  __typename?: 'EventAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EventBusBusevent = {
  __typename?: 'EventBusBusevent';
  created_at: Scalars['DateTime'];
  emitted?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<Enum_Eventbusbusevent_Eventtype>;
  genesis?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  payload: Scalars['JSON'];
  traceId?: Maybe<Scalars['String']>;
  uid: Scalars['String'];
  updated_at: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type EventConnection = {
  __typename?: 'EventConnection';
  aggregate?: Maybe<EventAggregator>;
  groupBy?: Maybe<EventGroupBy>;
  values?: Maybe<Array<Maybe<Event>>>;
};

export type EventConnectionCreated_At = {
  __typename?: 'EventConnectionCreated_at';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type EventConnectionEmitted = {
  __typename?: 'EventConnectionEmitted';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type EventConnectionEventType = {
  __typename?: 'EventConnectionEventType';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['String']>;
};

export type EventConnectionId = {
  __typename?: 'EventConnectionId';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type EventConnectionPayload = {
  __typename?: 'EventConnectionPayload';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type EventConnectionTraceId = {
  __typename?: 'EventConnectionTraceId';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['String']>;
};

export type EventConnectionType = {
  __typename?: 'EventConnectionType';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['String']>;
};

export type EventConnectionUid = {
  __typename?: 'EventConnectionUid';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['String']>;
};

export type EventConnectionUpdated_At = {
  __typename?: 'EventConnectionUpdated_at';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type EventConnectionUser = {
  __typename?: 'EventConnectionUser';
  connection?: Maybe<EventConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type EventGroupBy = {
  __typename?: 'EventGroupBy';
  created_at?: Maybe<Array<Maybe<EventConnectionCreated_At>>>;
  emitted?: Maybe<Array<Maybe<EventConnectionEmitted>>>;
  eventType?: Maybe<Array<Maybe<EventConnectionEventType>>>;
  id?: Maybe<Array<Maybe<EventConnectionId>>>;
  payload?: Maybe<Array<Maybe<EventConnectionPayload>>>;
  traceId?: Maybe<Array<Maybe<EventConnectionTraceId>>>;
  type?: Maybe<Array<Maybe<EventConnectionType>>>;
  uid?: Maybe<Array<Maybe<EventConnectionUid>>>;
  updated_at?: Maybe<Array<Maybe<EventConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<EventConnectionUser>>>;
};

export type EventInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  emitted?: InputMaybe<Scalars['DateTime']>;
  eventType?: InputMaybe<Enum_Event_Eventtype>;
  payload: Scalars['JSON'];
  traceId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  uid: Scalars['String'];
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  ext?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: InputMaybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: InputMaybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  related?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  size: Scalars['Float'];
  updated_by?: InputMaybe<Scalars['ID']>;
  url: Scalars['String'];
  width?: InputMaybe<Scalars['Int']>;
};

export type Finish = {
  __typename?: 'Finish';
  address?: Maybe<Scalars['String']>;
  cityCode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  maxInCityTravel?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['Int']>;
};

export type GenerateTravelLogLogInput = {
  blacklistedDates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  destinationLimits?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  forMonth: Scalars['String'];
  priceOfFuelPerLiter: Scalars['Float'];
  privateVehicleId: Scalars['ID'];
  routes?: InputMaybe<Array<InputMaybe<GenerateTravelLogRouteInput>>>;
  targetCompensation: Scalars['Float'];
};

export type GenerateTravelLogLogReturn = {
  __typename?: 'GenerateTravelLogLogReturn';
  fuelCompensation?: Maybe<Scalars['Float']>;
  kmTotal?: Maybe<Scalars['Float']>;
  neededKilometers?: Maybe<Scalars['Float']>;
  travelLogLegs?: Maybe<Array<Maybe<TravelLogLegs>>>;
};

export type GenerateTravelLogRouteInput = {
  maxUseLimit: Scalars['Int'];
  route: Scalars['Int'];
};

export type House = {
  __typename?: 'House';
  abilities?: Maybe<Array<Maybe<Ability>>>;
  area?: Maybe<Scalars['String']>;
  cellar?: Maybe<Scalars['Boolean']>;
  colour?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  date?: Maybe<Scalars['Date']>;
  enum?: Maybe<Enum_House_Enum>;
  garden?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  numberOfStoreys: Scalars['Int'];
  owner?: Maybe<UsersPermissionsUser>;
  price?: Maybe<Scalars['Float']>;
  published_at?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Maybe<Tags>>>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['DateTime'];
};


export type HouseAbilitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type HouseTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type HouseAggregator = {
  __typename?: 'HouseAggregator';
  avg?: Maybe<HouseAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<HouseAggregatorMax>;
  min?: Maybe<HouseAggregatorMin>;
  sum?: Maybe<HouseAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type HouseAggregatorAvg = {
  __typename?: 'HouseAggregatorAvg';
  numberOfStoreys?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

export type HouseAggregatorMax = {
  __typename?: 'HouseAggregatorMax';
  numberOfStoreys?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

export type HouseAggregatorMin = {
  __typename?: 'HouseAggregatorMin';
  numberOfStoreys?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

export type HouseAggregatorSum = {
  __typename?: 'HouseAggregatorSum';
  numberOfStoreys?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

export type HouseConnection = {
  __typename?: 'HouseConnection';
  aggregate?: Maybe<HouseAggregator>;
  groupBy?: Maybe<HouseGroupBy>;
  values?: Maybe<Array<Maybe<House>>>;
};

export type HouseConnectionArea = {
  __typename?: 'HouseConnectionArea';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type HouseConnectionCellar = {
  __typename?: 'HouseConnectionCellar';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type HouseConnectionColour = {
  __typename?: 'HouseConnectionColour';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type HouseConnectionCreated_At = {
  __typename?: 'HouseConnectionCreated_at';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type HouseConnectionDate = {
  __typename?: 'HouseConnectionDate';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type HouseConnectionEnum = {
  __typename?: 'HouseConnectionEnum';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type HouseConnectionGarden = {
  __typename?: 'HouseConnectionGarden';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type HouseConnectionId = {
  __typename?: 'HouseConnectionId';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type HouseConnectionNumberOfStoreys = {
  __typename?: 'HouseConnectionNumberOfStoreys';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type HouseConnectionOwner = {
  __typename?: 'HouseConnectionOwner';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type HouseConnectionPrice = {
  __typename?: 'HouseConnectionPrice';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type HouseConnectionPublished_At = {
  __typename?: 'HouseConnectionPublished_at';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type HouseConnectionTest = {
  __typename?: 'HouseConnectionTest';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type HouseConnectionUpdated_At = {
  __typename?: 'HouseConnectionUpdated_at';
  connection?: Maybe<HouseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type HouseGroupBy = {
  __typename?: 'HouseGroupBy';
  area?: Maybe<Array<Maybe<HouseConnectionArea>>>;
  cellar?: Maybe<Array<Maybe<HouseConnectionCellar>>>;
  colour?: Maybe<Array<Maybe<HouseConnectionColour>>>;
  created_at?: Maybe<Array<Maybe<HouseConnectionCreated_At>>>;
  date?: Maybe<Array<Maybe<HouseConnectionDate>>>;
  enum?: Maybe<Array<Maybe<HouseConnectionEnum>>>;
  garden?: Maybe<Array<Maybe<HouseConnectionGarden>>>;
  id?: Maybe<Array<Maybe<HouseConnectionId>>>;
  numberOfStoreys?: Maybe<Array<Maybe<HouseConnectionNumberOfStoreys>>>;
  owner?: Maybe<Array<Maybe<HouseConnectionOwner>>>;
  price?: Maybe<Array<Maybe<HouseConnectionPrice>>>;
  published_at?: Maybe<Array<Maybe<HouseConnectionPublished_At>>>;
  test?: Maybe<Array<Maybe<HouseConnectionTest>>>;
  updated_at?: Maybe<Array<Maybe<HouseConnectionUpdated_At>>>;
};

export type HouseInput = {
  abilities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  area?: InputMaybe<Scalars['String']>;
  cellar?: InputMaybe<Scalars['Boolean']>;
  colour?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  enum?: InputMaybe<Enum_House_Enum>;
  garden?: InputMaybe<Scalars['Boolean']>;
  numberOfStoreys: Scalars['Int'];
  owner?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  test?: InputMaybe<Scalars['Boolean']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type InitializeApprovalProcessInput = {
  targetModelId: Scalars['String'];
  targetModelName: ApprovalProcessSupportedModels;
};

export type InputId = {
  id: Scalars['ID'];
};

export type Invoice = {
  __typename?: 'Invoice';
  approvalProcess?: Maybe<ApprovalProcess>;
  approval_process?: Maybe<ApprovalProcess>;
  archived?: Maybe<Scalars['Boolean']>;
  attachments?: Maybe<Array<Maybe<S3File>>>;
  created_at: Scalars['DateTime'];
  dateReceived?: Maybe<Scalars['Date']>;
  department?: Maybe<Department>;
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  invoice_read_model?: Maybe<InvoiceReadModel>;
  origin?: Maybe<ReceivedMail>;
  pairingSymbol?: Maybe<Scalars['String']>;
  partner?: Maybe<CompanyPartner>;
  project?: Maybe<Project>;
  status?: Maybe<Enum_Invoice_Status>;
  subject?: Maybe<Scalars['String']>;
  sum?: Maybe<Scalars['Float']>;
  type?: Maybe<Enum_Invoice_Type>;
  updated_at: Scalars['DateTime'];
  variableSymbol?: Maybe<Scalars['String']>;
};


export type InvoiceAttachmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type InvoiceAggregator = {
  __typename?: 'InvoiceAggregator';
  avg?: Maybe<InvoiceAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<InvoiceAggregatorMax>;
  min?: Maybe<InvoiceAggregatorMin>;
  sum?: Maybe<InvoiceAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InvoiceAggregatorAvg = {
  __typename?: 'InvoiceAggregatorAvg';
  sum?: Maybe<Scalars['Float']>;
};

export type InvoiceAggregatorMax = {
  __typename?: 'InvoiceAggregatorMax';
  sum?: Maybe<Scalars['Float']>;
};

export type InvoiceAggregatorMin = {
  __typename?: 'InvoiceAggregatorMin';
  sum?: Maybe<Scalars['Float']>;
};

export type InvoiceAggregatorSum = {
  __typename?: 'InvoiceAggregatorSum';
  sum?: Maybe<Scalars['Float']>;
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  aggregate?: Maybe<InvoiceAggregator>;
  groupBy?: Maybe<InvoiceGroupBy>;
  values?: Maybe<Array<Maybe<Invoice>>>;
};

export type InvoiceConnectionApproval_Process = {
  __typename?: 'InvoiceConnectionApproval_process';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceConnectionArchived = {
  __typename?: 'InvoiceConnectionArchived';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type InvoiceConnectionCreated_At = {
  __typename?: 'InvoiceConnectionCreated_at';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type InvoiceConnectionDateReceived = {
  __typename?: 'InvoiceConnectionDateReceived';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceConnectionDepartment = {
  __typename?: 'InvoiceConnectionDepartment';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceConnectionDueDate = {
  __typename?: 'InvoiceConnectionDueDate';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceConnectionId = {
  __typename?: 'InvoiceConnectionId';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceConnectionInvoiceNumber = {
  __typename?: 'InvoiceConnectionInvoiceNumber';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceConnectionInvoice_Read_Model = {
  __typename?: 'InvoiceConnectionInvoice_read_model';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceConnectionOrigin = {
  __typename?: 'InvoiceConnectionOrigin';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceConnectionPairingSymbol = {
  __typename?: 'InvoiceConnectionPairingSymbol';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceConnectionPartner = {
  __typename?: 'InvoiceConnectionPartner';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceConnectionProject = {
  __typename?: 'InvoiceConnectionProject';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceConnectionStatus = {
  __typename?: 'InvoiceConnectionStatus';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceConnectionSubject = {
  __typename?: 'InvoiceConnectionSubject';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceConnectionSum = {
  __typename?: 'InvoiceConnectionSum';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type InvoiceConnectionType = {
  __typename?: 'InvoiceConnectionType';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceConnectionUpdated_At = {
  __typename?: 'InvoiceConnectionUpdated_at';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type InvoiceConnectionVariableSymbol = {
  __typename?: 'InvoiceConnectionVariableSymbol';
  connection?: Maybe<InvoiceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceGroupBy = {
  __typename?: 'InvoiceGroupBy';
  approval_process?: Maybe<Array<Maybe<InvoiceConnectionApproval_Process>>>;
  archived?: Maybe<Array<Maybe<InvoiceConnectionArchived>>>;
  created_at?: Maybe<Array<Maybe<InvoiceConnectionCreated_At>>>;
  dateReceived?: Maybe<Array<Maybe<InvoiceConnectionDateReceived>>>;
  department?: Maybe<Array<Maybe<InvoiceConnectionDepartment>>>;
  dueDate?: Maybe<Array<Maybe<InvoiceConnectionDueDate>>>;
  id?: Maybe<Array<Maybe<InvoiceConnectionId>>>;
  invoiceNumber?: Maybe<Array<Maybe<InvoiceConnectionInvoiceNumber>>>;
  invoice_read_model?: Maybe<Array<Maybe<InvoiceConnectionInvoice_Read_Model>>>;
  origin?: Maybe<Array<Maybe<InvoiceConnectionOrigin>>>;
  pairingSymbol?: Maybe<Array<Maybe<InvoiceConnectionPairingSymbol>>>;
  partner?: Maybe<Array<Maybe<InvoiceConnectionPartner>>>;
  project?: Maybe<Array<Maybe<InvoiceConnectionProject>>>;
  status?: Maybe<Array<Maybe<InvoiceConnectionStatus>>>;
  subject?: Maybe<Array<Maybe<InvoiceConnectionSubject>>>;
  sum?: Maybe<Array<Maybe<InvoiceConnectionSum>>>;
  type?: Maybe<Array<Maybe<InvoiceConnectionType>>>;
  updated_at?: Maybe<Array<Maybe<InvoiceConnectionUpdated_At>>>;
  variableSymbol?: Maybe<Array<Maybe<InvoiceConnectionVariableSymbol>>>;
};

export type InvoiceInput = {
  approval_process?: InputMaybe<Scalars['ID']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  dateReceived?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<Scalars['ID']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  invoice_read_model?: InputMaybe<Scalars['ID']>;
  origin?: InputMaybe<Scalars['ID']>;
  pairingSymbol?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['ID']>;
  project?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Invoice_Status>;
  subject?: InputMaybe<Scalars['String']>;
  sum?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Enum_Invoice_Type>;
  updated_by?: InputMaybe<Scalars['ID']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
};

export type InvoiceReadModel = {
  __typename?: 'InvoiceReadModel';
  approvalProcessCurrentStepId?: Maybe<Scalars['Int']>;
  approvalProcessCurrentStepType?: Maybe<Enum_Invoicereadmodel_Approvalprocesscurrentsteptype>;
  approvalProcessStatus?: Maybe<Enum_Invoicereadmodel_Approvalprocessstatus>;
  approvalProcessWaitingOn?: Maybe<UsersPermissionsUser>;
  archived?: Maybe<Scalars['Boolean']>;
  attachments?: Maybe<Array<Maybe<S3File>>>;
  created_at: Scalars['DateTime'];
  dateReceived?: Maybe<Scalars['Date']>;
  department?: Maybe<Department>;
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  isAdvance?: Maybe<Scalars['Boolean']>;
  origin?: Maybe<ReceivedMail>;
  pairingSymbol?: Maybe<Scalars['String']>;
  partner?: Maybe<CompanyPartner>;
  project?: Maybe<Project>;
  published_at?: Maybe<Scalars['DateTime']>;
  source_entity?: Maybe<Invoice>;
  status?: Maybe<Enum_Invoicereadmodel_Status>;
  subject?: Maybe<Scalars['String']>;
  sum?: Maybe<Scalars['Float']>;
  type?: Maybe<Enum_Invoicereadmodel_Type>;
  updated_at: Scalars['DateTime'];
  variableSymbol?: Maybe<Scalars['String']>;
};


export type InvoiceReadModelAttachmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type InvoiceReadModelAggregator = {
  __typename?: 'InvoiceReadModelAggregator';
  avg?: Maybe<InvoiceReadModelAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<InvoiceReadModelAggregatorMax>;
  min?: Maybe<InvoiceReadModelAggregatorMin>;
  sum?: Maybe<InvoiceReadModelAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InvoiceReadModelAggregatorAvg = {
  __typename?: 'InvoiceReadModelAggregatorAvg';
  approvalProcessCurrentStepId?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
};

export type InvoiceReadModelAggregatorMax = {
  __typename?: 'InvoiceReadModelAggregatorMax';
  approvalProcessCurrentStepId?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
};

export type InvoiceReadModelAggregatorMin = {
  __typename?: 'InvoiceReadModelAggregatorMin';
  approvalProcessCurrentStepId?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
};

export type InvoiceReadModelAggregatorSum = {
  __typename?: 'InvoiceReadModelAggregatorSum';
  approvalProcessCurrentStepId?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
};

export type InvoiceReadModelConnection = {
  __typename?: 'InvoiceReadModelConnection';
  aggregate?: Maybe<InvoiceReadModelAggregator>;
  groupBy?: Maybe<InvoiceReadModelGroupBy>;
  values?: Maybe<Array<Maybe<InvoiceReadModel>>>;
};

export type InvoiceReadModelConnectionApprovalProcessCurrentStepId = {
  __typename?: 'InvoiceReadModelConnectionApprovalProcessCurrentStepId';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type InvoiceReadModelConnectionApprovalProcessCurrentStepType = {
  __typename?: 'InvoiceReadModelConnectionApprovalProcessCurrentStepType';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceReadModelConnectionApprovalProcessStatus = {
  __typename?: 'InvoiceReadModelConnectionApprovalProcessStatus';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceReadModelConnectionApprovalProcessWaitingOn = {
  __typename?: 'InvoiceReadModelConnectionApprovalProcessWaitingOn';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceReadModelConnectionArchived = {
  __typename?: 'InvoiceReadModelConnectionArchived';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type InvoiceReadModelConnectionCreated_At = {
  __typename?: 'InvoiceReadModelConnectionCreated_at';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type InvoiceReadModelConnectionDateReceived = {
  __typename?: 'InvoiceReadModelConnectionDateReceived';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceReadModelConnectionDepartment = {
  __typename?: 'InvoiceReadModelConnectionDepartment';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceReadModelConnectionDueDate = {
  __typename?: 'InvoiceReadModelConnectionDueDate';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceReadModelConnectionId = {
  __typename?: 'InvoiceReadModelConnectionId';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceReadModelConnectionInvoiceNumber = {
  __typename?: 'InvoiceReadModelConnectionInvoiceNumber';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceReadModelConnectionIsAdvance = {
  __typename?: 'InvoiceReadModelConnectionIsAdvance';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type InvoiceReadModelConnectionOrigin = {
  __typename?: 'InvoiceReadModelConnectionOrigin';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceReadModelConnectionPairingSymbol = {
  __typename?: 'InvoiceReadModelConnectionPairingSymbol';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceReadModelConnectionPartner = {
  __typename?: 'InvoiceReadModelConnectionPartner';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceReadModelConnectionProject = {
  __typename?: 'InvoiceReadModelConnectionProject';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceReadModelConnectionPublished_At = {
  __typename?: 'InvoiceReadModelConnectionPublished_at';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type InvoiceReadModelConnectionSource_Entity = {
  __typename?: 'InvoiceReadModelConnectionSource_entity';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InvoiceReadModelConnectionStatus = {
  __typename?: 'InvoiceReadModelConnectionStatus';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceReadModelConnectionSubject = {
  __typename?: 'InvoiceReadModelConnectionSubject';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceReadModelConnectionSum = {
  __typename?: 'InvoiceReadModelConnectionSum';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type InvoiceReadModelConnectionType = {
  __typename?: 'InvoiceReadModelConnectionType';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceReadModelConnectionUpdated_At = {
  __typename?: 'InvoiceReadModelConnectionUpdated_at';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type InvoiceReadModelConnectionVariableSymbol = {
  __typename?: 'InvoiceReadModelConnectionVariableSymbol';
  connection?: Maybe<InvoiceReadModelConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InvoiceReadModelGroupBy = {
  __typename?: 'InvoiceReadModelGroupBy';
  approvalProcessCurrentStepId?: Maybe<Array<Maybe<InvoiceReadModelConnectionApprovalProcessCurrentStepId>>>;
  approvalProcessCurrentStepType?: Maybe<Array<Maybe<InvoiceReadModelConnectionApprovalProcessCurrentStepType>>>;
  approvalProcessStatus?: Maybe<Array<Maybe<InvoiceReadModelConnectionApprovalProcessStatus>>>;
  approvalProcessWaitingOn?: Maybe<Array<Maybe<InvoiceReadModelConnectionApprovalProcessWaitingOn>>>;
  archived?: Maybe<Array<Maybe<InvoiceReadModelConnectionArchived>>>;
  created_at?: Maybe<Array<Maybe<InvoiceReadModelConnectionCreated_At>>>;
  dateReceived?: Maybe<Array<Maybe<InvoiceReadModelConnectionDateReceived>>>;
  department?: Maybe<Array<Maybe<InvoiceReadModelConnectionDepartment>>>;
  dueDate?: Maybe<Array<Maybe<InvoiceReadModelConnectionDueDate>>>;
  id?: Maybe<Array<Maybe<InvoiceReadModelConnectionId>>>;
  invoiceNumber?: Maybe<Array<Maybe<InvoiceReadModelConnectionInvoiceNumber>>>;
  isAdvance?: Maybe<Array<Maybe<InvoiceReadModelConnectionIsAdvance>>>;
  origin?: Maybe<Array<Maybe<InvoiceReadModelConnectionOrigin>>>;
  pairingSymbol?: Maybe<Array<Maybe<InvoiceReadModelConnectionPairingSymbol>>>;
  partner?: Maybe<Array<Maybe<InvoiceReadModelConnectionPartner>>>;
  project?: Maybe<Array<Maybe<InvoiceReadModelConnectionProject>>>;
  published_at?: Maybe<Array<Maybe<InvoiceReadModelConnectionPublished_At>>>;
  source_entity?: Maybe<Array<Maybe<InvoiceReadModelConnectionSource_Entity>>>;
  status?: Maybe<Array<Maybe<InvoiceReadModelConnectionStatus>>>;
  subject?: Maybe<Array<Maybe<InvoiceReadModelConnectionSubject>>>;
  sum?: Maybe<Array<Maybe<InvoiceReadModelConnectionSum>>>;
  type?: Maybe<Array<Maybe<InvoiceReadModelConnectionType>>>;
  updated_at?: Maybe<Array<Maybe<InvoiceReadModelConnectionUpdated_At>>>;
  variableSymbol?: Maybe<Array<Maybe<InvoiceReadModelConnectionVariableSymbol>>>;
};

export type InvoiceReadModelInput = {
  approvalProcessCurrentStepId?: InputMaybe<Scalars['Int']>;
  approvalProcessCurrentStepType?: InputMaybe<Enum_Invoicereadmodel_Approvalprocesscurrentsteptype>;
  approvalProcessStatus?: InputMaybe<Enum_Invoicereadmodel_Approvalprocessstatus>;
  approvalProcessWaitingOn?: InputMaybe<Scalars['ID']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  dateReceived?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<Scalars['ID']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isAdvance?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<Scalars['ID']>;
  pairingSymbol?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['ID']>;
  project?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  source_entity?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Invoicereadmodel_Status>;
  subject?: InputMaybe<Scalars['String']>;
  sum?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Enum_Invoicereadmodel_Type>;
  updated_by?: InputMaybe<Scalars['ID']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
};

export type LocaleInput = {
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type MailModule = {
  __typename?: 'MailModule';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};

export type MailModuleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type Morph = Ability | AbilityAggregator | AbilityAggregatorAvg | AbilityAggregatorMax | AbilityAggregatorMin | AbilityAggregatorSum | AbilityConnection | AbilityConnectionAction | AbilityConnectionCreated_At | AbilityConnectionHouse | AbilityConnectionId | AbilityConnectionReason | AbilityConnectionReceived_Mail | AbilityConnectionRole | AbilityConnectionTargetModelId | AbilityConnectionTargetModelName | AbilityConnectionUpdated_At | AbilityConnectionUser | AbilityGroupBy | Address | AddressAggregator | AddressConnection | AddressConnectionCity | AddressConnectionCountry | AddressConnectionCreated_At | AddressConnectionEmail | AddressConnectionId | AddressConnectionMobile | AddressConnectionName | AddressConnectionPhone | AddressConnectionStreet | AddressConnectionUpdated_At | AddressConnectionZip | AddressGroupBy | Announcment | AnnouncmentAggregator | AnnouncmentConnection | AnnouncmentConnectionContent | AnnouncmentConnectionCreated_At | AnnouncmentConnectionId | AnnouncmentConnectionPublished_At | AnnouncmentConnectionTitle | AnnouncmentConnectionUpdated_At | AnnouncmentGroupBy | ApprovalProcess | ApprovalProcessAggregator | ApprovalProcessAggregatorAvg | ApprovalProcessAggregatorMax | ApprovalProcessAggregatorMin | ApprovalProcessAggregatorSum | ApprovalProcessConnection | ApprovalProcessConnectionCreated_At | ApprovalProcessConnectionId | ApprovalProcessConnectionManager | ApprovalProcessConnectionStart | ApprovalProcessConnectionStartOfCurrentPhaseIndex | ApprovalProcessConnectionStartedBy | ApprovalProcessConnectionStatus | ApprovalProcessConnectionTargetModelId | ApprovalProcessConnectionTargetModelName | ApprovalProcessConnectionUpdated_At | ApprovalProcessDisputeResolutionOption | ApprovalProcessDisputeResolutionOptionAggregator | ApprovalProcessDisputeResolutionOptionConnection | ApprovalProcessDisputeResolutionOptionConnectionCode | ApprovalProcessDisputeResolutionOptionConnectionCreated_At | ApprovalProcessDisputeResolutionOptionConnectionId | ApprovalProcessDisputeResolutionOptionConnectionName | ApprovalProcessDisputeResolutionOptionConnectionTargetModelName | ApprovalProcessDisputeResolutionOptionConnectionUpdated_At | ApprovalProcessDisputeResolutionOptionGroupBy | ApprovalProcessGroupBy | ApprovalProcessUpdateReturn | ApprovalStep | ApprovalStepAggregator | ApprovalStepAggregatorAvg | ApprovalStepAggregatorMax | ApprovalStepAggregatorMin | ApprovalStepAggregatorSum | ApprovalStepConnection | ApprovalStepConnectionApproval_Process | ApprovalStepConnectionAt | ApprovalStepConnectionCreated_At | ApprovalStepConnectionId | ApprovalStepConnectionIndex | ApprovalStepConnectionNext | ApprovalStepConnectionNote | ApprovalStepConnectionPrevious | ApprovalStepConnectionPublished_At | ApprovalStepConnectionUpdated_At | ApprovalStepConnectionUser | ApprovalStepGroupBy | AuditLogRecord | AuditLogRecordAggregator | AuditLogRecordAggregatorAvg | AuditLogRecordAggregatorMax | AuditLogRecordAggregatorMin | AuditLogRecordAggregatorSum | AuditLogRecordConnection | AuditLogRecordConnectionAction | AuditLogRecordConnectionCreated_At | AuditLogRecordConnectionDifference | AuditLogRecordConnectionId | AuditLogRecordConnectionLatitudeOfInitiatingDevice | AuditLogRecordConnectionLongitudeOfInitiatingDevice | AuditLogRecordConnectionNewData | AuditLogRecordConnectionOperatingSystemOfInitiatingDevice | AuditLogRecordConnectionParent_Record | AuditLogRecordConnectionPreviousData | AuditLogRecordConnectionTargetModelId | AuditLogRecordConnectionTargetModelName | AuditLogRecordConnectionTimestamp | AuditLogRecordConnectionUpdated_At | AuditLogRecordConnectionUser | AuditLogRecordGroupBy | City | CityAggregator | CityConnection | CityConnectionCreated_At | CityConnectionId | CityConnectionName | CityConnectionUpdated_At | CityGroupBy | Comment | CommentAggregator | CommentConnection | CommentConnectionAuthor | CommentConnectionContent | CommentConnectionCreated_At | CommentConnectionId | CommentConnectionIsSubcomment | CommentConnectionParentComment | CommentConnectionTargetModelId | CommentConnectionTargetModelName | CommentConnectionUpdated_At | CommentGroupBy | CompanyModule | CompanyPartner | CompanyPartnerAggregator | CompanyPartnerConnection | CompanyPartnerConnectionArchived | CompanyPartnerConnectionBankCode | CompanyPartnerConnectionBusinessId | CompanyPartnerConnectionCreated_At | CompanyPartnerConnectionIban | CompanyPartnerConnectionId | CompanyPartnerConnectionName | CompanyPartnerConnectionPublished_At | CompanyPartnerConnectionTaxId | CompanyPartnerConnectionUpdated_At | CompanyPartnerConnectionVatId | CompanyPartnerGroupBy | ComponentApprovalProcessApprovalProcessControlStep | ComponentApprovalProcessApprovalProcessDisputeResolutionStep | ComponentApprovalProcessDisputeResolutionStep | ComponentApprovalProcessInformStep | ComponentNotificationTags | ComponentSharedHouseAbility | ComponentTravelLogDates | ComponentTravelLogDestinationTravelLimit | ComponentTravelLogRoutes | ComponentTravelLogTravelLogLeg | ComponentTravelLogTravelLogRouteLegs | CreatedBy | Department | DepartmentAggregator | DepartmentAggregatorAvg | DepartmentAggregatorMax | DepartmentAggregatorMin | DepartmentAggregatorSum | DepartmentConnection | DepartmentConnectionCreated_At | DepartmentConnectionFinancialDecisionMaker | DepartmentConnectionHead | DepartmentConnectionHead_Assistant | DepartmentConnectionId | DepartmentConnectionMaxInvoiceSumAllowedForDepartmentManager | DepartmentConnectionName | DepartmentConnectionUpdated_At | DepartmentGroupBy | Distances | DropboxFolderItem | Event | EventAggregator | EventBusBusevent | EventConnection | EventConnectionCreated_At | EventConnectionEmitted | EventConnectionEventType | EventConnectionId | EventConnectionPayload | EventConnectionTraceId | EventConnectionType | EventConnectionUid | EventConnectionUpdated_At | EventConnectionUser | EventGroupBy | Finish | GenerateTravelLogLogReturn | House | HouseAggregator | HouseAggregatorAvg | HouseAggregatorMax | HouseAggregatorMin | HouseAggregatorSum | HouseConnection | HouseConnectionArea | HouseConnectionCellar | HouseConnectionColour | HouseConnectionCreated_At | HouseConnectionDate | HouseConnectionEnum | HouseConnectionGarden | HouseConnectionId | HouseConnectionNumberOfStoreys | HouseConnectionOwner | HouseConnectionPrice | HouseConnectionPublished_At | HouseConnectionTest | HouseConnectionUpdated_At | HouseGroupBy | I18NLocale | Invoice | InvoiceAggregator | InvoiceAggregatorAvg | InvoiceAggregatorMax | InvoiceAggregatorMin | InvoiceAggregatorSum | InvoiceConnection | InvoiceConnectionApproval_Process | InvoiceConnectionArchived | InvoiceConnectionCreated_At | InvoiceConnectionDateReceived | InvoiceConnectionDepartment | InvoiceConnectionDueDate | InvoiceConnectionId | InvoiceConnectionInvoiceNumber | InvoiceConnectionInvoice_Read_Model | InvoiceConnectionOrigin | InvoiceConnectionPairingSymbol | InvoiceConnectionPartner | InvoiceConnectionProject | InvoiceConnectionStatus | InvoiceConnectionSubject | InvoiceConnectionSum | InvoiceConnectionType | InvoiceConnectionUpdated_At | InvoiceConnectionVariableSymbol | InvoiceGroupBy | InvoiceReadModel | InvoiceReadModelAggregator | InvoiceReadModelAggregatorAvg | InvoiceReadModelAggregatorMax | InvoiceReadModelAggregatorMin | InvoiceReadModelAggregatorSum | InvoiceReadModelConnection | InvoiceReadModelConnectionApprovalProcessCurrentStepId | InvoiceReadModelConnectionApprovalProcessCurrentStepType | InvoiceReadModelConnectionApprovalProcessStatus | InvoiceReadModelConnectionApprovalProcessWaitingOn | InvoiceReadModelConnectionArchived | InvoiceReadModelConnectionCreated_At | InvoiceReadModelConnectionDateReceived | InvoiceReadModelConnectionDepartment | InvoiceReadModelConnectionDueDate | InvoiceReadModelConnectionId | InvoiceReadModelConnectionInvoiceNumber | InvoiceReadModelConnectionIsAdvance | InvoiceReadModelConnectionOrigin | InvoiceReadModelConnectionPairingSymbol | InvoiceReadModelConnectionPartner | InvoiceReadModelConnectionProject | InvoiceReadModelConnectionPublished_At | InvoiceReadModelConnectionSource_Entity | InvoiceReadModelConnectionStatus | InvoiceReadModelConnectionSubject | InvoiceReadModelConnectionSum | InvoiceReadModelConnectionType | InvoiceReadModelConnectionUpdated_At | InvoiceReadModelConnectionVariableSymbol | InvoiceReadModelGroupBy | MailModule | Notification | NotificationAggregator | NotificationConnection | NotificationConnectionCreated_At | NotificationConnectionData | NotificationConnectionDescription | NotificationConnectionId | NotificationConnectionRead | NotificationConnectionTitle | NotificationConnectionType | NotificationConnectionUpdated_At | NotificationConnectionUser | NotificationGroupBy | Project | ProjectAggregator | ProjectAggregatorAvg | ProjectAggregatorMax | ProjectAggregatorMin | ProjectAggregatorSum | ProjectConnection | ProjectConnectionCreated_At | ProjectConnectionDepartment | ProjectConnectionDescription | ProjectConnectionId | ProjectConnectionInvoiceMaxSumAllowedForProjectManager | ProjectConnectionMainManager | ProjectConnectionName | ProjectConnectionPartner | ProjectConnectionProjectNumber | ProjectConnectionUpdated_At | ProjectGroupBy | Reason | Reasons | ReceivedMail | ReceivedMailAggregator | ReceivedMailAggregatorAvg | ReceivedMailAggregatorMax | ReceivedMailAggregatorMin | ReceivedMailAggregatorSum | ReceivedMailConnection | ReceivedMailConnectionArchived | ReceivedMailConnectionAssignee | ReceivedMailConnectionContents | ReceivedMailConnectionCreated_At | ReceivedMailConnectionDateReceived | ReceivedMailConnectionDepartment | ReceivedMailConnectionId | ReceivedMailConnectionInvoice | ReceivedMailConnectionNote | ReceivedMailConnectionPreviousNumber | ReceivedMailConnectionPriority | ReceivedMailConnectionProcessed | ReceivedMailConnectionProject | ReceivedMailConnectionSenderAddress | ReceivedMailConnectionSenderPartner | ReceivedMailConnectionStatus | ReceivedMailConnectionTypeOfDelivery | ReceivedMailConnectionUpdated_At | ReceivedMailGroupBy | S3File | S3FileAggregator | S3FileConnection | S3FileConnectionCreated_At | S3FileConnectionId | S3FileConnectionKey | S3FileConnectionName | S3FileConnectionSent_Mail | S3FileConnectionStorage_Folder | S3FileConnectionTargetModelId | S3FileConnectionTargetModelName | S3FileConnectionType | S3FileConnectionUpdated_At | S3FileConnectionUploadedAt | S3FileGroupBy | SavedFilter | SavedFilterAggregator | SavedFilterConnection | SavedFilterConnectionArchived | SavedFilterConnectionCreated_At | SavedFilterConnectionFilters | SavedFilterConnectionId | SavedFilterConnectionName | SavedFilterConnectionTargetModelName | SavedFilterConnectionUpdated_At | SavedFilterConnectionUser | SavedFilterGroupBy | SentMail | SentMailAggregator | SentMailConnection | SentMailConnectionArchived | SentMailConnectionAssignee | SentMailConnectionContents | SentMailConnectionCreated_At | SentMailConnectionDateSent | SentMailConnectionId | SentMailConnectionNote | SentMailConnectionNumber | SentMailConnectionPublished_At | SentMailConnectionRecipientAddress | SentMailConnectionRecipientPartner | SentMailConnectionUpdated_At | SentMailGroupBy | ServiceLog | ServiceLogAggregator | ServiceLogConnection | ServiceLogConnectionCreated_At | ServiceLogConnectionDate | ServiceLogConnectionDescription | ServiceLogConnectionEmployee | ServiceLogConnectionId | ServiceLogConnectionPublished_At | ServiceLogConnectionResult | ServiceLogConnectionUpdated_At | ServiceLogConnectionVehicle | ServiceLogGroupBy | SettingsModule | SharedContactPerson | SharedContactPersonAggregator | SharedContactPersonConnection | SharedContactPersonConnectionCreated_At | SharedContactPersonConnectionId | SharedContactPersonConnectionName | SharedContactPersonConnectionPhone | SharedContactPersonConnectionPosition | SharedContactPersonConnectionUpdated_At | SharedContactPersonGroupBy | SharingInfo | Start | StorageFolder | StorageFolderAggregator | StorageFolderConnection | StorageFolderConnectionCreated_At | StorageFolderConnectionId | StorageFolderConnectionIsRoot | StorageFolderConnectionName | StorageFolderConnectionParent_Folder | StorageFolderConnectionPath | StorageFolderConnectionPublished_At | StorageFolderConnectionTargetModelId | StorageFolderConnectionTargetModelName | StorageFolderConnectionUpdated_At | StorageFolderGroupBy | Tags | TagsAggregator | TagsConnection | TagsConnectionCreated_At | TagsConnectionId | TagsConnectionName | TagsConnectionSlug | TagsConnectionUpdated_At | TagsGroupBy | TravelLogConfiguration | TravelLogConfigurationAggregator | TravelLogConfigurationConnection | TravelLogConfigurationConnectionCreated_At | TravelLogConfigurationConnectionId | TravelLogConfigurationConnectionName | TravelLogConfigurationConnectionPublished_At | TravelLogConfigurationConnectionUpdated_At | TravelLogConfigurationGroupBy | TravelLogLegs | TravelLogLog | TravelLogLogAggregator | TravelLogLogAggregatorAvg | TravelLogLogAggregatorMax | TravelLogLogAggregatorMin | TravelLogLogAggregatorSum | TravelLogLogConnection | TravelLogLogConnectionArchived | TravelLogLogConnectionCompensationForFuel | TravelLogLogConnectionCompensationForTravel | TravelLogLogConnectionCreated_At | TravelLogLogConnectionForMonth | TravelLogLogConnectionId | TravelLogLogConnectionNeededKilometers | TravelLogLogConnectionParametersUsedToGenerateLog | TravelLogLogConnectionPriceOfFuel | TravelLogLogConnectionPublished_At | TravelLogLogConnectionUpdated_At | TravelLogLogConnectionVehicle | TravelLogLogGroupBy | TravelLogModule | TravelLogPlace | TravelLogPlaceAggregator | TravelLogPlaceAggregatorAvg | TravelLogPlaceAggregatorMax | TravelLogPlaceAggregatorMin | TravelLogPlaceAggregatorSum | TravelLogPlaceConnection | TravelLogPlaceConnectionAddress | TravelLogPlaceConnectionCityCode | TravelLogPlaceConnectionCreated_At | TravelLogPlaceConnectionDefualtDayLimit | TravelLogPlaceConnectionId | TravelLogPlaceConnectionMaxInCityTravel | TravelLogPlaceConnectionName | TravelLogPlaceConnectionUpdated_At | TravelLogPlaceGroupBy | TravelLogPlacesDistance | TravelLogPlacesDistanceAggregator | TravelLogPlacesDistanceAggregatorAvg | TravelLogPlacesDistanceAggregatorMax | TravelLogPlacesDistanceAggregatorMin | TravelLogPlacesDistanceAggregatorSum | TravelLogPlacesDistanceConnection | TravelLogPlacesDistanceConnectionCreated_At | TravelLogPlacesDistanceConnectionDistanceInKm | TravelLogPlacesDistanceConnectionDurationInSeconds | TravelLogPlacesDistanceConnectionId | TravelLogPlacesDistanceConnectionIdentifier | TravelLogPlacesDistanceConnectionUpdated_At | TravelLogPlacesDistanceGroupBy | TravelLogPrivateVehicle | TravelLogPrivateVehicleAggregator | TravelLogPrivateVehicleAggregatorAvg | TravelLogPrivateVehicleAggregatorMax | TravelLogPrivateVehicleAggregatorMin | TravelLogPrivateVehicleAggregatorSum | TravelLogPrivateVehicleConnection | TravelLogPrivateVehicleConnectionBalancingPlace | TravelLogPrivateVehicleConnectionCreated_At | TravelLogPrivateVehicleConnectionFuelConsumption | TravelLogPrivateVehicleConnectionHomePlace | TravelLogPrivateVehicleConnectionId | TravelLogPrivateVehicleConnectionModel | TravelLogPrivateVehicleConnectionOwner | TravelLogPrivateVehicleConnectionPublished_At | TravelLogPrivateVehicleConnectionRegistrationPlate | TravelLogPrivateVehicleConnectionUpdated_At | TravelLogPrivateVehicleGroupBy | TravelLogPrivateVehicles | TravelLogRoute | TravelLogRouteAggregator | TravelLogRouteAggregatorAvg | TravelLogRouteAggregatorMax | TravelLogRouteAggregatorMin | TravelLogRouteAggregatorSum | TravelLogRouteConnection | TravelLogRouteConnectionCreated_At | TravelLogRouteConnectionId | TravelLogRouteConnectionOverallDistance | TravelLogRouteConnectionPublished_At | TravelLogRouteConnectionReason | TravelLogRouteConnectionUpdated_At | TravelLogRouteConnectionVehicle | TravelLogRouteGroupBy | TravelLogRouteReason | TravelLogRouteReasonAggregator | TravelLogRouteReasonConnection | TravelLogRouteReasonConnectionCreated_At | TravelLogRouteReasonConnectionId | TravelLogRouteReasonConnectionName | TravelLogRouteReasonConnectionPublished_At | TravelLogRouteReasonConnectionUpdated_At | TravelLogRouteReasonConnectionValue | TravelLogRouteReasonGroupBy | TravelLogRouteTemp | TravelLogRouteTempAggregator | TravelLogRouteTempAggregatorAvg | TravelLogRouteTempAggregatorMax | TravelLogRouteTempAggregatorMin | TravelLogRouteTempAggregatorSum | TravelLogRouteTempConnection | TravelLogRouteTempConnectionBalancing | TravelLogRouteTempConnectionCreated_At | TravelLogRouteTempConnectionDefaultMonthLimit | TravelLogRouteTempConnectionDestination | TravelLogRouteTempConnectionId | TravelLogRouteTempConnectionName | TravelLogRouteTempConnectionPublished_At | TravelLogRouteTempConnectionReason | TravelLogRouteTempConnectionUpdated_At | TravelLogRouteTempConnectionVehicle | TravelLogRouteTempGroupBy | TravelLogUserJourneyReason | TravelLogUserJourneyReasonAggregator | TravelLogUserJourneyReasonAggregatorAvg | TravelLogUserJourneyReasonAggregatorMax | TravelLogUserJourneyReasonAggregatorMin | TravelLogUserJourneyReasonAggregatorSum | TravelLogUserJourneyReasonConnection | TravelLogUserJourneyReasonConnectionCreated_At | TravelLogUserJourneyReasonConnectionDurationInHoursFrom | TravelLogUserJourneyReasonConnectionDurationInHoursTo | TravelLogUserJourneyReasonConnectionId | TravelLogUserJourneyReasonConnectionName | TravelLogUserJourneyReasonConnectionTempRoute | TravelLogUserJourneyReasonConnectionUpdated_At | TravelLogUserJourneyReasonConnectionUser | TravelLogUserJourneyReasonGroupBy | UpdateModelAbilitiesReturn | UpdatedBy | UploadFile | UploadFileAggregator | UploadFileAggregatorAvg | UploadFileAggregatorMax | UploadFileAggregatorMin | UploadFileAggregatorSum | UploadFileConnection | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionCreated_At | UploadFileConnectionExt | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionHeight | UploadFileConnectionId | UploadFileConnectionMime | UploadFileConnectionName | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UploadFileConnectionSize | UploadFileConnectionUpdated_At | UploadFileConnectionUrl | UploadFileConnectionWidth | UploadFileGroupBy | UserDevice | UserDeviceAggregator | UserDeviceConnection | UserDeviceConnectionCreated_At | UserDeviceConnectionFcmToken | UserDeviceConnectionId | UserDeviceConnectionLastUsed | UserDeviceConnectionOwner | UserDeviceConnectionPublished_At | UserDeviceConnectionUpdated_At | UserDeviceGroupBy | UserPermissionsPasswordPayload | UserSimple | UsersPermissionsLoginPayload | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleAggregator | UsersPermissionsRoleConnection | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionType | UsersPermissionsRoleGroupBy | UsersPermissionsUser | UsersPermissionsUserAggregator | UsersPermissionsUserConnection | UsersPermissionsUserConnectionActive | UsersPermissionsUserConnectionAddress | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionImage | UsersPermissionsUserConnectionName | UsersPermissionsUserConnectionPosition | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionUuid | UsersPermissionsUserGroupBy | Vehicle | VehicleAggregator | VehicleConnection | VehicleConnectionCreated_At | VehicleConnectionId | VehicleConnectionNote | VehicleConnectionPublished_At | VehicleConnectionRegistrationNumber | VehicleConnectionUpdated_At | VehicleGroupBy | VersionRelease | VersionReleaseAggregator | VersionReleaseAggregatorAvg | VersionReleaseAggregatorMax | VersionReleaseAggregatorMin | VersionReleaseAggregatorSum | VersionReleaseConnection | VersionReleaseConnectionContent | VersionReleaseConnectionCreated_At | VersionReleaseConnectionId | VersionReleaseConnectionUpdated_At | VersionReleaseConnectionVersion | VersionReleaseConnectionVersionNumerically | VersionReleaseGroupBy | WatchList | WatchListAggregator | WatchListConnection | WatchListConnectionCreated_At | WatchListConnectionId | WatchListConnectionTargetModelId | WatchListConnectionTargetModelName | WatchListConnectionUpdated_At | WatchListGroupBy | CreateAbilityPayload | CreateAddressPayload | CreateAnnouncmentPayload | CreateApprovalProcessDisputeResolutionOptionPayload | CreateApprovalProcessPayload | CreateApprovalStepPayload | CreateAuditLogRecordPayload | CreateCityPayload | CreateCommentPayload | CreateCompanyPartnerPayload | CreateDepartmentPayload | CreateEventPayload | CreateHousePayload | CreateInvoicePayload | CreateInvoiceReadModelPayload | CreateNotificationPayload | CreateProjectPayload | CreateReceivedMailPayload | CreateRolePayload | CreateS3FilePayload | CreateSavedFilterPayload | CreateSentMailPayload | CreateServiceLogPayload | CreateSharedContactPersonPayload | CreateStorageFolderPayload | CreateTagPayload | CreateTravelLogConfigurationPayload | CreateTravelLogLogPayload | CreateTravelLogPlacePayload | CreateTravelLogPlacesDistancePayload | CreateTravelLogPrivateVehiclePayload | CreateTravelLogRoutePayload | CreateTravelLogRouteReasonPayload | CreateTravelLogRouteTempPayload | CreateTravelLogUserJourneyReasonPayload | CreateUserDevicePayload | CreateUserPayload | CreateVehiclePayload | CreateVersionReleasePayload | CreateWatchListPayload | DeleteAbilityPayload | DeleteAddressPayload | DeleteAnnouncmentPayload | DeleteApprovalProcessDisputeResolutionOptionPayload | DeleteApprovalProcessPayload | DeleteApprovalStepPayload | DeleteAuditLogRecordPayload | DeleteCityPayload | DeleteCommentPayload | DeleteCompanyModulePayload | DeleteCompanyPartnerPayload | DeleteDepartmentPayload | DeleteEventPayload | DeleteFilePayload | DeleteHousePayload | DeleteInvoicePayload | DeleteInvoiceReadModelPayload | DeleteMailModulePayload | DeleteNotificationPayload | DeleteProjectPayload | DeleteReceivedMailPayload | DeleteRolePayload | DeleteS3FilePayload | DeleteSavedFilterPayload | DeleteSentMailPayload | DeleteServiceLogPayload | DeleteSettingsModulePayload | DeleteSharedContactPersonPayload | DeleteStorageFolderPayload | DeleteTagPayload | DeleteTravelLogConfigurationPayload | DeleteTravelLogLogPayload | DeleteTravelLogModulePayload | DeleteTravelLogPlacePayload | DeleteTravelLogPlacesDistancePayload | DeleteTravelLogPrivateVehiclePayload | DeleteTravelLogRoutePayload | DeleteTravelLogRouteReasonPayload | DeleteTravelLogRouteTempPayload | DeleteTravelLogUserJourneyReasonPayload | DeleteUserDevicePayload | DeleteUserPayload | DeleteVehiclePayload | DeleteVersionReleasePayload | DeleteWatchListPayload | UpdateAbilityPayload | UpdateAddressPayload | UpdateAnnouncmentPayload | UpdateApprovalProcessDisputeResolutionOptionPayload | UpdateApprovalProcessPayload | UpdateApprovalStepPayload | UpdateAuditLogRecordPayload | UpdateCityPayload | UpdateCommentPayload | UpdateCompanyModulePayload | UpdateCompanyPartnerPayload | UpdateDepartmentPayload | UpdateEventPayload | UpdateHousePayload | UpdateInvoicePayload | UpdateInvoiceReadModelPayload | UpdateMailModulePayload | UpdateNotificationPayload | UpdateProjectPayload | UpdateReceivedMailPayload | UpdateRolePayload | UpdateS3FilePayload | UpdateSavedFilterPayload | UpdateSentMailPayload | UpdateServiceLogPayload | UpdateSettingsModulePayload | UpdateSharedContactPersonPayload | UpdateStorageFolderPayload | UpdateTagPayload | UpdateTravelLogConfigurationPayload | UpdateTravelLogLogPayload | UpdateTravelLogModulePayload | UpdateTravelLogPlacePayload | UpdateTravelLogPlacesDistancePayload | UpdateTravelLogPrivateVehiclePayload | UpdateTravelLogRoutePayload | UpdateTravelLogRouteReasonPayload | UpdateTravelLogRouteTempPayload | UpdateTravelLogUserJourneyReasonPayload | UpdateUserDevicePayload | UpdateUserPayload | UpdateVehiclePayload | UpdateVersionReleasePayload | UpdateWatchListPayload;

export type Mutation = {
  __typename?: 'Mutation';
  addEntityComment?: Maybe<Comment>;
  addSetMailStatusAbilityToAllAssigneesHistorrycally?: Maybe<Scalars['Int']>;
  approveOrRejectApprovalStep?: Maybe<ApprovalProcessUpdateReturn>;
  creatOrUpdateReadModelForInvoice?: Maybe<InvoiceReadModel>;
  creatOrUpdateReadModelForInvoices: Scalars['Int'];
  createAbility?: Maybe<CreateAbilityPayload>;
  createAddress?: Maybe<CreateAddressPayload>;
  createAnnouncment?: Maybe<CreateAnnouncmentPayload>;
  createApprovalProcess?: Maybe<CreateApprovalProcessPayload>;
  createApprovalProcessDisputeResolutionOption?: Maybe<CreateApprovalProcessDisputeResolutionOptionPayload>;
  createApprovalStep?: Maybe<CreateApprovalStepPayload>;
  createAuditLogRecord?: Maybe<CreateAuditLogRecordPayload>;
  createCity?: Maybe<CreateCityPayload>;
  createComment?: Maybe<CreateCommentPayload>;
  createCompanyPartner?: Maybe<CreateCompanyPartnerPayload>;
  createDepartment?: Maybe<CreateDepartmentPayload>;
  createEvent?: Maybe<CreateEventPayload>;
  createHouse?: Maybe<CreateHousePayload>;
  createInvoice?: Maybe<CreateInvoicePayload>;
  createInvoiceReadModel?: Maybe<CreateInvoiceReadModelPayload>;
  createNotification?: Maybe<CreateNotificationPayload>;
  createProject?: Maybe<CreateProjectPayload>;
  createReceivedMail?: Maybe<CreateReceivedMailPayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  createS3File?: Maybe<CreateS3FilePayload>;
  createSavedFilter?: Maybe<CreateSavedFilterPayload>;
  createSentMail?: Maybe<CreateSentMailPayload>;
  createServiceLog?: Maybe<CreateServiceLogPayload>;
  createSharedContactPerson?: Maybe<CreateSharedContactPersonPayload>;
  createStorageFolder?: Maybe<CreateStorageFolderPayload>;
  createTag?: Maybe<CreateTagPayload>;
  createTravelLogConfiguration?: Maybe<CreateTravelLogConfigurationPayload>;
  createTravelLogLog?: Maybe<CreateTravelLogLogPayload>;
  createTravelLogPlace?: Maybe<CreateTravelLogPlacePayload>;
  createTravelLogPlacesDistance?: Maybe<CreateTravelLogPlacesDistancePayload>;
  createTravelLogPrivateVehicle?: Maybe<CreateTravelLogPrivateVehiclePayload>;
  createTravelLogRoute?: Maybe<CreateTravelLogRoutePayload>;
  createTravelLogRouteReason?: Maybe<CreateTravelLogRouteReasonPayload>;
  createTravelLogRouteTemp?: Maybe<CreateTravelLogRouteTempPayload>;
  createTravelLogUserJourneyReason?: Maybe<CreateTravelLogUserJourneyReasonPayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  createUserDevice?: Maybe<CreateUserDevicePayload>;
  createVehicle?: Maybe<CreateVehiclePayload>;
  createVehicleRoute?: Maybe<TravelLogRouteTemp>;
  createVersionRelease?: Maybe<CreateVersionReleasePayload>;
  createWatchList?: Maybe<CreateWatchListPayload>;
  deleteAbilities: Array<Maybe<Ability>>;
  deleteAbility?: Maybe<DeleteAbilityPayload>;
  deleteAddress?: Maybe<DeleteAddressPayload>;
  deleteAnnouncment?: Maybe<DeleteAnnouncmentPayload>;
  deleteApprovalProcess?: Maybe<DeleteApprovalProcessPayload>;
  deleteApprovalProcessDisputeResolutionOption?: Maybe<DeleteApprovalProcessDisputeResolutionOptionPayload>;
  deleteApprovalStep?: Maybe<DeleteApprovalStepPayload>;
  deleteAuditLogRecord?: Maybe<DeleteAuditLogRecordPayload>;
  deleteCity?: Maybe<DeleteCityPayload>;
  deleteComment?: Maybe<DeleteCommentPayload>;
  deleteCompanyModule?: Maybe<DeleteCompanyModulePayload>;
  deleteCompanyPartner?: Maybe<DeleteCompanyPartnerPayload>;
  deleteDepartment?: Maybe<DeleteDepartmentPayload>;
  deleteEvent?: Maybe<DeleteEventPayload>;
  /** Delete one file */
  deleteFile?: Maybe<DeleteFilePayload>;
  deleteHouse?: Maybe<DeleteHousePayload>;
  deleteInvoice?: Maybe<DeleteInvoicePayload>;
  deleteInvoiceReadModel?: Maybe<DeleteInvoiceReadModelPayload>;
  deleteMailModule?: Maybe<DeleteMailModulePayload>;
  deleteNotification?: Maybe<DeleteNotificationPayload>;
  deleteProject?: Maybe<DeleteProjectPayload>;
  deleteReceivedMail?: Maybe<DeleteReceivedMailPayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteS3File?: Maybe<DeleteS3FilePayload>;
  deleteSavedFilter?: Maybe<DeleteSavedFilterPayload>;
  deleteSentMail?: Maybe<DeleteSentMailPayload>;
  deleteServiceLog?: Maybe<DeleteServiceLogPayload>;
  deleteSettingsModule?: Maybe<DeleteSettingsModulePayload>;
  deleteSharedContactPerson?: Maybe<DeleteSharedContactPersonPayload>;
  deleteStorageFolder?: Maybe<DeleteStorageFolderPayload>;
  deleteTag?: Maybe<DeleteTagPayload>;
  deleteTravelLogConfiguration?: Maybe<DeleteTravelLogConfigurationPayload>;
  deleteTravelLogLog?: Maybe<DeleteTravelLogLogPayload>;
  deleteTravelLogModule?: Maybe<DeleteTravelLogModulePayload>;
  deleteTravelLogPlace?: Maybe<DeleteTravelLogPlacePayload>;
  deleteTravelLogPlacesDistance?: Maybe<DeleteTravelLogPlacesDistancePayload>;
  deleteTravelLogPrivateVehicle?: Maybe<DeleteTravelLogPrivateVehiclePayload>;
  deleteTravelLogRoute?: Maybe<DeleteTravelLogRoutePayload>;
  deleteTravelLogRouteReason?: Maybe<DeleteTravelLogRouteReasonPayload>;
  deleteTravelLogRouteTemp?: Maybe<DeleteTravelLogRouteTempPayload>;
  deleteTravelLogUserJourneyReason?: Maybe<DeleteTravelLogUserJourneyReasonPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteUserDevice?: Maybe<DeleteUserDevicePayload>;
  deleteVehicle?: Maybe<DeleteVehiclePayload>;
  deleteVersionRelease?: Maybe<DeleteVersionReleasePayload>;
  deleteWatchList?: Maybe<DeleteWatchListPayload>;
  dropboxUpload: Scalars['Int'];
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  generateTravelLogLog?: Maybe<GenerateTravelLogLogReturn>;
  initializeApprovalProcess?: Maybe<Scalars['Boolean']>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFile>>;
  register: UsersPermissionsLoginPayload;
  repairTravelLogSetupData?: Maybe<Scalars['Boolean']>;
  resetApprovalProcess?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  resolveDispute?: Maybe<ApprovalProcessUpdateReturn>;
  setMailStatus?: Maybe<ReceivedMail>;
  updateAbility?: Maybe<UpdateAbilityPayload>;
  updateAddress?: Maybe<UpdateAddressPayload>;
  updateAnnouncment?: Maybe<UpdateAnnouncmentPayload>;
  updateApprovalProcess?: Maybe<UpdateApprovalProcessPayload>;
  updateApprovalProcessDisputeResolutionOption?: Maybe<UpdateApprovalProcessDisputeResolutionOptionPayload>;
  updateApprovalStep?: Maybe<UpdateApprovalStepPayload>;
  updateAuditLogRecord?: Maybe<UpdateAuditLogRecordPayload>;
  updateCity?: Maybe<UpdateCityPayload>;
  updateComment?: Maybe<UpdateCommentPayload>;
  updateCompanyModule?: Maybe<UpdateCompanyModulePayload>;
  updateCompanyPartner?: Maybe<UpdateCompanyPartnerPayload>;
  updateDepartment?: Maybe<UpdateDepartmentPayload>;
  updateEvent?: Maybe<UpdateEventPayload>;
  updateFileInfo: UploadFile;
  updateHouse?: Maybe<UpdateHousePayload>;
  updateInvoice?: Maybe<UpdateInvoicePayload>;
  updateInvoiceReadModel?: Maybe<UpdateInvoiceReadModelPayload>;
  updateMailModule?: Maybe<UpdateMailModulePayload>;
  updateModelAbilities?: Maybe<UpdateModelAbilitiesReturn>;
  updateModelWatchList?: Maybe<WatchList>;
  updateNotification?: Maybe<UpdateNotificationPayload>;
  updateProject?: Maybe<UpdateProjectPayload>;
  updateReceivedMail?: Maybe<UpdateReceivedMailPayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  updateS3File?: Maybe<UpdateS3FilePayload>;
  updateSavedFilter?: Maybe<UpdateSavedFilterPayload>;
  updateSentMail?: Maybe<UpdateSentMailPayload>;
  updateServiceLog?: Maybe<UpdateServiceLogPayload>;
  updateSettingsModule?: Maybe<UpdateSettingsModulePayload>;
  updateSharedContactPerson?: Maybe<UpdateSharedContactPersonPayload>;
  updateStorageFolder?: Maybe<UpdateStorageFolderPayload>;
  updateTag?: Maybe<UpdateTagPayload>;
  updateTravelLogConfiguration?: Maybe<UpdateTravelLogConfigurationPayload>;
  updateTravelLogLog?: Maybe<UpdateTravelLogLogPayload>;
  updateTravelLogModule?: Maybe<UpdateTravelLogModulePayload>;
  updateTravelLogPlace?: Maybe<UpdateTravelLogPlacePayload>;
  updateTravelLogPlacesDistance?: Maybe<UpdateTravelLogPlacesDistancePayload>;
  updateTravelLogPrivateVehicle?: Maybe<UpdateTravelLogPrivateVehiclePayload>;
  updateTravelLogRoute?: Maybe<UpdateTravelLogRoutePayload>;
  updateTravelLogRouteReason?: Maybe<UpdateTravelLogRouteReasonPayload>;
  updateTravelLogRouteTemp?: Maybe<UpdateTravelLogRouteTempPayload>;
  updateTravelLogUserJourneyReason?: Maybe<UpdateTravelLogUserJourneyReasonPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserDevice?: Maybe<UpdateUserDevicePayload>;
  updateVehicle?: Maybe<UpdateVehiclePayload>;
  updateVersionRelease?: Maybe<UpdateVersionReleasePayload>;
  updateWatchList?: Maybe<UpdateWatchListPayload>;
  upload: UploadFile;
};


export type MutationAddEntityCommentArgs = {
  input: AddEntityCommentInput;
};


export type MutationApproveOrRejectApprovalStepArgs = {
  input?: InputMaybe<ApproveOrRejectApprovalStepInput>;
};


export type MutationCreatOrUpdateReadModelForInvoiceArgs = {
  id: Scalars['Int'];
};


export type MutationCreatOrUpdateReadModelForInvoicesArgs = {
  where: Scalars['JSON'];
};


export type MutationCreateAbilityArgs = {
  input?: InputMaybe<CreateAbilityInput>;
};


export type MutationCreateAddressArgs = {
  input?: InputMaybe<CreateAddressInput>;
};


export type MutationCreateAnnouncmentArgs = {
  input?: InputMaybe<CreateAnnouncmentInput>;
};


export type MutationCreateApprovalProcessArgs = {
  input?: InputMaybe<CreateApprovalProcessInput>;
};


export type MutationCreateApprovalProcessDisputeResolutionOptionArgs = {
  input?: InputMaybe<CreateApprovalProcessDisputeResolutionOptionInput>;
};


export type MutationCreateApprovalStepArgs = {
  input?: InputMaybe<CreateApprovalStepInput>;
};


export type MutationCreateAuditLogRecordArgs = {
  input?: InputMaybe<CreateAuditLogRecordInput>;
};


export type MutationCreateCityArgs = {
  input?: InputMaybe<CreateCityInput>;
};


export type MutationCreateCommentArgs = {
  input?: InputMaybe<CreateCommentInput>;
};


export type MutationCreateCompanyPartnerArgs = {
  input?: InputMaybe<CreateCompanyPartnerInput>;
};


export type MutationCreateDepartmentArgs = {
  input?: InputMaybe<CreateDepartmentInput>;
};


export type MutationCreateEventArgs = {
  input?: InputMaybe<CreateEventInput>;
};


export type MutationCreateHouseArgs = {
  input?: InputMaybe<CreateHouseInput>;
};


export type MutationCreateInvoiceArgs = {
  input?: InputMaybe<CreateInvoiceInput>;
};


export type MutationCreateInvoiceReadModelArgs = {
  input?: InputMaybe<CreateInvoiceReadModelInput>;
};


export type MutationCreateNotificationArgs = {
  input?: InputMaybe<CreateNotificationInput>;
};


export type MutationCreateProjectArgs = {
  input?: InputMaybe<CreateProjectInput>;
};


export type MutationCreateReceivedMailArgs = {
  input?: InputMaybe<CreateReceivedMailInput>;
};


export type MutationCreateRoleArgs = {
  input?: InputMaybe<CreateRoleInput>;
};


export type MutationCreateS3FileArgs = {
  input?: InputMaybe<CreateS3FileInput>;
};


export type MutationCreateSavedFilterArgs = {
  input?: InputMaybe<CreateSavedFilterInput>;
};


export type MutationCreateSentMailArgs = {
  input?: InputMaybe<CreateSentMailInput>;
};


export type MutationCreateServiceLogArgs = {
  input?: InputMaybe<CreateServiceLogInput>;
};


export type MutationCreateSharedContactPersonArgs = {
  input?: InputMaybe<CreateSharedContactPersonInput>;
};


export type MutationCreateStorageFolderArgs = {
  input?: InputMaybe<CreateStorageFolderInput>;
};


export type MutationCreateTagArgs = {
  input?: InputMaybe<CreateTagInput>;
};


export type MutationCreateTravelLogConfigurationArgs = {
  input?: InputMaybe<CreateTravelLogConfigurationInput>;
};


export type MutationCreateTravelLogLogArgs = {
  input?: InputMaybe<CreateTravelLogLogInput>;
};


export type MutationCreateTravelLogPlaceArgs = {
  input?: InputMaybe<CreateTravelLogPlaceInput>;
};


export type MutationCreateTravelLogPlacesDistanceArgs = {
  input?: InputMaybe<CreateTravelLogPlacesDistanceInput>;
};


export type MutationCreateTravelLogPrivateVehicleArgs = {
  input?: InputMaybe<CreateTravelLogPrivateVehicleInput>;
};


export type MutationCreateTravelLogRouteArgs = {
  input?: InputMaybe<CreateTravelLogRouteInput>;
};


export type MutationCreateTravelLogRouteReasonArgs = {
  input?: InputMaybe<CreateTravelLogRouteReasonInput>;
};


export type MutationCreateTravelLogRouteTempArgs = {
  input?: InputMaybe<CreateTravelLogRouteTempInput>;
};


export type MutationCreateTravelLogUserJourneyReasonArgs = {
  input?: InputMaybe<CreateTravelLogUserJourneyReasonInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationCreateUserDeviceArgs = {
  input?: InputMaybe<CreateUserDeviceInput>;
};


export type MutationCreateVehicleArgs = {
  input?: InputMaybe<CreateVehicleInput>;
};


export type MutationCreateVehicleRouteArgs = {
  input?: InputMaybe<CreateVehicleRouteInput>;
};


export type MutationCreateVersionReleaseArgs = {
  input?: InputMaybe<CreateVersionReleaseInput>;
};


export type MutationCreateWatchListArgs = {
  input?: InputMaybe<CreateWatchListInput>;
};


export type MutationDeleteAbilitiesArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type MutationDeleteAbilityArgs = {
  input?: InputMaybe<DeleteAbilityInput>;
};


export type MutationDeleteAddressArgs = {
  input?: InputMaybe<DeleteAddressInput>;
};


export type MutationDeleteAnnouncmentArgs = {
  input?: InputMaybe<DeleteAnnouncmentInput>;
};


export type MutationDeleteApprovalProcessArgs = {
  input?: InputMaybe<DeleteApprovalProcessInput>;
};


export type MutationDeleteApprovalProcessDisputeResolutionOptionArgs = {
  input?: InputMaybe<DeleteApprovalProcessDisputeResolutionOptionInput>;
};


export type MutationDeleteApprovalStepArgs = {
  input?: InputMaybe<DeleteApprovalStepInput>;
};


export type MutationDeleteAuditLogRecordArgs = {
  input?: InputMaybe<DeleteAuditLogRecordInput>;
};


export type MutationDeleteCityArgs = {
  input?: InputMaybe<DeleteCityInput>;
};


export type MutationDeleteCommentArgs = {
  input?: InputMaybe<DeleteCommentInput>;
};


export type MutationDeleteCompanyPartnerArgs = {
  input?: InputMaybe<DeleteCompanyPartnerInput>;
};


export type MutationDeleteDepartmentArgs = {
  input?: InputMaybe<DeleteDepartmentInput>;
};


export type MutationDeleteEventArgs = {
  input?: InputMaybe<DeleteEventInput>;
};


export type MutationDeleteFileArgs = {
  input?: InputMaybe<DeleteFileInput>;
};


export type MutationDeleteHouseArgs = {
  input?: InputMaybe<DeleteHouseInput>;
};


export type MutationDeleteInvoiceArgs = {
  input?: InputMaybe<DeleteInvoiceInput>;
};


export type MutationDeleteInvoiceReadModelArgs = {
  input?: InputMaybe<DeleteInvoiceReadModelInput>;
};


export type MutationDeleteNotificationArgs = {
  input?: InputMaybe<DeleteNotificationInput>;
};


export type MutationDeleteProjectArgs = {
  input?: InputMaybe<DeleteProjectInput>;
};


export type MutationDeleteReceivedMailArgs = {
  input?: InputMaybe<DeleteReceivedMailInput>;
};


export type MutationDeleteRoleArgs = {
  input?: InputMaybe<DeleteRoleInput>;
};


export type MutationDeleteS3FileArgs = {
  input?: InputMaybe<DeleteS3FileInput>;
};


export type MutationDeleteSavedFilterArgs = {
  input?: InputMaybe<DeleteSavedFilterInput>;
};


export type MutationDeleteSentMailArgs = {
  input?: InputMaybe<DeleteSentMailInput>;
};


export type MutationDeleteServiceLogArgs = {
  input?: InputMaybe<DeleteServiceLogInput>;
};


export type MutationDeleteSharedContactPersonArgs = {
  input?: InputMaybe<DeleteSharedContactPersonInput>;
};


export type MutationDeleteStorageFolderArgs = {
  input?: InputMaybe<DeleteStorageFolderInput>;
};


export type MutationDeleteTagArgs = {
  input?: InputMaybe<DeleteTagInput>;
};


export type MutationDeleteTravelLogConfigurationArgs = {
  input?: InputMaybe<DeleteTravelLogConfigurationInput>;
};


export type MutationDeleteTravelLogLogArgs = {
  input?: InputMaybe<DeleteTravelLogLogInput>;
};


export type MutationDeleteTravelLogPlaceArgs = {
  input?: InputMaybe<DeleteTravelLogPlaceInput>;
};


export type MutationDeleteTravelLogPlacesDistanceArgs = {
  input?: InputMaybe<DeleteTravelLogPlacesDistanceInput>;
};


export type MutationDeleteTravelLogPrivateVehicleArgs = {
  input?: InputMaybe<DeleteTravelLogPrivateVehicleInput>;
};


export type MutationDeleteTravelLogRouteArgs = {
  input?: InputMaybe<DeleteTravelLogRouteInput>;
};


export type MutationDeleteTravelLogRouteReasonArgs = {
  input?: InputMaybe<DeleteTravelLogRouteReasonInput>;
};


export type MutationDeleteTravelLogRouteTempArgs = {
  input?: InputMaybe<DeleteTravelLogRouteTempInput>;
};


export type MutationDeleteTravelLogUserJourneyReasonArgs = {
  input?: InputMaybe<DeleteTravelLogUserJourneyReasonInput>;
};


export type MutationDeleteUserArgs = {
  input?: InputMaybe<DeleteUserInput>;
};


export type MutationDeleteUserDeviceArgs = {
  input?: InputMaybe<DeleteUserDeviceInput>;
};


export type MutationDeleteVehicleArgs = {
  input?: InputMaybe<DeleteVehicleInput>;
};


export type MutationDeleteVersionReleaseArgs = {
  input?: InputMaybe<DeleteVersionReleaseInput>;
};


export type MutationDeleteWatchListArgs = {
  input?: InputMaybe<DeleteWatchListInput>;
};


export type MutationDropboxUploadArgs = {
  input?: InputMaybe<DropboxUploadInput>;
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenerateTravelLogLogArgs = {
  input: GenerateTravelLogLogInput;
};


export type MutationInitializeApprovalProcessArgs = {
  input?: InputMaybe<InitializeApprovalProcessInput>;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetApprovalProcessArgs = {
  input?: InputMaybe<ResetApprovalProcessInput>;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationResolveDisputeArgs = {
  input?: InputMaybe<ResolveDisputeInput>;
};


export type MutationSetMailStatusArgs = {
  input: SetMailStatusInput;
};


export type MutationUpdateAbilityArgs = {
  input?: InputMaybe<UpdateAbilityInput>;
};


export type MutationUpdateAddressArgs = {
  input?: InputMaybe<UpdateAddressInput>;
};


export type MutationUpdateAnnouncmentArgs = {
  input?: InputMaybe<UpdateAnnouncmentInput>;
};


export type MutationUpdateApprovalProcessArgs = {
  input?: InputMaybe<UpdateApprovalProcessInput>;
};


export type MutationUpdateApprovalProcessDisputeResolutionOptionArgs = {
  input?: InputMaybe<UpdateApprovalProcessDisputeResolutionOptionInput>;
};


export type MutationUpdateApprovalStepArgs = {
  input?: InputMaybe<UpdateApprovalStepInput>;
};


export type MutationUpdateAuditLogRecordArgs = {
  input?: InputMaybe<UpdateAuditLogRecordInput>;
};


export type MutationUpdateCityArgs = {
  input?: InputMaybe<UpdateCityInput>;
};


export type MutationUpdateCommentArgs = {
  input?: InputMaybe<UpdateCommentInput>;
};


export type MutationUpdateCompanyModuleArgs = {
  input?: InputMaybe<UpdateCompanyModuleInput>;
};


export type MutationUpdateCompanyPartnerArgs = {
  input?: InputMaybe<UpdateCompanyPartnerInput>;
};


export type MutationUpdateDepartmentArgs = {
  input?: InputMaybe<UpdateDepartmentInput>;
};


export type MutationUpdateEventArgs = {
  input?: InputMaybe<UpdateEventInput>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationUpdateHouseArgs = {
  input?: InputMaybe<UpdateHouseInput>;
};


export type MutationUpdateInvoiceArgs = {
  input?: InputMaybe<UpdateInvoiceInput>;
};


export type MutationUpdateInvoiceReadModelArgs = {
  input?: InputMaybe<UpdateInvoiceReadModelInput>;
};


export type MutationUpdateMailModuleArgs = {
  input?: InputMaybe<UpdateMailModuleInput>;
};


export type MutationUpdateModelAbilitiesArgs = {
  input?: InputMaybe<UpdateModelAbilitiesInput>;
};


export type MutationUpdateModelWatchListArgs = {
  input?: InputMaybe<UpdateModelWatchListInput>;
};


export type MutationUpdateNotificationArgs = {
  input?: InputMaybe<UpdateNotificationInput>;
};


export type MutationUpdateProjectArgs = {
  input?: InputMaybe<UpdateProjectInput>;
};


export type MutationUpdateReceivedMailArgs = {
  input?: InputMaybe<UpdateReceivedMailInput>;
};


export type MutationUpdateRoleArgs = {
  input?: InputMaybe<UpdateRoleInput>;
};


export type MutationUpdateS3FileArgs = {
  input?: InputMaybe<UpdateS3FileInput>;
};


export type MutationUpdateSavedFilterArgs = {
  input?: InputMaybe<UpdateSavedFilterInput>;
};


export type MutationUpdateSentMailArgs = {
  input?: InputMaybe<UpdateSentMailInput>;
};


export type MutationUpdateServiceLogArgs = {
  input?: InputMaybe<UpdateServiceLogInput>;
};


export type MutationUpdateSettingsModuleArgs = {
  input?: InputMaybe<UpdateSettingsModuleInput>;
};


export type MutationUpdateSharedContactPersonArgs = {
  input?: InputMaybe<UpdateSharedContactPersonInput>;
};


export type MutationUpdateStorageFolderArgs = {
  input?: InputMaybe<UpdateStorageFolderInput>;
};


export type MutationUpdateTagArgs = {
  input?: InputMaybe<UpdateTagInput>;
};


export type MutationUpdateTravelLogConfigurationArgs = {
  input?: InputMaybe<UpdateTravelLogConfigurationInput>;
};


export type MutationUpdateTravelLogLogArgs = {
  input?: InputMaybe<UpdateTravelLogLogInput>;
};


export type MutationUpdateTravelLogModuleArgs = {
  input?: InputMaybe<UpdateTravelLogModuleInput>;
};


export type MutationUpdateTravelLogPlaceArgs = {
  input?: InputMaybe<UpdateTravelLogPlaceInput>;
};


export type MutationUpdateTravelLogPlacesDistanceArgs = {
  input?: InputMaybe<UpdateTravelLogPlacesDistanceInput>;
};


export type MutationUpdateTravelLogPrivateVehicleArgs = {
  input?: InputMaybe<UpdateTravelLogPrivateVehicleInput>;
};


export type MutationUpdateTravelLogRouteArgs = {
  input?: InputMaybe<UpdateTravelLogRouteInput>;
};


export type MutationUpdateTravelLogRouteReasonArgs = {
  input?: InputMaybe<UpdateTravelLogRouteReasonInput>;
};


export type MutationUpdateTravelLogRouteTempArgs = {
  input?: InputMaybe<UpdateTravelLogRouteTempInput>;
};


export type MutationUpdateTravelLogUserJourneyReasonArgs = {
  input?: InputMaybe<UpdateTravelLogUserJourneyReasonInput>;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateUserDeviceArgs = {
  input?: InputMaybe<UpdateUserDeviceInput>;
};


export type MutationUpdateVehicleArgs = {
  input?: InputMaybe<UpdateVehicleInput>;
};


export type MutationUpdateVersionReleaseArgs = {
  input?: InputMaybe<UpdateVersionReleaseInput>;
};


export type MutationUpdateWatchListArgs = {
  input?: InputMaybe<UpdateWatchListInput>;
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
};

export type MyFiltersWhereInput = {
  targetModelName: Scalars['String'];
};

export type Notification = {
  __typename?: 'Notification';
  created_at: Scalars['DateTime'];
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<ComponentNotificationTags>>>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Notification_Type>;
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
};

export type NotificationAggregator = {
  __typename?: 'NotificationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  aggregate?: Maybe<NotificationAggregator>;
  groupBy?: Maybe<NotificationGroupBy>;
  values?: Maybe<Array<Maybe<Notification>>>;
};

export type NotificationConnectionCreated_At = {
  __typename?: 'NotificationConnectionCreated_at';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type NotificationConnectionData = {
  __typename?: 'NotificationConnectionData';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type NotificationConnectionDescription = {
  __typename?: 'NotificationConnectionDescription';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['String']>;
};

export type NotificationConnectionId = {
  __typename?: 'NotificationConnectionId';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type NotificationConnectionRead = {
  __typename?: 'NotificationConnectionRead';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type NotificationConnectionTitle = {
  __typename?: 'NotificationConnectionTitle';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['String']>;
};

export type NotificationConnectionType = {
  __typename?: 'NotificationConnectionType';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['String']>;
};

export type NotificationConnectionUpdated_At = {
  __typename?: 'NotificationConnectionUpdated_at';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type NotificationConnectionUser = {
  __typename?: 'NotificationConnectionUser';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type NotificationGroupBy = {
  __typename?: 'NotificationGroupBy';
  created_at?: Maybe<Array<Maybe<NotificationConnectionCreated_At>>>;
  data?: Maybe<Array<Maybe<NotificationConnectionData>>>;
  description?: Maybe<Array<Maybe<NotificationConnectionDescription>>>;
  id?: Maybe<Array<Maybe<NotificationConnectionId>>>;
  read?: Maybe<Array<Maybe<NotificationConnectionRead>>>;
  title?: Maybe<Array<Maybe<NotificationConnectionTitle>>>;
  type?: Maybe<Array<Maybe<NotificationConnectionType>>>;
  updated_at?: Maybe<Array<Maybe<NotificationConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<NotificationConnectionUser>>>;
};

export type NotificationInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  read?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<ComponentNotificationTagInput>>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Notification_Type>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type Project = {
  __typename?: 'Project';
  created_at: Scalars['DateTime'];
  department?: Maybe<Department>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceMaxSumAllowedForProjectManager?: Maybe<Scalars['Float']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  mainManager?: Maybe<UsersPermissionsUser>;
  managers?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  name?: Maybe<Scalars['String']>;
  partner?: Maybe<CompanyPartner>;
  projectNumber?: Maybe<Scalars['String']>;
  received_mails?: Maybe<Array<Maybe<ReceivedMail>>>;
  updated_at: Scalars['DateTime'];
};


export type ProjectInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type ProjectManagersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type ProjectReceived_MailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type ProjectAggregator = {
  __typename?: 'ProjectAggregator';
  avg?: Maybe<ProjectAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<ProjectAggregatorMax>;
  min?: Maybe<ProjectAggregatorMin>;
  sum?: Maybe<ProjectAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProjectAggregatorAvg = {
  __typename?: 'ProjectAggregatorAvg';
  invoiceMaxSumAllowedForProjectManager?: Maybe<Scalars['Float']>;
};

export type ProjectAggregatorMax = {
  __typename?: 'ProjectAggregatorMax';
  invoiceMaxSumAllowedForProjectManager?: Maybe<Scalars['Float']>;
};

export type ProjectAggregatorMin = {
  __typename?: 'ProjectAggregatorMin';
  invoiceMaxSumAllowedForProjectManager?: Maybe<Scalars['Float']>;
};

export type ProjectAggregatorSum = {
  __typename?: 'ProjectAggregatorSum';
  invoiceMaxSumAllowedForProjectManager?: Maybe<Scalars['Float']>;
};

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  aggregate?: Maybe<ProjectAggregator>;
  groupBy?: Maybe<ProjectGroupBy>;
  values?: Maybe<Array<Maybe<Project>>>;
};

export type ProjectConnectionCreated_At = {
  __typename?: 'ProjectConnectionCreated_at';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ProjectConnectionDepartment = {
  __typename?: 'ProjectConnectionDepartment';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ProjectConnectionDescription = {
  __typename?: 'ProjectConnectionDescription';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ProjectConnectionId = {
  __typename?: 'ProjectConnectionId';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ProjectConnectionInvoiceMaxSumAllowedForProjectManager = {
  __typename?: 'ProjectConnectionInvoiceMaxSumAllowedForProjectManager';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type ProjectConnectionMainManager = {
  __typename?: 'ProjectConnectionMainManager';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ProjectConnectionName = {
  __typename?: 'ProjectConnectionName';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ProjectConnectionPartner = {
  __typename?: 'ProjectConnectionPartner';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ProjectConnectionProjectNumber = {
  __typename?: 'ProjectConnectionProjectNumber';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ProjectConnectionUpdated_At = {
  __typename?: 'ProjectConnectionUpdated_at';
  connection?: Maybe<ProjectConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ProjectGroupBy = {
  __typename?: 'ProjectGroupBy';
  created_at?: Maybe<Array<Maybe<ProjectConnectionCreated_At>>>;
  department?: Maybe<Array<Maybe<ProjectConnectionDepartment>>>;
  description?: Maybe<Array<Maybe<ProjectConnectionDescription>>>;
  id?: Maybe<Array<Maybe<ProjectConnectionId>>>;
  invoiceMaxSumAllowedForProjectManager?: Maybe<Array<Maybe<ProjectConnectionInvoiceMaxSumAllowedForProjectManager>>>;
  mainManager?: Maybe<Array<Maybe<ProjectConnectionMainManager>>>;
  name?: Maybe<Array<Maybe<ProjectConnectionName>>>;
  partner?: Maybe<Array<Maybe<ProjectConnectionPartner>>>;
  projectNumber?: Maybe<Array<Maybe<ProjectConnectionProjectNumber>>>;
  updated_at?: Maybe<Array<Maybe<ProjectConnectionUpdated_At>>>;
};

export type ProjectInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  department?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  invoiceMaxSumAllowedForProjectManager?: InputMaybe<Scalars['Float']>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  mainManager?: InputMaybe<Scalars['ID']>;
  managers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['ID']>;
  projectNumber?: InputMaybe<Scalars['String']>;
  received_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  abilities?: Maybe<Array<Maybe<Ability>>>;
  abilitiesConnection?: Maybe<AbilityConnection>;
  abilitiesCount: Scalars['Int'];
  ability?: Maybe<Ability>;
  address?: Maybe<Address>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  addressesConnection?: Maybe<AddressConnection>;
  announcment?: Maybe<Announcment>;
  announcments?: Maybe<Array<Maybe<Announcment>>>;
  announcmentsConnection?: Maybe<AnnouncmentConnection>;
  approvalProcess?: Maybe<ApprovalProcess>;
  approvalProcessDisputeResolutionOption?: Maybe<ApprovalProcessDisputeResolutionOption>;
  approvalProcessDisputeResolutionOptions?: Maybe<Array<Maybe<ApprovalProcessDisputeResolutionOption>>>;
  approvalProcessDisputeResolutionOptionsConnection?: Maybe<ApprovalProcessDisputeResolutionOptionConnection>;
  approvalProcesses?: Maybe<Array<Maybe<ApprovalProcess>>>;
  approvalProcessesConnection?: Maybe<ApprovalProcessConnection>;
  approvalStep?: Maybe<ApprovalStep>;
  approvalSteps?: Maybe<Array<Maybe<ApprovalStep>>>;
  approvalStepsConnection?: Maybe<ApprovalStepConnection>;
  approvalStepsCount: Scalars['Int'];
  auditLogRecord?: Maybe<AuditLogRecord>;
  auditLogRecords?: Maybe<Array<Maybe<AuditLogRecord>>>;
  auditLogRecordsConnection?: Maybe<AuditLogRecordConnection>;
  auditLogRecordsCount: Scalars['Int'];
  cities?: Maybe<Array<Maybe<City>>>;
  citiesConnection?: Maybe<CityConnection>;
  city?: Maybe<City>;
  comment?: Maybe<Comment>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  commentsConnection?: Maybe<CommentConnection>;
  companyModule?: Maybe<CompanyModule>;
  companyPartner?: Maybe<CompanyPartner>;
  companyPartners?: Maybe<Array<Maybe<CompanyPartner>>>;
  companyPartnersConnection?: Maybe<CompanyPartnerConnection>;
  companyPartnersCount: Scalars['Int'];
  department?: Maybe<Department>;
  departments?: Maybe<Array<Maybe<Department>>>;
  departmentsConnection?: Maybe<DepartmentConnection>;
  departmentsCount: Scalars['Int'];
  differenceInApprovedInvoicesAndDropboxFiles?: Maybe<Array<Maybe<Scalars['String']>>>;
  dropboxListFolderFiles?: Maybe<Array<Maybe<DropboxFolderItem>>>;
  entityWatchList?: Maybe<WatchList>;
  event?: Maybe<Event>;
  events?: Maybe<Array<Maybe<Event>>>;
  eventsConnection?: Maybe<EventConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  getUsersSimple: Array<Maybe<UserSimple>>;
  house?: Maybe<House>;
  houses?: Maybe<Array<Maybe<House>>>;
  housesConnection?: Maybe<HouseConnection>;
  housesCount: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceReadModel?: Maybe<InvoiceReadModel>;
  invoiceReadModelCount: Scalars['Int'];
  invoiceReadModels?: Maybe<Array<Maybe<InvoiceReadModel>>>;
  invoiceReadModelsConnection?: Maybe<InvoiceReadModelConnection>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  invoicesConnection?: Maybe<InvoiceConnection>;
  invoicesCount: Scalars['Int'];
  mailModule?: Maybe<MailModule>;
  me?: Maybe<UsersPermissionsMe>;
  myAbilities: Array<Maybe<Ability>>;
  myFilters: Array<Maybe<SavedFilter>>;
  myNotifications?: Maybe<Array<Maybe<Notification>>>;
  myNotificationsCount: Scalars['Int'];
  notification?: Maybe<Notification>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  notificationsConnection?: Maybe<NotificationConnection>;
  notificationsCount: Scalars['Int'];
  project?: Maybe<Project>;
  projects?: Maybe<Array<Maybe<Project>>>;
  projectsConnection?: Maybe<ProjectConnection>;
  projectsCount: Scalars['Int'];
  receivedMail?: Maybe<ReceivedMail>;
  receivedMails?: Maybe<Array<Maybe<ReceivedMail>>>;
  receivedMailsConnection?: Maybe<ReceivedMailConnection>;
  receivedMailsCount: Scalars['Int'];
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  s3File?: Maybe<S3File>;
  s3Files?: Maybe<Array<Maybe<S3File>>>;
  s3FilesConnection?: Maybe<S3FileConnection>;
  savedFilter?: Maybe<SavedFilter>;
  savedFilters?: Maybe<Array<Maybe<SavedFilter>>>;
  savedFiltersConnection?: Maybe<SavedFilterConnection>;
  sentMail?: Maybe<SentMail>;
  sentMails?: Maybe<Array<Maybe<SentMail>>>;
  sentMailsConnection?: Maybe<SentMailConnection>;
  serviceLog?: Maybe<ServiceLog>;
  serviceLogs?: Maybe<Array<Maybe<ServiceLog>>>;
  serviceLogsConnection?: Maybe<ServiceLogConnection>;
  serviceLogsCount: Scalars['Int'];
  settingsModule?: Maybe<SettingsModule>;
  sharedContactPeople?: Maybe<Array<Maybe<SharedContactPerson>>>;
  sharedContactPeopleConnection?: Maybe<SharedContactPersonConnection>;
  sharedContactPerson?: Maybe<SharedContactPerson>;
  storageFolder?: Maybe<StorageFolder>;
  storageFolders?: Maybe<Array<Maybe<StorageFolder>>>;
  storageFoldersConnection?: Maybe<StorageFolderConnection>;
  tag?: Maybe<Tags>;
  tags?: Maybe<Array<Maybe<Tags>>>;
  tagsConnection?: Maybe<TagsConnection>;
  travelLogConfiguration?: Maybe<TravelLogConfiguration>;
  travelLogConfigurations?: Maybe<Array<Maybe<TravelLogConfiguration>>>;
  travelLogConfigurationsConnection?: Maybe<TravelLogConfigurationConnection>;
  travelLogLog?: Maybe<TravelLogLog>;
  travelLogLogs?: Maybe<Array<Maybe<TravelLogLog>>>;
  travelLogLogsConnection?: Maybe<TravelLogLogConnection>;
  travelLogLogsCount: Scalars['Int'];
  travelLogModule?: Maybe<TravelLogModule>;
  travelLogPlace?: Maybe<TravelLogPlace>;
  travelLogPlaces?: Maybe<Array<Maybe<TravelLogPlace>>>;
  travelLogPlacesConnection?: Maybe<TravelLogPlaceConnection>;
  travelLogPlacesCount: Scalars['Int'];
  travelLogPlacesDistance?: Maybe<TravelLogPlacesDistance>;
  travelLogPlacesDistances?: Maybe<Array<Maybe<TravelLogPlacesDistance>>>;
  travelLogPlacesDistancesConnection?: Maybe<TravelLogPlacesDistanceConnection>;
  travelLogPlacesDistancesCount: Scalars['Int'];
  travelLogPrivateVehicle?: Maybe<TravelLogPrivateVehicle>;
  travelLogPrivateVehicles?: Maybe<Array<Maybe<TravelLogPrivateVehicle>>>;
  travelLogPrivateVehiclesConnection?: Maybe<TravelLogPrivateVehicleConnection>;
  travelLogPrivateVehiclesCount: Scalars['Int'];
  travelLogRoute?: Maybe<TravelLogRoute>;
  travelLogRouteReason?: Maybe<TravelLogRouteReason>;
  travelLogRouteReasons?: Maybe<Array<Maybe<TravelLogRouteReason>>>;
  travelLogRouteReasonsConnection?: Maybe<TravelLogRouteReasonConnection>;
  travelLogRouteTemp?: Maybe<TravelLogRouteTemp>;
  travelLogRouteTemps?: Maybe<Array<Maybe<TravelLogRouteTemp>>>;
  travelLogRouteTempsConnection?: Maybe<TravelLogRouteTempConnection>;
  travelLogRoutes?: Maybe<Array<Maybe<TravelLogRoute>>>;
  travelLogRoutesConnection?: Maybe<TravelLogRouteConnection>;
  travelLogUserJourneyReason?: Maybe<TravelLogUserJourneyReason>;
  travelLogUserJourneyReasons?: Maybe<Array<Maybe<TravelLogUserJourneyReason>>>;
  travelLogUserJourneyReasonsConnection?: Maybe<TravelLogUserJourneyReasonConnection>;
  travelLogUserJourneyReasonsCount: Scalars['Int'];
  user?: Maybe<UsersPermissionsUser>;
  userDevice?: Maybe<UserDevice>;
  userDevices?: Maybe<Array<Maybe<UserDevice>>>;
  userDevicesConnection?: Maybe<UserDeviceConnection>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  vehicle?: Maybe<Vehicle>;
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  vehiclesConnection?: Maybe<VehicleConnection>;
  vehiclesCount: Scalars['Int'];
  versionRelease?: Maybe<VersionRelease>;
  versionReleases?: Maybe<Array<Maybe<VersionRelease>>>;
  versionReleasesConnection?: Maybe<VersionReleaseConnection>;
  watchList?: Maybe<WatchList>;
  watchLists?: Maybe<Array<Maybe<WatchList>>>;
  watchListsConnection?: Maybe<WatchListConnection>;
};


export type QueryAbilitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryAbilitiesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryAbilitiesCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryAbilityArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryAddressArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryAddressesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryAddressesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryAnnouncmentArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryAnnouncmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryAnnouncmentsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryApprovalProcessArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryApprovalProcessDisputeResolutionOptionArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryApprovalProcessDisputeResolutionOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryApprovalProcessDisputeResolutionOptionsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryApprovalProcessesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryApprovalProcessesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryApprovalStepArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryApprovalStepsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryApprovalStepsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryApprovalStepsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryAuditLogRecordArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryAuditLogRecordsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryAuditLogRecordsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryAuditLogRecordsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryCitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryCitiesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryCityArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryCommentArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryCommentsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryCompanyModuleArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryCompanyPartnerArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryCompanyPartnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryCompanyPartnersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryCompanyPartnersCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryDepartmentArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryDepartmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryDepartmentsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryDepartmentsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryDropboxListFolderFilesArgs = {
  input: DropboxListFolderFilesInput;
};


export type QueryEntityWatchListArgs = {
  input?: InputMaybe<TargetEntityDefinitionInput>;
};


export type QueryEventArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryEventsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryFilesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetUsersSimpleArgs = {
  where?: InputMaybe<UsersSimpleWhereInput>;
};


export type QueryHouseArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryHousesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryHousesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryHousesCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryInvoiceReadModelArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryInvoiceReadModelCountArgs = {
  where: Scalars['JSON'];
};


export type QueryInvoiceReadModelsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryInvoiceReadModelsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryInvoicesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryInvoicesCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryMailModuleArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryMyFiltersArgs = {
  where?: InputMaybe<MyFiltersWhereInput>;
};


export type QueryMyNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryMyNotificationsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryNotificationsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryNotificationsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryProjectArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryProjectsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryProjectsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryReceivedMailArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryReceivedMailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryReceivedMailsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryReceivedMailsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryRolesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryRolesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryS3FileArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryS3FilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryS3FilesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QuerySavedFilterArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QuerySavedFiltersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QuerySavedFiltersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QuerySentMailArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QuerySentMailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QuerySentMailsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryServiceLogArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryServiceLogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryServiceLogsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryServiceLogsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QuerySettingsModuleArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QuerySharedContactPeopleArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QuerySharedContactPeopleConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QuerySharedContactPersonArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryStorageFolderArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryStorageFoldersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryStorageFoldersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTagArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTagsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogConfigurationArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogConfigurationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogConfigurationsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogLogArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogLogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogLogsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogLogsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogModuleArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogPlaceArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogPlacesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogPlacesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogPlacesCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogPlacesDistanceArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogPlacesDistancesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogPlacesDistancesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogPlacesDistancesCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogPrivateVehicleArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogPrivateVehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogPrivateVehiclesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogPrivateVehiclesCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogRouteArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogRouteReasonArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogRouteReasonsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogRouteReasonsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogRouteTempArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogRouteTempsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogRouteTempsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogRoutesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogRoutesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogUserJourneyReasonArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTravelLogUserJourneyReasonsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogUserJourneyReasonsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTravelLogUserJourneyReasonsCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryUserDeviceArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryUserDevicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryUserDevicesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryUsersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryVehicleArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryVehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryVehiclesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryVehiclesCountArgs = {
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryVersionReleaseArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryVersionReleasesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryVersionReleasesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryWatchListArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryWatchListsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryWatchListsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type Reason = {
  __typename?: 'Reason';
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<CreatedBy>;
  durationFrom?: Maybe<Scalars['String']>;
  durationInHoursFrom?: Maybe<Scalars['Int']>;
  durationInHoursTo?: Maybe<Scalars['Int']>;
  durationInSecondsFrom?: Maybe<Scalars['String']>;
  durationInSecondsTo?: Maybe<Scalars['String']>;
  durationTo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  takesSecondsRangeEnd?: Maybe<Scalars['String']>;
  takesSeondsRangeStart?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_by?: Maybe<UpdatedBy>;
  users_permissions_user?: Maybe<Scalars['String']>;
};

export type Reasons = {
  __typename?: 'Reasons';
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['Int']>;
  durationFrom?: Maybe<Scalars['String']>;
  durationInHoursFrom?: Maybe<Scalars['Int']>;
  durationInHoursTo?: Maybe<Scalars['Int']>;
  durationInSecondsFrom?: Maybe<Scalars['String']>;
  durationInSecondsTo?: Maybe<Scalars['String']>;
  durationTo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  takesSecondsRangeEnd?: Maybe<Scalars['String']>;
  takesSeondsRangeStart?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<Scalars['String']>;
};

export type ReceivedMail = {
  __typename?: 'ReceivedMail';
  archived?: Maybe<Scalars['Boolean']>;
  assignee?: Maybe<UsersPermissionsUser>;
  attachements?: Maybe<Array<Maybe<S3File>>>;
  contents: Enum_Receivedmail_Contents;
  created_at: Scalars['DateTime'];
  dateReceived?: Maybe<Scalars['Date']>;
  department?: Maybe<Department>;
  id: Scalars['ID'];
  invoice?: Maybe<Invoice>;
  note?: Maybe<Scalars['String']>;
  previousNumber?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  processed?: Maybe<Scalars['Boolean']>;
  project?: Maybe<Project>;
  senderAddress?: Maybe<Address>;
  senderPartner?: Maybe<CompanyPartner>;
  status?: Maybe<Enum_Receivedmail_Status>;
  typeOfDelivery: Enum_Receivedmail_Typeofdelivery;
  updated_at: Scalars['DateTime'];
};


export type ReceivedMailAttachementsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type ReceivedMailAggregator = {
  __typename?: 'ReceivedMailAggregator';
  avg?: Maybe<ReceivedMailAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<ReceivedMailAggregatorMax>;
  min?: Maybe<ReceivedMailAggregatorMin>;
  sum?: Maybe<ReceivedMailAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ReceivedMailAggregatorAvg = {
  __typename?: 'ReceivedMailAggregatorAvg';
  priority?: Maybe<Scalars['Float']>;
};

export type ReceivedMailAggregatorMax = {
  __typename?: 'ReceivedMailAggregatorMax';
  priority?: Maybe<Scalars['Float']>;
};

export type ReceivedMailAggregatorMin = {
  __typename?: 'ReceivedMailAggregatorMin';
  priority?: Maybe<Scalars['Float']>;
};

export type ReceivedMailAggregatorSum = {
  __typename?: 'ReceivedMailAggregatorSum';
  priority?: Maybe<Scalars['Float']>;
};

export type ReceivedMailConnection = {
  __typename?: 'ReceivedMailConnection';
  aggregate?: Maybe<ReceivedMailAggregator>;
  groupBy?: Maybe<ReceivedMailGroupBy>;
  values?: Maybe<Array<Maybe<ReceivedMail>>>;
};

export type ReceivedMailConnectionArchived = {
  __typename?: 'ReceivedMailConnectionArchived';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type ReceivedMailConnectionAssignee = {
  __typename?: 'ReceivedMailConnectionAssignee';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ReceivedMailConnectionContents = {
  __typename?: 'ReceivedMailConnectionContents';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ReceivedMailConnectionCreated_At = {
  __typename?: 'ReceivedMailConnectionCreated_at';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ReceivedMailConnectionDateReceived = {
  __typename?: 'ReceivedMailConnectionDateReceived';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ReceivedMailConnectionDepartment = {
  __typename?: 'ReceivedMailConnectionDepartment';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ReceivedMailConnectionId = {
  __typename?: 'ReceivedMailConnectionId';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ReceivedMailConnectionInvoice = {
  __typename?: 'ReceivedMailConnectionInvoice';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ReceivedMailConnectionNote = {
  __typename?: 'ReceivedMailConnectionNote';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ReceivedMailConnectionPreviousNumber = {
  __typename?: 'ReceivedMailConnectionPreviousNumber';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ReceivedMailConnectionPriority = {
  __typename?: 'ReceivedMailConnectionPriority';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type ReceivedMailConnectionProcessed = {
  __typename?: 'ReceivedMailConnectionProcessed';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type ReceivedMailConnectionProject = {
  __typename?: 'ReceivedMailConnectionProject';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ReceivedMailConnectionSenderAddress = {
  __typename?: 'ReceivedMailConnectionSenderAddress';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ReceivedMailConnectionSenderPartner = {
  __typename?: 'ReceivedMailConnectionSenderPartner';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ReceivedMailConnectionStatus = {
  __typename?: 'ReceivedMailConnectionStatus';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ReceivedMailConnectionTypeOfDelivery = {
  __typename?: 'ReceivedMailConnectionTypeOfDelivery';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ReceivedMailConnectionUpdated_At = {
  __typename?: 'ReceivedMailConnectionUpdated_at';
  connection?: Maybe<ReceivedMailConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ReceivedMailGroupBy = {
  __typename?: 'ReceivedMailGroupBy';
  archived?: Maybe<Array<Maybe<ReceivedMailConnectionArchived>>>;
  assignee?: Maybe<Array<Maybe<ReceivedMailConnectionAssignee>>>;
  contents?: Maybe<Array<Maybe<ReceivedMailConnectionContents>>>;
  created_at?: Maybe<Array<Maybe<ReceivedMailConnectionCreated_At>>>;
  dateReceived?: Maybe<Array<Maybe<ReceivedMailConnectionDateReceived>>>;
  department?: Maybe<Array<Maybe<ReceivedMailConnectionDepartment>>>;
  id?: Maybe<Array<Maybe<ReceivedMailConnectionId>>>;
  invoice?: Maybe<Array<Maybe<ReceivedMailConnectionInvoice>>>;
  note?: Maybe<Array<Maybe<ReceivedMailConnectionNote>>>;
  previousNumber?: Maybe<Array<Maybe<ReceivedMailConnectionPreviousNumber>>>;
  priority?: Maybe<Array<Maybe<ReceivedMailConnectionPriority>>>;
  processed?: Maybe<Array<Maybe<ReceivedMailConnectionProcessed>>>;
  project?: Maybe<Array<Maybe<ReceivedMailConnectionProject>>>;
  senderAddress?: Maybe<Array<Maybe<ReceivedMailConnectionSenderAddress>>>;
  senderPartner?: Maybe<Array<Maybe<ReceivedMailConnectionSenderPartner>>>;
  status?: Maybe<Array<Maybe<ReceivedMailConnectionStatus>>>;
  typeOfDelivery?: Maybe<Array<Maybe<ReceivedMailConnectionTypeOfDelivery>>>;
  updated_at?: Maybe<Array<Maybe<ReceivedMailConnectionUpdated_At>>>;
};

export type ReceivedMailInput = {
  abilities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignee?: InputMaybe<Scalars['ID']>;
  attachements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contents?: InputMaybe<Enum_Receivedmail_Contents>;
  created_by?: InputMaybe<Scalars['ID']>;
  dateReceived?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  previousNumber?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  processed?: InputMaybe<Scalars['Boolean']>;
  project?: InputMaybe<Scalars['ID']>;
  senderAddress?: InputMaybe<Scalars['ID']>;
  senderPartner?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Receivedmail_Status>;
  typeOfDelivery?: InputMaybe<Enum_Receivedmail_Typeofdelivery>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type ResetApprovalProcessInput = {
  targetModelId: Scalars['String'];
  targetModelName: ApprovalProcessSupportedModels;
};

export type ResolveDisputeInput = {
  note?: InputMaybe<Scalars['String']>;
  reinitializeApprovalProcess?: InputMaybe<Scalars['Boolean']>;
  resolution?: InputMaybe<Scalars['String']>;
  stepId: Scalars['String'];
};

export type RoleInput = {
  abilities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type S3File = {
  __typename?: 'S3File';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sent_mail?: Maybe<SentMail>;
  storage_folder?: Maybe<StorageFolder>;
  targetModelId?: Maybe<Scalars['String']>;
  targetModelName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  uploadedAt?: Maybe<Scalars['DateTime']>;
};

export type S3FileAggregator = {
  __typename?: 'S3FileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type S3FileConnection = {
  __typename?: 'S3FileConnection';
  aggregate?: Maybe<S3FileAggregator>;
  groupBy?: Maybe<S3FileGroupBy>;
  values?: Maybe<Array<Maybe<S3File>>>;
};

export type S3FileConnectionCreated_At = {
  __typename?: 'S3FileConnectionCreated_at';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type S3FileConnectionId = {
  __typename?: 'S3FileConnectionId';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type S3FileConnectionKey = {
  __typename?: 'S3FileConnectionKey';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type S3FileConnectionName = {
  __typename?: 'S3FileConnectionName';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type S3FileConnectionSent_Mail = {
  __typename?: 'S3FileConnectionSent_mail';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type S3FileConnectionStorage_Folder = {
  __typename?: 'S3FileConnectionStorage_folder';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type S3FileConnectionTargetModelId = {
  __typename?: 'S3FileConnectionTargetModelId';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type S3FileConnectionTargetModelName = {
  __typename?: 'S3FileConnectionTargetModelName';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type S3FileConnectionType = {
  __typename?: 'S3FileConnectionType';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type S3FileConnectionUpdated_At = {
  __typename?: 'S3FileConnectionUpdated_at';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type S3FileConnectionUploadedAt = {
  __typename?: 'S3FileConnectionUploadedAt';
  connection?: Maybe<S3FileConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type S3FileGroupBy = {
  __typename?: 'S3FileGroupBy';
  created_at?: Maybe<Array<Maybe<S3FileConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<S3FileConnectionId>>>;
  key?: Maybe<Array<Maybe<S3FileConnectionKey>>>;
  name?: Maybe<Array<Maybe<S3FileConnectionName>>>;
  sent_mail?: Maybe<Array<Maybe<S3FileConnectionSent_Mail>>>;
  storage_folder?: Maybe<Array<Maybe<S3FileConnectionStorage_Folder>>>;
  targetModelId?: Maybe<Array<Maybe<S3FileConnectionTargetModelId>>>;
  targetModelName?: Maybe<Array<Maybe<S3FileConnectionTargetModelName>>>;
  type?: Maybe<Array<Maybe<S3FileConnectionType>>>;
  updated_at?: Maybe<Array<Maybe<S3FileConnectionUpdated_At>>>;
  uploadedAt?: Maybe<Array<Maybe<S3FileConnectionUploadedAt>>>;
};

export type S3FileInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sent_mail?: InputMaybe<Scalars['ID']>;
  storage_folder?: InputMaybe<Scalars['ID']>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SavedFilter = {
  __typename?: 'SavedFilter';
  archived?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['DateTime'];
  filters?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  targetModelName?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
};

export type SavedFilterAggregator = {
  __typename?: 'SavedFilterAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SavedFilterConnection = {
  __typename?: 'SavedFilterConnection';
  aggregate?: Maybe<SavedFilterAggregator>;
  groupBy?: Maybe<SavedFilterGroupBy>;
  values?: Maybe<Array<Maybe<SavedFilter>>>;
};

export type SavedFilterConnectionArchived = {
  __typename?: 'SavedFilterConnectionArchived';
  connection?: Maybe<SavedFilterConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type SavedFilterConnectionCreated_At = {
  __typename?: 'SavedFilterConnectionCreated_at';
  connection?: Maybe<SavedFilterConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SavedFilterConnectionFilters = {
  __typename?: 'SavedFilterConnectionFilters';
  connection?: Maybe<SavedFilterConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type SavedFilterConnectionId = {
  __typename?: 'SavedFilterConnectionId';
  connection?: Maybe<SavedFilterConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SavedFilterConnectionName = {
  __typename?: 'SavedFilterConnectionName';
  connection?: Maybe<SavedFilterConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SavedFilterConnectionTargetModelName = {
  __typename?: 'SavedFilterConnectionTargetModelName';
  connection?: Maybe<SavedFilterConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SavedFilterConnectionUpdated_At = {
  __typename?: 'SavedFilterConnectionUpdated_at';
  connection?: Maybe<SavedFilterConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SavedFilterConnectionUser = {
  __typename?: 'SavedFilterConnectionUser';
  connection?: Maybe<SavedFilterConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SavedFilterGroupBy = {
  __typename?: 'SavedFilterGroupBy';
  archived?: Maybe<Array<Maybe<SavedFilterConnectionArchived>>>;
  created_at?: Maybe<Array<Maybe<SavedFilterConnectionCreated_At>>>;
  filters?: Maybe<Array<Maybe<SavedFilterConnectionFilters>>>;
  id?: Maybe<Array<Maybe<SavedFilterConnectionId>>>;
  name?: Maybe<Array<Maybe<SavedFilterConnectionName>>>;
  targetModelName?: Maybe<Array<Maybe<SavedFilterConnectionTargetModelName>>>;
  updated_at?: Maybe<Array<Maybe<SavedFilterConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<SavedFilterConnectionUser>>>;
};

export type SavedFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type SentMail = {
  __typename?: 'SentMail';
  archived?: Maybe<Scalars['Boolean']>;
  assignee?: Maybe<UsersPermissionsUser>;
  attachments?: Maybe<Array<Maybe<S3File>>>;
  contents?: Maybe<Enum_Sentmail_Contents>;
  created_at: Scalars['DateTime'];
  dateSent?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  recipientAddress?: Maybe<Address>;
  recipientPartner?: Maybe<CompanyPartner>;
  updated_at: Scalars['DateTime'];
};


export type SentMailAttachmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type SentMailAggregator = {
  __typename?: 'SentMailAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SentMailConnection = {
  __typename?: 'SentMailConnection';
  aggregate?: Maybe<SentMailAggregator>;
  groupBy?: Maybe<SentMailGroupBy>;
  values?: Maybe<Array<Maybe<SentMail>>>;
};

export type SentMailConnectionArchived = {
  __typename?: 'SentMailConnectionArchived';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type SentMailConnectionAssignee = {
  __typename?: 'SentMailConnectionAssignee';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SentMailConnectionContents = {
  __typename?: 'SentMailConnectionContents';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SentMailConnectionCreated_At = {
  __typename?: 'SentMailConnectionCreated_at';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SentMailConnectionDateSent = {
  __typename?: 'SentMailConnectionDateSent';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SentMailConnectionId = {
  __typename?: 'SentMailConnectionId';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SentMailConnectionNote = {
  __typename?: 'SentMailConnectionNote';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SentMailConnectionNumber = {
  __typename?: 'SentMailConnectionNumber';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SentMailConnectionPublished_At = {
  __typename?: 'SentMailConnectionPublished_at';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SentMailConnectionRecipientAddress = {
  __typename?: 'SentMailConnectionRecipientAddress';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SentMailConnectionRecipientPartner = {
  __typename?: 'SentMailConnectionRecipientPartner';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SentMailConnectionUpdated_At = {
  __typename?: 'SentMailConnectionUpdated_at';
  connection?: Maybe<SentMailConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SentMailGroupBy = {
  __typename?: 'SentMailGroupBy';
  archived?: Maybe<Array<Maybe<SentMailConnectionArchived>>>;
  assignee?: Maybe<Array<Maybe<SentMailConnectionAssignee>>>;
  contents?: Maybe<Array<Maybe<SentMailConnectionContents>>>;
  created_at?: Maybe<Array<Maybe<SentMailConnectionCreated_At>>>;
  dateSent?: Maybe<Array<Maybe<SentMailConnectionDateSent>>>;
  id?: Maybe<Array<Maybe<SentMailConnectionId>>>;
  note?: Maybe<Array<Maybe<SentMailConnectionNote>>>;
  number?: Maybe<Array<Maybe<SentMailConnectionNumber>>>;
  published_at?: Maybe<Array<Maybe<SentMailConnectionPublished_At>>>;
  recipientAddress?: Maybe<Array<Maybe<SentMailConnectionRecipientAddress>>>;
  recipientPartner?: Maybe<Array<Maybe<SentMailConnectionRecipientPartner>>>;
  updated_at?: Maybe<Array<Maybe<SentMailConnectionUpdated_At>>>;
};

export type SentMailInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  assignee?: InputMaybe<Scalars['ID']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contents?: InputMaybe<Enum_Sentmail_Contents>;
  created_by?: InputMaybe<Scalars['ID']>;
  dateSent?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  recipientAddress?: InputMaybe<Scalars['ID']>;
  recipientPartner?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type ServiceLog = {
  __typename?: 'ServiceLog';
  created_at: Scalars['DateTime'];
  date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  employee?: Maybe<UsersPermissionsUser>;
  id: Scalars['ID'];
  published_at?: Maybe<Scalars['DateTime']>;
  result?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  vehicle?: Maybe<Vehicle>;
};

export type ServiceLogAggregator = {
  __typename?: 'ServiceLogAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ServiceLogConnection = {
  __typename?: 'ServiceLogConnection';
  aggregate?: Maybe<ServiceLogAggregator>;
  groupBy?: Maybe<ServiceLogGroupBy>;
  values?: Maybe<Array<Maybe<ServiceLog>>>;
};

export type ServiceLogConnectionCreated_At = {
  __typename?: 'ServiceLogConnectionCreated_at';
  connection?: Maybe<ServiceLogConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ServiceLogConnectionDate = {
  __typename?: 'ServiceLogConnectionDate';
  connection?: Maybe<ServiceLogConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ServiceLogConnectionDescription = {
  __typename?: 'ServiceLogConnectionDescription';
  connection?: Maybe<ServiceLogConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ServiceLogConnectionEmployee = {
  __typename?: 'ServiceLogConnectionEmployee';
  connection?: Maybe<ServiceLogConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ServiceLogConnectionId = {
  __typename?: 'ServiceLogConnectionId';
  connection?: Maybe<ServiceLogConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ServiceLogConnectionPublished_At = {
  __typename?: 'ServiceLogConnectionPublished_at';
  connection?: Maybe<ServiceLogConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ServiceLogConnectionResult = {
  __typename?: 'ServiceLogConnectionResult';
  connection?: Maybe<ServiceLogConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ServiceLogConnectionUpdated_At = {
  __typename?: 'ServiceLogConnectionUpdated_at';
  connection?: Maybe<ServiceLogConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ServiceLogConnectionVehicle = {
  __typename?: 'ServiceLogConnectionVehicle';
  connection?: Maybe<ServiceLogConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ServiceLogGroupBy = {
  __typename?: 'ServiceLogGroupBy';
  created_at?: Maybe<Array<Maybe<ServiceLogConnectionCreated_At>>>;
  date?: Maybe<Array<Maybe<ServiceLogConnectionDate>>>;
  description?: Maybe<Array<Maybe<ServiceLogConnectionDescription>>>;
  employee?: Maybe<Array<Maybe<ServiceLogConnectionEmployee>>>;
  id?: Maybe<Array<Maybe<ServiceLogConnectionId>>>;
  published_at?: Maybe<Array<Maybe<ServiceLogConnectionPublished_At>>>;
  result?: Maybe<Array<Maybe<ServiceLogConnectionResult>>>;
  updated_at?: Maybe<Array<Maybe<ServiceLogConnectionUpdated_At>>>;
  vehicle?: Maybe<Array<Maybe<ServiceLogConnectionVehicle>>>;
};

export type ServiceLogInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  result?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vehicle?: InputMaybe<Scalars['ID']>;
};

export type SetMailStatusInput = {
  id: Scalars['ID'];
  status: Enum_Receivedmail_Status;
};

export type SettingsModule = {
  __typename?: 'SettingsModule';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};

export type SettingsModuleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type SharedContactPerson = {
  __typename?: 'SharedContactPerson';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type SharedContactPersonAggregator = {
  __typename?: 'SharedContactPersonAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SharedContactPersonConnection = {
  __typename?: 'SharedContactPersonConnection';
  aggregate?: Maybe<SharedContactPersonAggregator>;
  groupBy?: Maybe<SharedContactPersonGroupBy>;
  values?: Maybe<Array<Maybe<SharedContactPerson>>>;
};

export type SharedContactPersonConnectionCreated_At = {
  __typename?: 'SharedContactPersonConnectionCreated_at';
  connection?: Maybe<SharedContactPersonConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SharedContactPersonConnectionId = {
  __typename?: 'SharedContactPersonConnectionId';
  connection?: Maybe<SharedContactPersonConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SharedContactPersonConnectionName = {
  __typename?: 'SharedContactPersonConnectionName';
  connection?: Maybe<SharedContactPersonConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SharedContactPersonConnectionPhone = {
  __typename?: 'SharedContactPersonConnectionPhone';
  connection?: Maybe<SharedContactPersonConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SharedContactPersonConnectionPosition = {
  __typename?: 'SharedContactPersonConnectionPosition';
  connection?: Maybe<SharedContactPersonConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SharedContactPersonConnectionUpdated_At = {
  __typename?: 'SharedContactPersonConnectionUpdated_at';
  connection?: Maybe<SharedContactPersonConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SharedContactPersonGroupBy = {
  __typename?: 'SharedContactPersonGroupBy';
  created_at?: Maybe<Array<Maybe<SharedContactPersonConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<SharedContactPersonConnectionId>>>;
  name?: Maybe<Array<Maybe<SharedContactPersonConnectionName>>>;
  phone?: Maybe<Array<Maybe<SharedContactPersonConnectionPhone>>>;
  position?: Maybe<Array<Maybe<SharedContactPersonConnectionPosition>>>;
  updated_at?: Maybe<Array<Maybe<SharedContactPersonConnectionUpdated_At>>>;
};

export type SharedContactPersonInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type SharingInfo = {
  __typename?: 'SharingInfo';
  modified_by?: Maybe<Scalars['String']>;
  parent_shared_folder_id?: Maybe<Scalars['String']>;
  read_only?: Maybe<Scalars['Boolean']>;
};

export type Start = {
  __typename?: 'Start';
  address?: Maybe<Scalars['String']>;
  cityCode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<CreatedBy>;
  distances?: Maybe<Array<Maybe<Distances>>>;
  id?: Maybe<Scalars['Int']>;
  maxInCityTravel?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  reasons?: Maybe<Array<Maybe<Reasons>>>;
  travel_log_private_vehicles?: Maybe<Array<Maybe<TravelLogPrivateVehicles>>>;
  updated_at?: Maybe<Scalars['String']>;
  updated_by?: Maybe<UpdatedBy>;
};

export type StorageFolder = {
  __typename?: 'StorageFolder';
  child_folders?: Maybe<Array<Maybe<StorageFolder>>>;
  created_at: Scalars['DateTime'];
  files?: Maybe<Array<Maybe<S3File>>>;
  id: Scalars['ID'];
  isRoot?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parent_folder?: Maybe<StorageFolder>;
  path: Scalars['String'];
  published_at?: Maybe<Scalars['DateTime']>;
  targetModelId?: Maybe<Scalars['String']>;
  targetModelName?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};


export type StorageFolderChild_FoldersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type StorageFolderFilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type StorageFolderAggregator = {
  __typename?: 'StorageFolderAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StorageFolderConnection = {
  __typename?: 'StorageFolderConnection';
  aggregate?: Maybe<StorageFolderAggregator>;
  groupBy?: Maybe<StorageFolderGroupBy>;
  values?: Maybe<Array<Maybe<StorageFolder>>>;
};

export type StorageFolderConnectionCreated_At = {
  __typename?: 'StorageFolderConnectionCreated_at';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type StorageFolderConnectionId = {
  __typename?: 'StorageFolderConnectionId';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type StorageFolderConnectionIsRoot = {
  __typename?: 'StorageFolderConnectionIsRoot';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type StorageFolderConnectionName = {
  __typename?: 'StorageFolderConnectionName';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['String']>;
};

export type StorageFolderConnectionParent_Folder = {
  __typename?: 'StorageFolderConnectionParent_folder';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type StorageFolderConnectionPath = {
  __typename?: 'StorageFolderConnectionPath';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['String']>;
};

export type StorageFolderConnectionPublished_At = {
  __typename?: 'StorageFolderConnectionPublished_at';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type StorageFolderConnectionTargetModelId = {
  __typename?: 'StorageFolderConnectionTargetModelId';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['String']>;
};

export type StorageFolderConnectionTargetModelName = {
  __typename?: 'StorageFolderConnectionTargetModelName';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['String']>;
};

export type StorageFolderConnectionUpdated_At = {
  __typename?: 'StorageFolderConnectionUpdated_at';
  connection?: Maybe<StorageFolderConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type StorageFolderGroupBy = {
  __typename?: 'StorageFolderGroupBy';
  created_at?: Maybe<Array<Maybe<StorageFolderConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<StorageFolderConnectionId>>>;
  isRoot?: Maybe<Array<Maybe<StorageFolderConnectionIsRoot>>>;
  name?: Maybe<Array<Maybe<StorageFolderConnectionName>>>;
  parent_folder?: Maybe<Array<Maybe<StorageFolderConnectionParent_Folder>>>;
  path?: Maybe<Array<Maybe<StorageFolderConnectionPath>>>;
  published_at?: Maybe<Array<Maybe<StorageFolderConnectionPublished_At>>>;
  targetModelId?: Maybe<Array<Maybe<StorageFolderConnectionTargetModelId>>>;
  targetModelName?: Maybe<Array<Maybe<StorageFolderConnectionTargetModelName>>>;
  updated_at?: Maybe<Array<Maybe<StorageFolderConnectionUpdated_At>>>;
};

export type StorageFolderInput = {
  child_folders?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isRoot?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parent_folder?: InputMaybe<Scalars['ID']>;
  path: Scalars['String'];
  published_at?: InputMaybe<Scalars['DateTime']>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type TagInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type Tags = {
  __typename?: 'Tags';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type TagsAggregator = {
  __typename?: 'TagsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TagsConnection = {
  __typename?: 'TagsConnection';
  aggregate?: Maybe<TagsAggregator>;
  groupBy?: Maybe<TagsGroupBy>;
  values?: Maybe<Array<Maybe<Tags>>>;
};

export type TagsConnectionCreated_At = {
  __typename?: 'TagsConnectionCreated_at';
  connection?: Maybe<TagsConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TagsConnectionId = {
  __typename?: 'TagsConnectionId';
  connection?: Maybe<TagsConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TagsConnectionName = {
  __typename?: 'TagsConnectionName';
  connection?: Maybe<TagsConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TagsConnectionSlug = {
  __typename?: 'TagsConnectionSlug';
  connection?: Maybe<TagsConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TagsConnectionUpdated_At = {
  __typename?: 'TagsConnectionUpdated_at';
  connection?: Maybe<TagsConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TagsGroupBy = {
  __typename?: 'TagsGroupBy';
  created_at?: Maybe<Array<Maybe<TagsConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<TagsConnectionId>>>;
  name?: Maybe<Array<Maybe<TagsConnectionName>>>;
  slug?: Maybe<Array<Maybe<TagsConnectionSlug>>>;
  updated_at?: Maybe<Array<Maybe<TagsConnectionUpdated_At>>>;
};

export type TargetEntityDefinitionInput = {
  targetModelId: Scalars['String'];
  targetModelName: Scalars['String'];
};

export type TravelLogConfiguration = {
  __typename?: 'TravelLogConfiguration';
  Name?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};

export type TravelLogConfigurationAggregator = {
  __typename?: 'TravelLogConfigurationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TravelLogConfigurationConnection = {
  __typename?: 'TravelLogConfigurationConnection';
  aggregate?: Maybe<TravelLogConfigurationAggregator>;
  groupBy?: Maybe<TravelLogConfigurationGroupBy>;
  values?: Maybe<Array<Maybe<TravelLogConfiguration>>>;
};

export type TravelLogConfigurationConnectionCreated_At = {
  __typename?: 'TravelLogConfigurationConnectionCreated_at';
  connection?: Maybe<TravelLogConfigurationConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogConfigurationConnectionId = {
  __typename?: 'TravelLogConfigurationConnectionId';
  connection?: Maybe<TravelLogConfigurationConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogConfigurationConnectionName = {
  __typename?: 'TravelLogConfigurationConnectionName';
  connection?: Maybe<TravelLogConfigurationConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogConfigurationConnectionPublished_At = {
  __typename?: 'TravelLogConfigurationConnectionPublished_at';
  connection?: Maybe<TravelLogConfigurationConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogConfigurationConnectionUpdated_At = {
  __typename?: 'TravelLogConfigurationConnectionUpdated_at';
  connection?: Maybe<TravelLogConfigurationConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogConfigurationGroupBy = {
  __typename?: 'TravelLogConfigurationGroupBy';
  Name?: Maybe<Array<Maybe<TravelLogConfigurationConnectionName>>>;
  created_at?: Maybe<Array<Maybe<TravelLogConfigurationConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<TravelLogConfigurationConnectionId>>>;
  published_at?: Maybe<Array<Maybe<TravelLogConfigurationConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<TravelLogConfigurationConnectionUpdated_At>>>;
};

export type TravelLogConfigurationInput = {
  Name?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type TravelLogLegs = {
  __typename?: 'TravelLogLegs';
  batchUuid?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['String']>;
  finish?: Maybe<Finish>;
  finishTime?: Maybe<Scalars['String']>;
  fuelCompensation?: Maybe<Scalars['Float']>;
  reason?: Maybe<Reason>;
  remainingKilometers?: Maybe<Scalars['Float']>;
  start?: Maybe<Start>;
  startTime?: Maybe<Scalars['String']>;
  travelCompensation?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['String']>;
  workDuration?: Maybe<Scalars['String']>;
  workFinishTime?: Maybe<Scalars['String']>;
  workStartTime?: Maybe<Scalars['String']>;
};

export type TravelLogLog = {
  __typename?: 'TravelLogLog';
  archived?: Maybe<Scalars['Boolean']>;
  attachments?: Maybe<Array<Maybe<S3File>>>;
  blacklistedDates?: Maybe<Array<Maybe<ComponentTravelLogDates>>>;
  compensationForFuel?: Maybe<Scalars['Float']>;
  compensationForTravel?: Maybe<Scalars['Float']>;
  created_at: Scalars['DateTime'];
  destinationLimits?: Maybe<Array<Maybe<ComponentTravelLogDestinationTravelLimit>>>;
  forMonth?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  legs?: Maybe<Array<Maybe<ComponentTravelLogTravelLogLeg>>>;
  neededKilometers?: Maybe<Scalars['Float']>;
  parametersUsedToGenerateLog?: Maybe<Scalars['JSON']>;
  priceOfFuel?: Maybe<Scalars['Float']>;
  published_at?: Maybe<Scalars['DateTime']>;
  routes?: Maybe<Array<Maybe<ComponentTravelLogRoutes>>>;
  updated_at: Scalars['DateTime'];
  vehicle?: Maybe<TravelLogPrivateVehicle>;
};


export type TravelLogLogAttachmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type TravelLogLogAggregator = {
  __typename?: 'TravelLogLogAggregator';
  avg?: Maybe<TravelLogLogAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<TravelLogLogAggregatorMax>;
  min?: Maybe<TravelLogLogAggregatorMin>;
  sum?: Maybe<TravelLogLogAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TravelLogLogAggregatorAvg = {
  __typename?: 'TravelLogLogAggregatorAvg';
  compensationForFuel?: Maybe<Scalars['Float']>;
  compensationForTravel?: Maybe<Scalars['Float']>;
  neededKilometers?: Maybe<Scalars['Float']>;
  priceOfFuel?: Maybe<Scalars['Float']>;
};

export type TravelLogLogAggregatorMax = {
  __typename?: 'TravelLogLogAggregatorMax';
  compensationForFuel?: Maybe<Scalars['Float']>;
  compensationForTravel?: Maybe<Scalars['Float']>;
  neededKilometers?: Maybe<Scalars['Float']>;
  priceOfFuel?: Maybe<Scalars['Float']>;
};

export type TravelLogLogAggregatorMin = {
  __typename?: 'TravelLogLogAggregatorMin';
  compensationForFuel?: Maybe<Scalars['Float']>;
  compensationForTravel?: Maybe<Scalars['Float']>;
  neededKilometers?: Maybe<Scalars['Float']>;
  priceOfFuel?: Maybe<Scalars['Float']>;
};

export type TravelLogLogAggregatorSum = {
  __typename?: 'TravelLogLogAggregatorSum';
  compensationForFuel?: Maybe<Scalars['Float']>;
  compensationForTravel?: Maybe<Scalars['Float']>;
  neededKilometers?: Maybe<Scalars['Float']>;
  priceOfFuel?: Maybe<Scalars['Float']>;
};

export type TravelLogLogConnection = {
  __typename?: 'TravelLogLogConnection';
  aggregate?: Maybe<TravelLogLogAggregator>;
  groupBy?: Maybe<TravelLogLogGroupBy>;
  values?: Maybe<Array<Maybe<TravelLogLog>>>;
};

export type TravelLogLogConnectionArchived = {
  __typename?: 'TravelLogLogConnectionArchived';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type TravelLogLogConnectionCompensationForFuel = {
  __typename?: 'TravelLogLogConnectionCompensationForFuel';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogLogConnectionCompensationForTravel = {
  __typename?: 'TravelLogLogConnectionCompensationForTravel';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogLogConnectionCreated_At = {
  __typename?: 'TravelLogLogConnectionCreated_at';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogLogConnectionForMonth = {
  __typename?: 'TravelLogLogConnectionForMonth';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogLogConnectionId = {
  __typename?: 'TravelLogLogConnectionId';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogLogConnectionNeededKilometers = {
  __typename?: 'TravelLogLogConnectionNeededKilometers';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogLogConnectionParametersUsedToGenerateLog = {
  __typename?: 'TravelLogLogConnectionParametersUsedToGenerateLog';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type TravelLogLogConnectionPriceOfFuel = {
  __typename?: 'TravelLogLogConnectionPriceOfFuel';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogLogConnectionPublished_At = {
  __typename?: 'TravelLogLogConnectionPublished_at';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogLogConnectionUpdated_At = {
  __typename?: 'TravelLogLogConnectionUpdated_at';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogLogConnectionVehicle = {
  __typename?: 'TravelLogLogConnectionVehicle';
  connection?: Maybe<TravelLogLogConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogLogGroupBy = {
  __typename?: 'TravelLogLogGroupBy';
  archived?: Maybe<Array<Maybe<TravelLogLogConnectionArchived>>>;
  compensationForFuel?: Maybe<Array<Maybe<TravelLogLogConnectionCompensationForFuel>>>;
  compensationForTravel?: Maybe<Array<Maybe<TravelLogLogConnectionCompensationForTravel>>>;
  created_at?: Maybe<Array<Maybe<TravelLogLogConnectionCreated_At>>>;
  forMonth?: Maybe<Array<Maybe<TravelLogLogConnectionForMonth>>>;
  id?: Maybe<Array<Maybe<TravelLogLogConnectionId>>>;
  neededKilometers?: Maybe<Array<Maybe<TravelLogLogConnectionNeededKilometers>>>;
  parametersUsedToGenerateLog?: Maybe<Array<Maybe<TravelLogLogConnectionParametersUsedToGenerateLog>>>;
  priceOfFuel?: Maybe<Array<Maybe<TravelLogLogConnectionPriceOfFuel>>>;
  published_at?: Maybe<Array<Maybe<TravelLogLogConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<TravelLogLogConnectionUpdated_At>>>;
  vehicle?: Maybe<Array<Maybe<TravelLogLogConnectionVehicle>>>;
};

export type TravelLogLogInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  blacklistedDates?: InputMaybe<Array<InputMaybe<ComponentTravelLogDateInput>>>;
  compensationForFuel?: InputMaybe<Scalars['Float']>;
  compensationForTravel?: InputMaybe<Scalars['Float']>;
  created_by?: InputMaybe<Scalars['ID']>;
  destinationLimits?: InputMaybe<Array<InputMaybe<ComponentTravelLogDestinationTravelLimitInput>>>;
  forMonth?: InputMaybe<Scalars['Date']>;
  legs?: InputMaybe<Array<InputMaybe<ComponentTravelLogTravelLogLegInput>>>;
  neededKilometers?: InputMaybe<Scalars['Float']>;
  parametersUsedToGenerateLog?: InputMaybe<Scalars['JSON']>;
  priceOfFuel?: InputMaybe<Scalars['Float']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  routes?: InputMaybe<Array<InputMaybe<ComponentTravelLogRouteInput>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vehicle?: InputMaybe<Scalars['ID']>;
};

export type TravelLogModule = {
  __typename?: 'TravelLogModule';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};

export type TravelLogModuleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type TravelLogPlace = {
  __typename?: 'TravelLogPlace';
  address?: Maybe<Scalars['String']>;
  balancingPlaceToVehicles?: Maybe<Array<Maybe<TravelLogPrivateVehicle>>>;
  cityCode?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  defualtDayLimit?: Maybe<Scalars['Int']>;
  distances?: Maybe<Array<Maybe<TravelLogPlacesDistance>>>;
  homePlaceToVehicles?: Maybe<Array<Maybe<TravelLogPrivateVehicle>>>;
  id: Scalars['ID'];
  maxInCityTravel?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  reasons?: Maybe<Array<Maybe<TravelLogUserJourneyReason>>>;
  travel_log_private_vehicles?: Maybe<Array<Maybe<TravelLogPrivateVehicle>>>;
  travel_log_route_temps?: Maybe<Array<Maybe<TravelLogRouteTemp>>>;
  updated_at: Scalars['DateTime'];
};


export type TravelLogPlaceBalancingPlaceToVehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPlaceDistancesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPlaceHomePlaceToVehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPlaceReasonsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPlaceTravel_Log_Private_VehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPlaceTravel_Log_Route_TempsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type TravelLogPlaceAggregator = {
  __typename?: 'TravelLogPlaceAggregator';
  avg?: Maybe<TravelLogPlaceAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<TravelLogPlaceAggregatorMax>;
  min?: Maybe<TravelLogPlaceAggregatorMin>;
  sum?: Maybe<TravelLogPlaceAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TravelLogPlaceAggregatorAvg = {
  __typename?: 'TravelLogPlaceAggregatorAvg';
  defualtDayLimit?: Maybe<Scalars['Float']>;
  maxInCityTravel?: Maybe<Scalars['Float']>;
};

export type TravelLogPlaceAggregatorMax = {
  __typename?: 'TravelLogPlaceAggregatorMax';
  defualtDayLimit?: Maybe<Scalars['Float']>;
  maxInCityTravel?: Maybe<Scalars['Float']>;
};

export type TravelLogPlaceAggregatorMin = {
  __typename?: 'TravelLogPlaceAggregatorMin';
  defualtDayLimit?: Maybe<Scalars['Float']>;
  maxInCityTravel?: Maybe<Scalars['Float']>;
};

export type TravelLogPlaceAggregatorSum = {
  __typename?: 'TravelLogPlaceAggregatorSum';
  defualtDayLimit?: Maybe<Scalars['Float']>;
  maxInCityTravel?: Maybe<Scalars['Float']>;
};

export type TravelLogPlaceConnection = {
  __typename?: 'TravelLogPlaceConnection';
  aggregate?: Maybe<TravelLogPlaceAggregator>;
  groupBy?: Maybe<TravelLogPlaceGroupBy>;
  values?: Maybe<Array<Maybe<TravelLogPlace>>>;
};

export type TravelLogPlaceConnectionAddress = {
  __typename?: 'TravelLogPlaceConnectionAddress';
  connection?: Maybe<TravelLogPlaceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogPlaceConnectionCityCode = {
  __typename?: 'TravelLogPlaceConnectionCityCode';
  connection?: Maybe<TravelLogPlaceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogPlaceConnectionCreated_At = {
  __typename?: 'TravelLogPlaceConnectionCreated_at';
  connection?: Maybe<TravelLogPlaceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogPlaceConnectionDefualtDayLimit = {
  __typename?: 'TravelLogPlaceConnectionDefualtDayLimit';
  connection?: Maybe<TravelLogPlaceConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type TravelLogPlaceConnectionId = {
  __typename?: 'TravelLogPlaceConnectionId';
  connection?: Maybe<TravelLogPlaceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogPlaceConnectionMaxInCityTravel = {
  __typename?: 'TravelLogPlaceConnectionMaxInCityTravel';
  connection?: Maybe<TravelLogPlaceConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogPlaceConnectionName = {
  __typename?: 'TravelLogPlaceConnectionName';
  connection?: Maybe<TravelLogPlaceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogPlaceConnectionUpdated_At = {
  __typename?: 'TravelLogPlaceConnectionUpdated_at';
  connection?: Maybe<TravelLogPlaceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogPlaceGroupBy = {
  __typename?: 'TravelLogPlaceGroupBy';
  address?: Maybe<Array<Maybe<TravelLogPlaceConnectionAddress>>>;
  cityCode?: Maybe<Array<Maybe<TravelLogPlaceConnectionCityCode>>>;
  created_at?: Maybe<Array<Maybe<TravelLogPlaceConnectionCreated_At>>>;
  defualtDayLimit?: Maybe<Array<Maybe<TravelLogPlaceConnectionDefualtDayLimit>>>;
  id?: Maybe<Array<Maybe<TravelLogPlaceConnectionId>>>;
  maxInCityTravel?: Maybe<Array<Maybe<TravelLogPlaceConnectionMaxInCityTravel>>>;
  name?: Maybe<Array<Maybe<TravelLogPlaceConnectionName>>>;
  updated_at?: Maybe<Array<Maybe<TravelLogPlaceConnectionUpdated_At>>>;
};

export type TravelLogPlaceInput = {
  address?: InputMaybe<Scalars['String']>;
  balancingPlaceToVehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  cityCode?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  defualtDayLimit?: InputMaybe<Scalars['Int']>;
  distances?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  homePlaceToVehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  maxInCityTravel?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  reasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_log_private_vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_log_route_temps?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type TravelLogPlacesDistance = {
  __typename?: 'TravelLogPlacesDistance';
  created_at: Scalars['DateTime'];
  distanceInKm?: Maybe<Scalars['Float']>;
  durationInSeconds?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  places?: Maybe<Array<Maybe<TravelLogPlace>>>;
  updated_at: Scalars['DateTime'];
};


export type TravelLogPlacesDistancePlacesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type TravelLogPlacesDistanceAggregator = {
  __typename?: 'TravelLogPlacesDistanceAggregator';
  avg?: Maybe<TravelLogPlacesDistanceAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<TravelLogPlacesDistanceAggregatorMax>;
  min?: Maybe<TravelLogPlacesDistanceAggregatorMin>;
  sum?: Maybe<TravelLogPlacesDistanceAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TravelLogPlacesDistanceAggregatorAvg = {
  __typename?: 'TravelLogPlacesDistanceAggregatorAvg';
  distanceInKm?: Maybe<Scalars['Float']>;
};

export type TravelLogPlacesDistanceAggregatorMax = {
  __typename?: 'TravelLogPlacesDistanceAggregatorMax';
  distanceInKm?: Maybe<Scalars['Float']>;
};

export type TravelLogPlacesDistanceAggregatorMin = {
  __typename?: 'TravelLogPlacesDistanceAggregatorMin';
  distanceInKm?: Maybe<Scalars['Float']>;
};

export type TravelLogPlacesDistanceAggregatorSum = {
  __typename?: 'TravelLogPlacesDistanceAggregatorSum';
  distanceInKm?: Maybe<Scalars['Float']>;
};

export type TravelLogPlacesDistanceConnection = {
  __typename?: 'TravelLogPlacesDistanceConnection';
  aggregate?: Maybe<TravelLogPlacesDistanceAggregator>;
  groupBy?: Maybe<TravelLogPlacesDistanceGroupBy>;
  values?: Maybe<Array<Maybe<TravelLogPlacesDistance>>>;
};

export type TravelLogPlacesDistanceConnectionCreated_At = {
  __typename?: 'TravelLogPlacesDistanceConnectionCreated_at';
  connection?: Maybe<TravelLogPlacesDistanceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogPlacesDistanceConnectionDistanceInKm = {
  __typename?: 'TravelLogPlacesDistanceConnectionDistanceInKm';
  connection?: Maybe<TravelLogPlacesDistanceConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogPlacesDistanceConnectionDurationInSeconds = {
  __typename?: 'TravelLogPlacesDistanceConnectionDurationInSeconds';
  connection?: Maybe<TravelLogPlacesDistanceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogPlacesDistanceConnectionId = {
  __typename?: 'TravelLogPlacesDistanceConnectionId';
  connection?: Maybe<TravelLogPlacesDistanceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogPlacesDistanceConnectionIdentifier = {
  __typename?: 'TravelLogPlacesDistanceConnectionIdentifier';
  connection?: Maybe<TravelLogPlacesDistanceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogPlacesDistanceConnectionUpdated_At = {
  __typename?: 'TravelLogPlacesDistanceConnectionUpdated_at';
  connection?: Maybe<TravelLogPlacesDistanceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogPlacesDistanceGroupBy = {
  __typename?: 'TravelLogPlacesDistanceGroupBy';
  created_at?: Maybe<Array<Maybe<TravelLogPlacesDistanceConnectionCreated_At>>>;
  distanceInKm?: Maybe<Array<Maybe<TravelLogPlacesDistanceConnectionDistanceInKm>>>;
  durationInSeconds?: Maybe<Array<Maybe<TravelLogPlacesDistanceConnectionDurationInSeconds>>>;
  id?: Maybe<Array<Maybe<TravelLogPlacesDistanceConnectionId>>>;
  identifier?: Maybe<Array<Maybe<TravelLogPlacesDistanceConnectionIdentifier>>>;
  updated_at?: Maybe<Array<Maybe<TravelLogPlacesDistanceConnectionUpdated_At>>>;
};

export type TravelLogPlacesDistanceInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  distanceInKm?: InputMaybe<Scalars['Float']>;
  durationInSeconds?: InputMaybe<Scalars['Long']>;
  identifier?: InputMaybe<Scalars['String']>;
  places?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type TravelLogPrivateVehicle = {
  __typename?: 'TravelLogPrivateVehicle';
  balancingPlace?: Maybe<TravelLogPlace>;
  created_at: Scalars['DateTime'];
  fuelConsumption?: Maybe<Scalars['Float']>;
  homePlace?: Maybe<TravelLogPlace>;
  id: Scalars['ID'];
  model?: Maybe<Scalars['String']>;
  owner?: Maybe<UsersPermissionsUser>;
  places?: Maybe<Array<Maybe<TravelLogPlace>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  registrationCertFiles?: Maybe<Array<Maybe<S3File>>>;
  registrationCertificate?: Maybe<Array<Maybe<S3File>>>;
  registrationPlate?: Maybe<Scalars['String']>;
  routes?: Maybe<Array<Maybe<TravelLogRoute>>>;
  tempRoutes?: Maybe<Array<Maybe<TravelLogRouteTemp>>>;
  travel_logs?: Maybe<Array<Maybe<TravelLogLog>>>;
  updated_at: Scalars['DateTime'];
};


export type TravelLogPrivateVehiclePlacesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPrivateVehicleRegistrationCertFilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPrivateVehicleRegistrationCertificateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPrivateVehicleRoutesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPrivateVehicleTempRoutesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type TravelLogPrivateVehicleTravel_LogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type TravelLogPrivateVehicleAggregator = {
  __typename?: 'TravelLogPrivateVehicleAggregator';
  avg?: Maybe<TravelLogPrivateVehicleAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<TravelLogPrivateVehicleAggregatorMax>;
  min?: Maybe<TravelLogPrivateVehicleAggregatorMin>;
  sum?: Maybe<TravelLogPrivateVehicleAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TravelLogPrivateVehicleAggregatorAvg = {
  __typename?: 'TravelLogPrivateVehicleAggregatorAvg';
  fuelConsumption?: Maybe<Scalars['Float']>;
};

export type TravelLogPrivateVehicleAggregatorMax = {
  __typename?: 'TravelLogPrivateVehicleAggregatorMax';
  fuelConsumption?: Maybe<Scalars['Float']>;
};

export type TravelLogPrivateVehicleAggregatorMin = {
  __typename?: 'TravelLogPrivateVehicleAggregatorMin';
  fuelConsumption?: Maybe<Scalars['Float']>;
};

export type TravelLogPrivateVehicleAggregatorSum = {
  __typename?: 'TravelLogPrivateVehicleAggregatorSum';
  fuelConsumption?: Maybe<Scalars['Float']>;
};

export type TravelLogPrivateVehicleConnection = {
  __typename?: 'TravelLogPrivateVehicleConnection';
  aggregate?: Maybe<TravelLogPrivateVehicleAggregator>;
  groupBy?: Maybe<TravelLogPrivateVehicleGroupBy>;
  values?: Maybe<Array<Maybe<TravelLogPrivateVehicle>>>;
};

export type TravelLogPrivateVehicleConnectionBalancingPlace = {
  __typename?: 'TravelLogPrivateVehicleConnectionBalancingPlace';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogPrivateVehicleConnectionCreated_At = {
  __typename?: 'TravelLogPrivateVehicleConnectionCreated_at';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogPrivateVehicleConnectionFuelConsumption = {
  __typename?: 'TravelLogPrivateVehicleConnectionFuelConsumption';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogPrivateVehicleConnectionHomePlace = {
  __typename?: 'TravelLogPrivateVehicleConnectionHomePlace';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogPrivateVehicleConnectionId = {
  __typename?: 'TravelLogPrivateVehicleConnectionId';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogPrivateVehicleConnectionModel = {
  __typename?: 'TravelLogPrivateVehicleConnectionModel';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogPrivateVehicleConnectionOwner = {
  __typename?: 'TravelLogPrivateVehicleConnectionOwner';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogPrivateVehicleConnectionPublished_At = {
  __typename?: 'TravelLogPrivateVehicleConnectionPublished_at';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogPrivateVehicleConnectionRegistrationPlate = {
  __typename?: 'TravelLogPrivateVehicleConnectionRegistrationPlate';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogPrivateVehicleConnectionUpdated_At = {
  __typename?: 'TravelLogPrivateVehicleConnectionUpdated_at';
  connection?: Maybe<TravelLogPrivateVehicleConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogPrivateVehicleGroupBy = {
  __typename?: 'TravelLogPrivateVehicleGroupBy';
  balancingPlace?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionBalancingPlace>>>;
  created_at?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionCreated_At>>>;
  fuelConsumption?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionFuelConsumption>>>;
  homePlace?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionHomePlace>>>;
  id?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionId>>>;
  model?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionModel>>>;
  owner?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionOwner>>>;
  published_at?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionPublished_At>>>;
  registrationPlate?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionRegistrationPlate>>>;
  updated_at?: Maybe<Array<Maybe<TravelLogPrivateVehicleConnectionUpdated_At>>>;
};

export type TravelLogPrivateVehicleInput = {
  balancingPlace?: InputMaybe<Scalars['ID']>;
  created_by?: InputMaybe<Scalars['ID']>;
  fuelConsumption?: InputMaybe<Scalars['Float']>;
  homePlace?: InputMaybe<Scalars['ID']>;
  model?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['ID']>;
  places?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  registrationCertFiles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  registrationCertificate?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  registrationPlate?: InputMaybe<Scalars['String']>;
  routes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tempRoutes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type TravelLogPrivateVehicles = {
  __typename?: 'TravelLogPrivateVehicles';
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  fuelConsumption?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  registrationPlate?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['Int']>;
};

export type TravelLogRoute = {
  __typename?: 'TravelLogRoute';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  legs?: Maybe<Array<Maybe<ComponentTravelLogTravelLogRouteLegs>>>;
  overallDistance?: Maybe<Scalars['Float']>;
  published_at?: Maybe<Scalars['DateTime']>;
  reason?: Maybe<TravelLogRouteReason>;
  updated_at: Scalars['DateTime'];
  vehicle?: Maybe<TravelLogPrivateVehicle>;
};

export type TravelLogRouteAggregator = {
  __typename?: 'TravelLogRouteAggregator';
  avg?: Maybe<TravelLogRouteAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<TravelLogRouteAggregatorMax>;
  min?: Maybe<TravelLogRouteAggregatorMin>;
  sum?: Maybe<TravelLogRouteAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TravelLogRouteAggregatorAvg = {
  __typename?: 'TravelLogRouteAggregatorAvg';
  overallDistance?: Maybe<Scalars['Float']>;
};

export type TravelLogRouteAggregatorMax = {
  __typename?: 'TravelLogRouteAggregatorMax';
  overallDistance?: Maybe<Scalars['Float']>;
};

export type TravelLogRouteAggregatorMin = {
  __typename?: 'TravelLogRouteAggregatorMin';
  overallDistance?: Maybe<Scalars['Float']>;
};

export type TravelLogRouteAggregatorSum = {
  __typename?: 'TravelLogRouteAggregatorSum';
  overallDistance?: Maybe<Scalars['Float']>;
};

export type TravelLogRouteConnection = {
  __typename?: 'TravelLogRouteConnection';
  aggregate?: Maybe<TravelLogRouteAggregator>;
  groupBy?: Maybe<TravelLogRouteGroupBy>;
  values?: Maybe<Array<Maybe<TravelLogRoute>>>;
};

export type TravelLogRouteConnectionCreated_At = {
  __typename?: 'TravelLogRouteConnectionCreated_at';
  connection?: Maybe<TravelLogRouteConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogRouteConnectionId = {
  __typename?: 'TravelLogRouteConnectionId';
  connection?: Maybe<TravelLogRouteConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogRouteConnectionOverallDistance = {
  __typename?: 'TravelLogRouteConnectionOverallDistance';
  connection?: Maybe<TravelLogRouteConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogRouteConnectionPublished_At = {
  __typename?: 'TravelLogRouteConnectionPublished_at';
  connection?: Maybe<TravelLogRouteConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogRouteConnectionReason = {
  __typename?: 'TravelLogRouteConnectionReason';
  connection?: Maybe<TravelLogRouteConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogRouteConnectionUpdated_At = {
  __typename?: 'TravelLogRouteConnectionUpdated_at';
  connection?: Maybe<TravelLogRouteConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogRouteConnectionVehicle = {
  __typename?: 'TravelLogRouteConnectionVehicle';
  connection?: Maybe<TravelLogRouteConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogRouteGroupBy = {
  __typename?: 'TravelLogRouteGroupBy';
  created_at?: Maybe<Array<Maybe<TravelLogRouteConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<TravelLogRouteConnectionId>>>;
  overallDistance?: Maybe<Array<Maybe<TravelLogRouteConnectionOverallDistance>>>;
  published_at?: Maybe<Array<Maybe<TravelLogRouteConnectionPublished_At>>>;
  reason?: Maybe<Array<Maybe<TravelLogRouteConnectionReason>>>;
  updated_at?: Maybe<Array<Maybe<TravelLogRouteConnectionUpdated_At>>>;
  vehicle?: Maybe<Array<Maybe<TravelLogRouteConnectionVehicle>>>;
};

export type TravelLogRouteInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  legs?: InputMaybe<Array<InputMaybe<ComponentTravelLogTravelLogRouteLegInput>>>;
  overallDistance?: InputMaybe<Scalars['Float']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vehicle?: InputMaybe<Scalars['ID']>;
};

export type TravelLogRouteReason = {
  __typename?: 'TravelLogRouteReason';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  routes?: Maybe<Array<Maybe<TravelLogRoute>>>;
  updated_at: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};


export type TravelLogRouteReasonRoutesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type TravelLogRouteReasonAggregator = {
  __typename?: 'TravelLogRouteReasonAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TravelLogRouteReasonConnection = {
  __typename?: 'TravelLogRouteReasonConnection';
  aggregate?: Maybe<TravelLogRouteReasonAggregator>;
  groupBy?: Maybe<TravelLogRouteReasonGroupBy>;
  values?: Maybe<Array<Maybe<TravelLogRouteReason>>>;
};

export type TravelLogRouteReasonConnectionCreated_At = {
  __typename?: 'TravelLogRouteReasonConnectionCreated_at';
  connection?: Maybe<TravelLogRouteReasonConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogRouteReasonConnectionId = {
  __typename?: 'TravelLogRouteReasonConnectionId';
  connection?: Maybe<TravelLogRouteReasonConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogRouteReasonConnectionName = {
  __typename?: 'TravelLogRouteReasonConnectionName';
  connection?: Maybe<TravelLogRouteReasonConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogRouteReasonConnectionPublished_At = {
  __typename?: 'TravelLogRouteReasonConnectionPublished_at';
  connection?: Maybe<TravelLogRouteReasonConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogRouteReasonConnectionUpdated_At = {
  __typename?: 'TravelLogRouteReasonConnectionUpdated_at';
  connection?: Maybe<TravelLogRouteReasonConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogRouteReasonConnectionValue = {
  __typename?: 'TravelLogRouteReasonConnectionValue';
  connection?: Maybe<TravelLogRouteReasonConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogRouteReasonGroupBy = {
  __typename?: 'TravelLogRouteReasonGroupBy';
  created_at?: Maybe<Array<Maybe<TravelLogRouteReasonConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<TravelLogRouteReasonConnectionId>>>;
  name?: Maybe<Array<Maybe<TravelLogRouteReasonConnectionName>>>;
  published_at?: Maybe<Array<Maybe<TravelLogRouteReasonConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<TravelLogRouteReasonConnectionUpdated_At>>>;
  value?: Maybe<Array<Maybe<TravelLogRouteReasonConnectionValue>>>;
};

export type TravelLogRouteReasonInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  routes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
};

export type TravelLogRouteTemp = {
  __typename?: 'TravelLogRouteTemp';
  balancing?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['DateTime'];
  defaultMonthLimit?: Maybe<Scalars['Int']>;
  destination?: Maybe<TravelLogPlace>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  reason?: Maybe<TravelLogUserJourneyReason>;
  updated_at: Scalars['DateTime'];
  vehicle?: Maybe<TravelLogPrivateVehicle>;
};

export type TravelLogRouteTempAggregator = {
  __typename?: 'TravelLogRouteTempAggregator';
  avg?: Maybe<TravelLogRouteTempAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<TravelLogRouteTempAggregatorMax>;
  min?: Maybe<TravelLogRouteTempAggregatorMin>;
  sum?: Maybe<TravelLogRouteTempAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TravelLogRouteTempAggregatorAvg = {
  __typename?: 'TravelLogRouteTempAggregatorAvg';
  defaultMonthLimit?: Maybe<Scalars['Float']>;
};

export type TravelLogRouteTempAggregatorMax = {
  __typename?: 'TravelLogRouteTempAggregatorMax';
  defaultMonthLimit?: Maybe<Scalars['Float']>;
};

export type TravelLogRouteTempAggregatorMin = {
  __typename?: 'TravelLogRouteTempAggregatorMin';
  defaultMonthLimit?: Maybe<Scalars['Float']>;
};

export type TravelLogRouteTempAggregatorSum = {
  __typename?: 'TravelLogRouteTempAggregatorSum';
  defaultMonthLimit?: Maybe<Scalars['Float']>;
};

export type TravelLogRouteTempConnection = {
  __typename?: 'TravelLogRouteTempConnection';
  aggregate?: Maybe<TravelLogRouteTempAggregator>;
  groupBy?: Maybe<TravelLogRouteTempGroupBy>;
  values?: Maybe<Array<Maybe<TravelLogRouteTemp>>>;
};

export type TravelLogRouteTempConnectionBalancing = {
  __typename?: 'TravelLogRouteTempConnectionBalancing';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type TravelLogRouteTempConnectionCreated_At = {
  __typename?: 'TravelLogRouteTempConnectionCreated_at';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogRouteTempConnectionDefaultMonthLimit = {
  __typename?: 'TravelLogRouteTempConnectionDefaultMonthLimit';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type TravelLogRouteTempConnectionDestination = {
  __typename?: 'TravelLogRouteTempConnectionDestination';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogRouteTempConnectionId = {
  __typename?: 'TravelLogRouteTempConnectionId';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogRouteTempConnectionName = {
  __typename?: 'TravelLogRouteTempConnectionName';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogRouteTempConnectionPublished_At = {
  __typename?: 'TravelLogRouteTempConnectionPublished_at';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogRouteTempConnectionReason = {
  __typename?: 'TravelLogRouteTempConnectionReason';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogRouteTempConnectionUpdated_At = {
  __typename?: 'TravelLogRouteTempConnectionUpdated_at';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogRouteTempConnectionVehicle = {
  __typename?: 'TravelLogRouteTempConnectionVehicle';
  connection?: Maybe<TravelLogRouteTempConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogRouteTempGroupBy = {
  __typename?: 'TravelLogRouteTempGroupBy';
  balancing?: Maybe<Array<Maybe<TravelLogRouteTempConnectionBalancing>>>;
  created_at?: Maybe<Array<Maybe<TravelLogRouteTempConnectionCreated_At>>>;
  defaultMonthLimit?: Maybe<Array<Maybe<TravelLogRouteTempConnectionDefaultMonthLimit>>>;
  destination?: Maybe<Array<Maybe<TravelLogRouteTempConnectionDestination>>>;
  id?: Maybe<Array<Maybe<TravelLogRouteTempConnectionId>>>;
  name?: Maybe<Array<Maybe<TravelLogRouteTempConnectionName>>>;
  published_at?: Maybe<Array<Maybe<TravelLogRouteTempConnectionPublished_At>>>;
  reason?: Maybe<Array<Maybe<TravelLogRouteTempConnectionReason>>>;
  updated_at?: Maybe<Array<Maybe<TravelLogRouteTempConnectionUpdated_At>>>;
  vehicle?: Maybe<Array<Maybe<TravelLogRouteTempConnectionVehicle>>>;
};

export type TravelLogRouteTempInput = {
  balancing?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Scalars['ID']>;
  defaultMonthLimit?: InputMaybe<Scalars['Int']>;
  destination?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vehicle?: InputMaybe<Scalars['ID']>;
};

export type TravelLogUserJourneyReason = {
  __typename?: 'TravelLogUserJourneyReason';
  created_at: Scalars['DateTime'];
  durationInHoursFrom?: Maybe<Scalars['Float']>;
  durationInHoursTo?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  places?: Maybe<Array<Maybe<TravelLogPlace>>>;
  tempRoute?: Maybe<TravelLogRouteTemp>;
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
};


export type TravelLogUserJourneyReasonPlacesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type TravelLogUserJourneyReasonAggregator = {
  __typename?: 'TravelLogUserJourneyReasonAggregator';
  avg?: Maybe<TravelLogUserJourneyReasonAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<TravelLogUserJourneyReasonAggregatorMax>;
  min?: Maybe<TravelLogUserJourneyReasonAggregatorMin>;
  sum?: Maybe<TravelLogUserJourneyReasonAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TravelLogUserJourneyReasonAggregatorAvg = {
  __typename?: 'TravelLogUserJourneyReasonAggregatorAvg';
  durationInHoursFrom?: Maybe<Scalars['Float']>;
  durationInHoursTo?: Maybe<Scalars['Float']>;
};

export type TravelLogUserJourneyReasonAggregatorMax = {
  __typename?: 'TravelLogUserJourneyReasonAggregatorMax';
  durationInHoursFrom?: Maybe<Scalars['Float']>;
  durationInHoursTo?: Maybe<Scalars['Float']>;
};

export type TravelLogUserJourneyReasonAggregatorMin = {
  __typename?: 'TravelLogUserJourneyReasonAggregatorMin';
  durationInHoursFrom?: Maybe<Scalars['Float']>;
  durationInHoursTo?: Maybe<Scalars['Float']>;
};

export type TravelLogUserJourneyReasonAggregatorSum = {
  __typename?: 'TravelLogUserJourneyReasonAggregatorSum';
  durationInHoursFrom?: Maybe<Scalars['Float']>;
  durationInHoursTo?: Maybe<Scalars['Float']>;
};

export type TravelLogUserJourneyReasonConnection = {
  __typename?: 'TravelLogUserJourneyReasonConnection';
  aggregate?: Maybe<TravelLogUserJourneyReasonAggregator>;
  groupBy?: Maybe<TravelLogUserJourneyReasonGroupBy>;
  values?: Maybe<Array<Maybe<TravelLogUserJourneyReason>>>;
};

export type TravelLogUserJourneyReasonConnectionCreated_At = {
  __typename?: 'TravelLogUserJourneyReasonConnectionCreated_at';
  connection?: Maybe<TravelLogUserJourneyReasonConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogUserJourneyReasonConnectionDurationInHoursFrom = {
  __typename?: 'TravelLogUserJourneyReasonConnectionDurationInHoursFrom';
  connection?: Maybe<TravelLogUserJourneyReasonConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogUserJourneyReasonConnectionDurationInHoursTo = {
  __typename?: 'TravelLogUserJourneyReasonConnectionDurationInHoursTo';
  connection?: Maybe<TravelLogUserJourneyReasonConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type TravelLogUserJourneyReasonConnectionId = {
  __typename?: 'TravelLogUserJourneyReasonConnectionId';
  connection?: Maybe<TravelLogUserJourneyReasonConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogUserJourneyReasonConnectionName = {
  __typename?: 'TravelLogUserJourneyReasonConnectionName';
  connection?: Maybe<TravelLogUserJourneyReasonConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TravelLogUserJourneyReasonConnectionTempRoute = {
  __typename?: 'TravelLogUserJourneyReasonConnectionTempRoute';
  connection?: Maybe<TravelLogUserJourneyReasonConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogUserJourneyReasonConnectionUpdated_At = {
  __typename?: 'TravelLogUserJourneyReasonConnectionUpdated_at';
  connection?: Maybe<TravelLogUserJourneyReasonConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TravelLogUserJourneyReasonConnectionUser = {
  __typename?: 'TravelLogUserJourneyReasonConnectionUser';
  connection?: Maybe<TravelLogUserJourneyReasonConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TravelLogUserJourneyReasonGroupBy = {
  __typename?: 'TravelLogUserJourneyReasonGroupBy';
  created_at?: Maybe<Array<Maybe<TravelLogUserJourneyReasonConnectionCreated_At>>>;
  durationInHoursFrom?: Maybe<Array<Maybe<TravelLogUserJourneyReasonConnectionDurationInHoursFrom>>>;
  durationInHoursTo?: Maybe<Array<Maybe<TravelLogUserJourneyReasonConnectionDurationInHoursTo>>>;
  id?: Maybe<Array<Maybe<TravelLogUserJourneyReasonConnectionId>>>;
  name?: Maybe<Array<Maybe<TravelLogUserJourneyReasonConnectionName>>>;
  tempRoute?: Maybe<Array<Maybe<TravelLogUserJourneyReasonConnectionTempRoute>>>;
  updated_at?: Maybe<Array<Maybe<TravelLogUserJourneyReasonConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<TravelLogUserJourneyReasonConnectionUser>>>;
};

export type TravelLogUserJourneyReasonInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  durationInHoursFrom?: InputMaybe<Scalars['Float']>;
  durationInHoursTo?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  places?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tempRoute?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type UpdateModelAbilitiesInput = {
  data?: InputMaybe<Array<InputMaybe<AbilityInput>>>;
  where: Scalars['JSON'];
};

export type UpdateModelAbilitiesReturn = {
  __typename?: 'UpdateModelAbilitiesReturn';
  added: Array<Maybe<Ability>>;
  removed: Array<Maybe<Ability>>;
};

export type UpdateModelWatchListInput = {
  targetModelId: Scalars['String'];
  targetModelName: Scalars['String'];
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type UpdatedBy = {
  __typename?: 'UpdatedBy';
  blocked?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  preferedLanguage?: Maybe<Scalars['String']>;
  registrationToken?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
  size: Scalars['Float'];
  updated_at: Scalars['DateTime'];
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};


export type UploadFileRelatedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  avg?: Maybe<UploadFileAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<UploadFileAggregatorMax>;
  min?: Maybe<UploadFileAggregatorMin>;
  sum?: Maybe<UploadFileAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  aggregate?: Maybe<UploadFileAggregator>;
  groupBy?: Maybe<UploadFileGroupBy>;
  values?: Maybe<Array<Maybe<UploadFile>>>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
};

export type UserDevice = {
  __typename?: 'UserDevice';
  created_at: Scalars['DateTime'];
  fcmToken?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUsed?: Maybe<Scalars['DateTime']>;
  owner?: Maybe<UsersPermissionsUser>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};

export type UserDeviceAggregator = {
  __typename?: 'UserDeviceAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UserDeviceConnection = {
  __typename?: 'UserDeviceConnection';
  aggregate?: Maybe<UserDeviceAggregator>;
  groupBy?: Maybe<UserDeviceGroupBy>;
  values?: Maybe<Array<Maybe<UserDevice>>>;
};

export type UserDeviceConnectionCreated_At = {
  __typename?: 'UserDeviceConnectionCreated_at';
  connection?: Maybe<UserDeviceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UserDeviceConnectionFcmToken = {
  __typename?: 'UserDeviceConnectionFcmToken';
  connection?: Maybe<UserDeviceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UserDeviceConnectionId = {
  __typename?: 'UserDeviceConnectionId';
  connection?: Maybe<UserDeviceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UserDeviceConnectionLastUsed = {
  __typename?: 'UserDeviceConnectionLastUsed';
  connection?: Maybe<UserDeviceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UserDeviceConnectionOwner = {
  __typename?: 'UserDeviceConnectionOwner';
  connection?: Maybe<UserDeviceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UserDeviceConnectionPublished_At = {
  __typename?: 'UserDeviceConnectionPublished_at';
  connection?: Maybe<UserDeviceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UserDeviceConnectionUpdated_At = {
  __typename?: 'UserDeviceConnectionUpdated_at';
  connection?: Maybe<UserDeviceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UserDeviceGroupBy = {
  __typename?: 'UserDeviceGroupBy';
  created_at?: Maybe<Array<Maybe<UserDeviceConnectionCreated_At>>>;
  fcmToken?: Maybe<Array<Maybe<UserDeviceConnectionFcmToken>>>;
  id?: Maybe<Array<Maybe<UserDeviceConnectionId>>>;
  lastUsed?: Maybe<Array<Maybe<UserDeviceConnectionLastUsed>>>;
  owner?: Maybe<Array<Maybe<UserDeviceConnectionOwner>>>;
  published_at?: Maybe<Array<Maybe<UserDeviceConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<UserDeviceConnectionUpdated_At>>>;
};

export type UserDeviceInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  lastUsed?: InputMaybe<Scalars['DateTime']>;
  owner?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type UserInput = {
  abilities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['ID']>;
  administrator_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  approval_processes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  approvals?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  audit_log_records?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Scalars['ID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  departmentsWhereIsFinancialDecisionMaker?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  departments_where_assistant?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  departments_where_head?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  devices?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email: Scalars['String'];
  events?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  houses?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  image?: InputMaybe<Scalars['ID']>;
  managedProjects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  password?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  provider?: InputMaybe<Scalars['String']>;
  received_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  saved_filters?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sent_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  service_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_log_private_vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_log_user_journey_reasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
  username: Scalars['String'];
  uuid?: InputMaybe<Scalars['String']>;
  watch_lists?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UserSimple = {
  __typename?: 'UserSimple';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: InputMaybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  controller: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
  type: Scalars['String'];
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  abilities?: Maybe<Array<Maybe<Ability>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  type?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRoleAbilitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsRolePermissionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  abilities?: Maybe<Array<Maybe<Ability>>>;
  active?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Address>;
  administrator_in?: Maybe<Array<Maybe<Department>>>;
  approval_processes?: Maybe<Array<Maybe<ApprovalProcess>>>;
  approvals?: Maybe<Array<Maybe<ApprovalStep>>>;
  audit_log_records?: Maybe<Array<Maybe<AuditLogRecord>>>;
  blocked?: Maybe<Scalars['Boolean']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  confirmed?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['DateTime'];
  departments?: Maybe<Array<Maybe<Department>>>;
  departmentsWhereIsFinancialDecisionMaker?: Maybe<Array<Maybe<Department>>>;
  departments_where_assistant?: Maybe<Array<Maybe<Department>>>;
  departments_where_head?: Maybe<Array<Maybe<Department>>>;
  devices?: Maybe<Array<Maybe<UserDevice>>>;
  email: Scalars['String'];
  events?: Maybe<Array<Maybe<Event>>>;
  houses?: Maybe<Array<Maybe<House>>>;
  id: Scalars['ID'];
  image?: Maybe<UploadFile>;
  managedProjects?: Maybe<Array<Maybe<Project>>>;
  name?: Maybe<Scalars['String']>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  position?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<Project>>>;
  provider?: Maybe<Scalars['String']>;
  received_mails?: Maybe<Array<Maybe<ReceivedMail>>>;
  role?: Maybe<UsersPermissionsRole>;
  saved_filters?: Maybe<Array<Maybe<SavedFilter>>>;
  sent_mails?: Maybe<Array<Maybe<SentMail>>>;
  service_logs?: Maybe<Array<Maybe<ServiceLog>>>;
  tags?: Maybe<Array<Maybe<Tags>>>;
  travel_log_private_vehicles?: Maybe<Array<Maybe<TravelLogPrivateVehicle>>>;
  travel_log_user_journey_reasons?: Maybe<Array<Maybe<TravelLogUserJourneyReason>>>;
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  uuid?: Maybe<Scalars['String']>;
  watch_lists?: Maybe<Array<Maybe<WatchList>>>;
};


export type UsersPermissionsUserAbilitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserAdministrator_InArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserApproval_ProcessesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserApprovalsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserAudit_Log_RecordsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserDepartmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserDepartmentsWhereIsFinancialDecisionMakerArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserDepartments_Where_AssistantArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserDepartments_Where_HeadArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserDevicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserHousesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserManagedProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserReceived_MailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserSaved_FiltersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserSent_MailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserService_LogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserTravel_Log_Private_VehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserTravel_Log_User_Journey_ReasonsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsUserWatch_ListsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};

export type UsersPermissionsUserConnectionActive = {
  __typename?: 'UsersPermissionsUserConnectionActive';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type UsersPermissionsUserConnectionAddress = {
  __typename?: 'UsersPermissionsUserConnectionAddress';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionImage = {
  __typename?: 'UsersPermissionsUserConnectionImage';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionName = {
  __typename?: 'UsersPermissionsUserConnectionName';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionPosition = {
  __typename?: 'UsersPermissionsUserConnectionPosition';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionUuid = {
  __typename?: 'UsersPermissionsUserConnectionUuid';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  active?: Maybe<Array<Maybe<UsersPermissionsUserConnectionActive>>>;
  address?: Maybe<Array<Maybe<UsersPermissionsUserConnectionAddress>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  image?: Maybe<Array<Maybe<UsersPermissionsUserConnectionImage>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsUserConnectionName>>>;
  position?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPosition>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  uuid?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUuid>>>;
};

export type UsersSimpleWhereInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  registrationNumber?: Maybe<Scalars['String']>;
  service_logs?: Maybe<Array<Maybe<ServiceLog>>>;
  updated_at: Scalars['DateTime'];
};


export type VehicleService_LogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type VehicleAggregator = {
  __typename?: 'VehicleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VehicleConnection = {
  __typename?: 'VehicleConnection';
  aggregate?: Maybe<VehicleAggregator>;
  groupBy?: Maybe<VehicleGroupBy>;
  values?: Maybe<Array<Maybe<Vehicle>>>;
};

export type VehicleConnectionCreated_At = {
  __typename?: 'VehicleConnectionCreated_at';
  connection?: Maybe<VehicleConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type VehicleConnectionId = {
  __typename?: 'VehicleConnectionId';
  connection?: Maybe<VehicleConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type VehicleConnectionNote = {
  __typename?: 'VehicleConnectionNote';
  connection?: Maybe<VehicleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type VehicleConnectionPublished_At = {
  __typename?: 'VehicleConnectionPublished_at';
  connection?: Maybe<VehicleConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type VehicleConnectionRegistrationNumber = {
  __typename?: 'VehicleConnectionRegistrationNumber';
  connection?: Maybe<VehicleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type VehicleConnectionUpdated_At = {
  __typename?: 'VehicleConnectionUpdated_at';
  connection?: Maybe<VehicleConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type VehicleGroupBy = {
  __typename?: 'VehicleGroupBy';
  created_at?: Maybe<Array<Maybe<VehicleConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<VehicleConnectionId>>>;
  note?: Maybe<Array<Maybe<VehicleConnectionNote>>>;
  published_at?: Maybe<Array<Maybe<VehicleConnectionPublished_At>>>;
  registrationNumber?: Maybe<Array<Maybe<VehicleConnectionRegistrationNumber>>>;
  updated_at?: Maybe<Array<Maybe<VehicleConnectionUpdated_At>>>;
};

export type VehicleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  service_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type VersionRelease = {
  __typename?: 'VersionRelease';
  content?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  updated_at: Scalars['DateTime'];
  version?: Maybe<Scalars['String']>;
  versionNumerically?: Maybe<Scalars['Int']>;
};

export type VersionReleaseAggregator = {
  __typename?: 'VersionReleaseAggregator';
  avg?: Maybe<VersionReleaseAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<VersionReleaseAggregatorMax>;
  min?: Maybe<VersionReleaseAggregatorMin>;
  sum?: Maybe<VersionReleaseAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VersionReleaseAggregatorAvg = {
  __typename?: 'VersionReleaseAggregatorAvg';
  versionNumerically?: Maybe<Scalars['Float']>;
};

export type VersionReleaseAggregatorMax = {
  __typename?: 'VersionReleaseAggregatorMax';
  versionNumerically?: Maybe<Scalars['Float']>;
};

export type VersionReleaseAggregatorMin = {
  __typename?: 'VersionReleaseAggregatorMin';
  versionNumerically?: Maybe<Scalars['Float']>;
};

export type VersionReleaseAggregatorSum = {
  __typename?: 'VersionReleaseAggregatorSum';
  versionNumerically?: Maybe<Scalars['Float']>;
};

export type VersionReleaseConnection = {
  __typename?: 'VersionReleaseConnection';
  aggregate?: Maybe<VersionReleaseAggregator>;
  groupBy?: Maybe<VersionReleaseGroupBy>;
  values?: Maybe<Array<Maybe<VersionRelease>>>;
};

export type VersionReleaseConnectionContent = {
  __typename?: 'VersionReleaseConnectionContent';
  connection?: Maybe<VersionReleaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type VersionReleaseConnectionCreated_At = {
  __typename?: 'VersionReleaseConnectionCreated_at';
  connection?: Maybe<VersionReleaseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type VersionReleaseConnectionId = {
  __typename?: 'VersionReleaseConnectionId';
  connection?: Maybe<VersionReleaseConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type VersionReleaseConnectionUpdated_At = {
  __typename?: 'VersionReleaseConnectionUpdated_at';
  connection?: Maybe<VersionReleaseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type VersionReleaseConnectionVersion = {
  __typename?: 'VersionReleaseConnectionVersion';
  connection?: Maybe<VersionReleaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type VersionReleaseConnectionVersionNumerically = {
  __typename?: 'VersionReleaseConnectionVersionNumerically';
  connection?: Maybe<VersionReleaseConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type VersionReleaseGroupBy = {
  __typename?: 'VersionReleaseGroupBy';
  content?: Maybe<Array<Maybe<VersionReleaseConnectionContent>>>;
  created_at?: Maybe<Array<Maybe<VersionReleaseConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<VersionReleaseConnectionId>>>;
  updated_at?: Maybe<Array<Maybe<VersionReleaseConnectionUpdated_At>>>;
  version?: Maybe<Array<Maybe<VersionReleaseConnectionVersion>>>;
  versionNumerically?: Maybe<Array<Maybe<VersionReleaseConnectionVersionNumerically>>>;
};

export type VersionReleaseInput = {
  content?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['String']>;
  versionNumerically?: InputMaybe<Scalars['Int']>;
};

export type WatchList = {
  __typename?: 'WatchList';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  targetModelId?: Maybe<Scalars['String']>;
  targetModelName?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type WatchListUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type WatchListAggregator = {
  __typename?: 'WatchListAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WatchListConnection = {
  __typename?: 'WatchListConnection';
  aggregate?: Maybe<WatchListAggregator>;
  groupBy?: Maybe<WatchListGroupBy>;
  values?: Maybe<Array<Maybe<WatchList>>>;
};

export type WatchListConnectionCreated_At = {
  __typename?: 'WatchListConnectionCreated_at';
  connection?: Maybe<WatchListConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type WatchListConnectionId = {
  __typename?: 'WatchListConnectionId';
  connection?: Maybe<WatchListConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type WatchListConnectionTargetModelId = {
  __typename?: 'WatchListConnectionTargetModelId';
  connection?: Maybe<WatchListConnection>;
  key?: Maybe<Scalars['String']>;
};

export type WatchListConnectionTargetModelName = {
  __typename?: 'WatchListConnectionTargetModelName';
  connection?: Maybe<WatchListConnection>;
  key?: Maybe<Scalars['String']>;
};

export type WatchListConnectionUpdated_At = {
  __typename?: 'WatchListConnectionUpdated_at';
  connection?: Maybe<WatchListConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type WatchListGroupBy = {
  __typename?: 'WatchListGroupBy';
  created_at?: Maybe<Array<Maybe<WatchListConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<WatchListConnectionId>>>;
  targetModelId?: Maybe<Array<Maybe<WatchListConnectionTargetModelId>>>;
  targetModelName?: Maybe<Array<Maybe<WatchListConnectionTargetModelName>>>;
  updated_at?: Maybe<Array<Maybe<WatchListConnectionUpdated_At>>>;
};

export type WatchListInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CreateAbilityInput = {
  data?: InputMaybe<AbilityInput>;
};

export type CreateAbilityPayload = {
  __typename?: 'createAbilityPayload';
  ability?: Maybe<Ability>;
};

export type CreateAddressInput = {
  data?: InputMaybe<AddressInput>;
};

export type CreateAddressPayload = {
  __typename?: 'createAddressPayload';
  address?: Maybe<Address>;
};

export type CreateAnnouncmentInput = {
  data?: InputMaybe<AnnouncmentInput>;
};

export type CreateAnnouncmentPayload = {
  __typename?: 'createAnnouncmentPayload';
  announcment?: Maybe<Announcment>;
};

export type CreateApprovalProcessDisputeResolutionOptionInput = {
  data?: InputMaybe<ApprovalProcessDisputeResolutionOptionInput>;
};

export type CreateApprovalProcessDisputeResolutionOptionPayload = {
  __typename?: 'createApprovalProcessDisputeResolutionOptionPayload';
  approvalProcessDisputeResolutionOption?: Maybe<ApprovalProcessDisputeResolutionOption>;
};

export type CreateApprovalProcessInput = {
  data?: InputMaybe<ApprovalProcessInput>;
};

export type CreateApprovalProcessPayload = {
  __typename?: 'createApprovalProcessPayload';
  approvalProcess?: Maybe<ApprovalProcess>;
};

export type CreateApprovalStepInput = {
  data?: InputMaybe<ApprovalStepInput>;
};

export type CreateApprovalStepPayload = {
  __typename?: 'createApprovalStepPayload';
  approvalStep?: Maybe<ApprovalStep>;
};

export type CreateAuditLogRecordInput = {
  data?: InputMaybe<AuditLogRecordInput>;
};

export type CreateAuditLogRecordPayload = {
  __typename?: 'createAuditLogRecordPayload';
  auditLogRecord?: Maybe<AuditLogRecord>;
};

export type CreateCityInput = {
  data?: InputMaybe<CityInput>;
};

export type CreateCityPayload = {
  __typename?: 'createCityPayload';
  city?: Maybe<City>;
};

export type CreateCommentInput = {
  data?: InputMaybe<CommentInput>;
};

export type CreateCommentPayload = {
  __typename?: 'createCommentPayload';
  comment?: Maybe<Comment>;
};

export type CreateCompanyPartnerInput = {
  data?: InputMaybe<CompanyPartnerInput>;
};

export type CreateCompanyPartnerPayload = {
  __typename?: 'createCompanyPartnerPayload';
  companyPartner?: Maybe<CompanyPartner>;
};

export type CreateDepartmentInput = {
  data?: InputMaybe<DepartmentInput>;
};

export type CreateDepartmentPayload = {
  __typename?: 'createDepartmentPayload';
  department?: Maybe<Department>;
};

export type CreateEventInput = {
  data?: InputMaybe<EventInput>;
};

export type CreateEventPayload = {
  __typename?: 'createEventPayload';
  event?: Maybe<Event>;
};

export type CreateHouseInput = {
  data?: InputMaybe<HouseInput>;
};

export type CreateHousePayload = {
  __typename?: 'createHousePayload';
  house?: Maybe<House>;
};

export type CreateInvoiceInput = {
  data?: InputMaybe<InvoiceInput>;
};

export type CreateInvoicePayload = {
  __typename?: 'createInvoicePayload';
  invoice?: Maybe<Invoice>;
};

export type CreateInvoiceReadModelInput = {
  data?: InputMaybe<InvoiceReadModelInput>;
};

export type CreateInvoiceReadModelPayload = {
  __typename?: 'createInvoiceReadModelPayload';
  invoiceReadModel?: Maybe<InvoiceReadModel>;
};

export type CreateNotificationInput = {
  data?: InputMaybe<NotificationInput>;
};

export type CreateNotificationPayload = {
  __typename?: 'createNotificationPayload';
  notification?: Maybe<Notification>;
};

export type CreateProjectInput = {
  data?: InputMaybe<ProjectInput>;
};

export type CreateProjectPayload = {
  __typename?: 'createProjectPayload';
  project?: Maybe<Project>;
};

export type CreateReceivedMailInput = {
  data?: InputMaybe<ReceivedMailInput>;
};

export type CreateReceivedMailPayload = {
  __typename?: 'createReceivedMailPayload';
  receivedMail?: Maybe<ReceivedMail>;
};

export type CreateRoleInput = {
  data?: InputMaybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateS3FileInput = {
  data?: InputMaybe<S3FileInput>;
};

export type CreateS3FilePayload = {
  __typename?: 'createS3FilePayload';
  s3File?: Maybe<S3File>;
};

export type CreateSavedFilterInput = {
  data?: InputMaybe<SavedFilterInput>;
};

export type CreateSavedFilterPayload = {
  __typename?: 'createSavedFilterPayload';
  savedFilter?: Maybe<SavedFilter>;
};

export type CreateSentMailInput = {
  data?: InputMaybe<SentMailInput>;
};

export type CreateSentMailPayload = {
  __typename?: 'createSentMailPayload';
  sentMail?: Maybe<SentMail>;
};

export type CreateServiceLogInput = {
  data?: InputMaybe<ServiceLogInput>;
};

export type CreateServiceLogPayload = {
  __typename?: 'createServiceLogPayload';
  serviceLog?: Maybe<ServiceLog>;
};

export type CreateSharedContactPersonInput = {
  data?: InputMaybe<SharedContactPersonInput>;
};

export type CreateSharedContactPersonPayload = {
  __typename?: 'createSharedContactPersonPayload';
  sharedContactPerson?: Maybe<SharedContactPerson>;
};

export type CreateStorageFolderInput = {
  data?: InputMaybe<StorageFolderInput>;
};

export type CreateStorageFolderPayload = {
  __typename?: 'createStorageFolderPayload';
  storageFolder?: Maybe<StorageFolder>;
};

export type CreateTagInput = {
  data?: InputMaybe<TagInput>;
};

export type CreateTagPayload = {
  __typename?: 'createTagPayload';
  tag?: Maybe<Tags>;
};

export type CreateTravelLogConfigurationInput = {
  data?: InputMaybe<TravelLogConfigurationInput>;
};

export type CreateTravelLogConfigurationPayload = {
  __typename?: 'createTravelLogConfigurationPayload';
  travelLogConfiguration?: Maybe<TravelLogConfiguration>;
};

export type CreateTravelLogLogInput = {
  data?: InputMaybe<TravelLogLogInput>;
};

export type CreateTravelLogLogPayload = {
  __typename?: 'createTravelLogLogPayload';
  travelLogLog?: Maybe<TravelLogLog>;
};

export type CreateTravelLogPlaceInput = {
  data?: InputMaybe<TravelLogPlaceInput>;
};

export type CreateTravelLogPlacePayload = {
  __typename?: 'createTravelLogPlacePayload';
  travelLogPlace?: Maybe<TravelLogPlace>;
};

export type CreateTravelLogPlacesDistanceInput = {
  data?: InputMaybe<TravelLogPlacesDistanceInput>;
};

export type CreateTravelLogPlacesDistancePayload = {
  __typename?: 'createTravelLogPlacesDistancePayload';
  travelLogPlacesDistance?: Maybe<TravelLogPlacesDistance>;
};

export type CreateTravelLogPrivateVehicleInput = {
  data?: InputMaybe<TravelLogPrivateVehicleInput>;
};

export type CreateTravelLogPrivateVehiclePayload = {
  __typename?: 'createTravelLogPrivateVehiclePayload';
  travelLogPrivateVehicle?: Maybe<TravelLogPrivateVehicle>;
};

export type CreateTravelLogRouteInput = {
  data?: InputMaybe<TravelLogRouteInput>;
};

export type CreateTravelLogRoutePayload = {
  __typename?: 'createTravelLogRoutePayload';
  travelLogRoute?: Maybe<TravelLogRoute>;
};

export type CreateTravelLogRouteReasonInput = {
  data?: InputMaybe<TravelLogRouteReasonInput>;
};

export type CreateTravelLogRouteReasonPayload = {
  __typename?: 'createTravelLogRouteReasonPayload';
  travelLogRouteReason?: Maybe<TravelLogRouteReason>;
};

export type CreateTravelLogRouteTempInput = {
  data?: InputMaybe<TravelLogRouteTempInput>;
};

export type CreateTravelLogRouteTempPayload = {
  __typename?: 'createTravelLogRouteTempPayload';
  travelLogRouteTemp?: Maybe<TravelLogRouteTemp>;
};

export type CreateTravelLogUserJourneyReasonInput = {
  data?: InputMaybe<TravelLogUserJourneyReasonInput>;
};

export type CreateTravelLogUserJourneyReasonPayload = {
  __typename?: 'createTravelLogUserJourneyReasonPayload';
  travelLogUserJourneyReason?: Maybe<TravelLogUserJourneyReason>;
};

export type CreateUserDeviceInput = {
  data?: InputMaybe<UserDeviceInput>;
};

export type CreateUserDevicePayload = {
  __typename?: 'createUserDevicePayload';
  userDevice?: Maybe<UserDevice>;
};

export type CreateUserInput = {
  data?: InputMaybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type CreateVehicleInput = {
  data?: InputMaybe<VehicleInput>;
};

export type CreateVehiclePayload = {
  __typename?: 'createVehiclePayload';
  vehicle?: Maybe<Vehicle>;
};

export type CreateVersionReleaseInput = {
  data?: InputMaybe<VersionReleaseInput>;
};

export type CreateVersionReleasePayload = {
  __typename?: 'createVersionReleasePayload';
  versionRelease?: Maybe<VersionRelease>;
};

export type CreateWatchListInput = {
  data?: InputMaybe<WatchListInput>;
};

export type CreateWatchListPayload = {
  __typename?: 'createWatchListPayload';
  watchList?: Maybe<WatchList>;
};

export type DeleteAbilityInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteAbilityPayload = {
  __typename?: 'deleteAbilityPayload';
  ability?: Maybe<Ability>;
};

export type DeleteAddressInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteAddressPayload = {
  __typename?: 'deleteAddressPayload';
  address?: Maybe<Address>;
};

export type DeleteAnnouncmentInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteAnnouncmentPayload = {
  __typename?: 'deleteAnnouncmentPayload';
  announcment?: Maybe<Announcment>;
};

export type DeleteApprovalProcessDisputeResolutionOptionInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteApprovalProcessDisputeResolutionOptionPayload = {
  __typename?: 'deleteApprovalProcessDisputeResolutionOptionPayload';
  approvalProcessDisputeResolutionOption?: Maybe<ApprovalProcessDisputeResolutionOption>;
};

export type DeleteApprovalProcessInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteApprovalProcessPayload = {
  __typename?: 'deleteApprovalProcessPayload';
  approvalProcess?: Maybe<ApprovalProcess>;
};

export type DeleteApprovalStepInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteApprovalStepPayload = {
  __typename?: 'deleteApprovalStepPayload';
  approvalStep?: Maybe<ApprovalStep>;
};

export type DeleteAuditLogRecordInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteAuditLogRecordPayload = {
  __typename?: 'deleteAuditLogRecordPayload';
  auditLogRecord?: Maybe<AuditLogRecord>;
};

export type DeleteCityInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteCityPayload = {
  __typename?: 'deleteCityPayload';
  city?: Maybe<City>;
};

export type DeleteCommentInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteCommentPayload = {
  __typename?: 'deleteCommentPayload';
  comment?: Maybe<Comment>;
};

export type DeleteCompanyModulePayload = {
  __typename?: 'deleteCompanyModulePayload';
  companyModule?: Maybe<CompanyModule>;
};

export type DeleteCompanyPartnerInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteCompanyPartnerPayload = {
  __typename?: 'deleteCompanyPartnerPayload';
  companyPartner?: Maybe<CompanyPartner>;
};

export type DeleteDepartmentInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteDepartmentPayload = {
  __typename?: 'deleteDepartmentPayload';
  department?: Maybe<Department>;
};

export type DeleteEventInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteEventPayload = {
  __typename?: 'deleteEventPayload';
  event?: Maybe<Event>;
};

export type DeleteFileInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type DeleteHouseInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteHousePayload = {
  __typename?: 'deleteHousePayload';
  house?: Maybe<House>;
};

export type DeleteInvoiceInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteInvoicePayload = {
  __typename?: 'deleteInvoicePayload';
  invoice?: Maybe<Invoice>;
};

export type DeleteInvoiceReadModelInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteInvoiceReadModelPayload = {
  __typename?: 'deleteInvoiceReadModelPayload';
  invoiceReadModel?: Maybe<InvoiceReadModel>;
};

export type DeleteMailModulePayload = {
  __typename?: 'deleteMailModulePayload';
  mailModule?: Maybe<MailModule>;
};

export type DeleteNotificationInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteNotificationPayload = {
  __typename?: 'deleteNotificationPayload';
  notification?: Maybe<Notification>;
};

export type DeleteProjectInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteProjectPayload = {
  __typename?: 'deleteProjectPayload';
  project?: Maybe<Project>;
};

export type DeleteReceivedMailInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteReceivedMailPayload = {
  __typename?: 'deleteReceivedMailPayload';
  receivedMail?: Maybe<ReceivedMail>;
};

export type DeleteRoleInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteS3FileInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteS3FilePayload = {
  __typename?: 'deleteS3FilePayload';
  s3File?: Maybe<S3File>;
};

export type DeleteSavedFilterInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteSavedFilterPayload = {
  __typename?: 'deleteSavedFilterPayload';
  savedFilter?: Maybe<SavedFilter>;
};

export type DeleteSentMailInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteSentMailPayload = {
  __typename?: 'deleteSentMailPayload';
  sentMail?: Maybe<SentMail>;
};

export type DeleteServiceLogInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteServiceLogPayload = {
  __typename?: 'deleteServiceLogPayload';
  serviceLog?: Maybe<ServiceLog>;
};

export type DeleteSettingsModulePayload = {
  __typename?: 'deleteSettingsModulePayload';
  settingsModule?: Maybe<SettingsModule>;
};

export type DeleteSharedContactPersonInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteSharedContactPersonPayload = {
  __typename?: 'deleteSharedContactPersonPayload';
  sharedContactPerson?: Maybe<SharedContactPerson>;
};

export type DeleteStorageFolderInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteStorageFolderPayload = {
  __typename?: 'deleteStorageFolderPayload';
  storageFolder?: Maybe<StorageFolder>;
};

export type DeleteTagInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTagPayload = {
  __typename?: 'deleteTagPayload';
  tag?: Maybe<Tags>;
};

export type DeleteTravelLogConfigurationInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTravelLogConfigurationPayload = {
  __typename?: 'deleteTravelLogConfigurationPayload';
  travelLogConfiguration?: Maybe<TravelLogConfiguration>;
};

export type DeleteTravelLogLogInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTravelLogLogPayload = {
  __typename?: 'deleteTravelLogLogPayload';
  travelLogLog?: Maybe<TravelLogLog>;
};

export type DeleteTravelLogModulePayload = {
  __typename?: 'deleteTravelLogModulePayload';
  travelLogModule?: Maybe<TravelLogModule>;
};

export type DeleteTravelLogPlaceInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTravelLogPlacePayload = {
  __typename?: 'deleteTravelLogPlacePayload';
  travelLogPlace?: Maybe<TravelLogPlace>;
};

export type DeleteTravelLogPlacesDistanceInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTravelLogPlacesDistancePayload = {
  __typename?: 'deleteTravelLogPlacesDistancePayload';
  travelLogPlacesDistance?: Maybe<TravelLogPlacesDistance>;
};

export type DeleteTravelLogPrivateVehicleInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTravelLogPrivateVehiclePayload = {
  __typename?: 'deleteTravelLogPrivateVehiclePayload';
  travelLogPrivateVehicle?: Maybe<TravelLogPrivateVehicle>;
};

export type DeleteTravelLogRouteInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTravelLogRoutePayload = {
  __typename?: 'deleteTravelLogRoutePayload';
  travelLogRoute?: Maybe<TravelLogRoute>;
};

export type DeleteTravelLogRouteReasonInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTravelLogRouteReasonPayload = {
  __typename?: 'deleteTravelLogRouteReasonPayload';
  travelLogRouteReason?: Maybe<TravelLogRouteReason>;
};

export type DeleteTravelLogRouteTempInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTravelLogRouteTempPayload = {
  __typename?: 'deleteTravelLogRouteTempPayload';
  travelLogRouteTemp?: Maybe<TravelLogRouteTemp>;
};

export type DeleteTravelLogUserJourneyReasonInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTravelLogUserJourneyReasonPayload = {
  __typename?: 'deleteTravelLogUserJourneyReasonPayload';
  travelLogUserJourneyReason?: Maybe<TravelLogUserJourneyReason>;
};

export type DeleteUserDeviceInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteUserDevicePayload = {
  __typename?: 'deleteUserDevicePayload';
  userDevice?: Maybe<UserDevice>;
};

export type DeleteUserInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteVehicleInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteVehiclePayload = {
  __typename?: 'deleteVehiclePayload';
  vehicle?: Maybe<Vehicle>;
};

export type DeleteVersionReleaseInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteVersionReleasePayload = {
  __typename?: 'deleteVersionReleasePayload';
  versionRelease?: Maybe<VersionRelease>;
};

export type DeleteWatchListInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteWatchListPayload = {
  __typename?: 'deleteWatchListPayload';
  watchList?: Maybe<WatchList>;
};

export type EditAbilityInput = {
  action?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  house?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<Scalars['String']>;
  received_mail?: InputMaybe<Scalars['ID']>;
  role?: InputMaybe<Scalars['ID']>;
  targetModelId?: InputMaybe<Scalars['Int']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type EditAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  receivedMails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  received_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  street?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type EditAnnouncmentInput = {
  content?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditApprovalProcessDisputeResolutionOptionInput = {
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditApprovalProcessInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  manager?: InputMaybe<Scalars['ID']>;
  start?: InputMaybe<Scalars['DateTime']>;
  startOfCurrentPhaseIndex?: InputMaybe<Scalars['Int']>;
  startedBy?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Approvalprocess_Status>;
  steps?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditApprovalStepInput = {
  approval_process?: InputMaybe<Scalars['ID']>;
  at?: InputMaybe<Scalars['DateTime']>;
  created_by?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<Array<Scalars['ApprovalStepDataDynamicZoneInput']>>;
  index?: InputMaybe<Scalars['Int']>;
  next?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type EditAuditLogRecordInput = {
  action?: InputMaybe<Scalars['String']>;
  child_records?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  difference?: InputMaybe<Scalars['JSON']>;
  latitudeOfInitiatingDevice?: InputMaybe<Scalars['Float']>;
  longitudeOfInitiatingDevice?: InputMaybe<Scalars['Float']>;
  newData?: InputMaybe<Scalars['JSON']>;
  operatingSystemOfInitiatingDevice?: InputMaybe<Scalars['String']>;
  parent_record?: InputMaybe<Scalars['ID']>;
  previousData?: InputMaybe<Scalars['JSON']>;
  targetModelId?: InputMaybe<Scalars['Int']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type EditBuseventInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  emitted?: InputMaybe<Scalars['DateTime']>;
  eventType?: InputMaybe<Enum_Eventbusbusevent_Eventtype>;
  genesis?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
  traceId?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type EditCityInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditCommentInput = {
  author?: InputMaybe<Scalars['ID']>;
  content?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  isSubcomment?: InputMaybe<Scalars['Boolean']>;
  parentComment?: InputMaybe<Scalars['ID']>;
  subcomments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditCompanyModuleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditCompanyPartnerInput = {
  addresses?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  bankCode?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  iban?: InputMaybe<Scalars['String']>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  receivedMailSentTo?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sentMail?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  taxId?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vatId?: InputMaybe<Scalars['String']>;
};

export type EditComponentApprovalProcessApprovalProcessControlStepInput = {
  controlType?: InputMaybe<Enum_Componentapprovalprocessapprovalprocesscontrolstep_Controltype>;
  decisionReason?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  reasonRequired?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Enum_Componentapprovalprocessapprovalprocesscontrolstep_Status>;
};

export type EditComponentApprovalProcessApprovalProcessDisputeResolutionStepInput = {
  id?: InputMaybe<Scalars['ID']>;
  resolution?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Componentapprovalprocessapprovalprocessdisputeresolutionstep_Status>;
};

export type EditComponentApprovalProcessDisputeResolutionStepInput = {
  id?: InputMaybe<Scalars['ID']>;
  reinitializeApprovalProcess?: InputMaybe<Scalars['Boolean']>;
  resolution?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Componentapprovalprocessdisputeresolutionstep_Status>;
};

export type EditComponentApprovalProcessInformStepInput = {
  id?: InputMaybe<Scalars['ID']>;
  meta?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<Enum_Componentapprovalprocessinformstep_Type>;
};

export type EditComponentNotificationTagInput = {
  id?: InputMaybe<Scalars['ID']>;
  label?: InputMaybe<Scalars['String']>;
};

export type EditComponentSharedHouseAbilityInput = {
  house?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type EditComponentTravelLogDateInput = {
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type EditComponentTravelLogDestinationTravelLimitInput = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  place?: InputMaybe<Scalars['ID']>;
};

export type EditComponentTravelLogRouteInput = {
  id?: InputMaybe<Scalars['ID']>;
  maxUseLimit?: InputMaybe<Scalars['Int']>;
  route?: InputMaybe<Scalars['ID']>;
};

export type EditComponentTravelLogTravelLogLegInput = {
  date?: InputMaybe<Scalars['Date']>;
  distance?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['String']>;
  finish?: InputMaybe<Scalars['ID']>;
  finishTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['ID']>;
  journeyUuid?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['ID']>;
  start?: InputMaybe<Scalars['ID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  travelCompensation?: InputMaybe<Scalars['Float']>;
  workFinishTime?: InputMaybe<Scalars['Time']>;
  workStartTime?: InputMaybe<Scalars['Time']>;
};

export type EditComponentTravelLogTravelLogRouteLegInput = {
  distance?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  to?: InputMaybe<Scalars['ID']>;
};

export type EditDepartmentInput = {
  administrators?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  financialDecisionMaker?: InputMaybe<Scalars['ID']>;
  head?: InputMaybe<Scalars['ID']>;
  head_assistant?: InputMaybe<Scalars['ID']>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  maxInvoiceSumAllowedForDepartmentManager?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  received_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditEventInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  emitted?: InputMaybe<Scalars['DateTime']>;
  eventType?: InputMaybe<Enum_Event_Eventtype>;
  payload?: InputMaybe<Scalars['JSON']>;
  traceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type EditFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  ext?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  related?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  size?: InputMaybe<Scalars['Float']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type EditHouseInput = {
  abilities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  area?: InputMaybe<Scalars['String']>;
  cellar?: InputMaybe<Scalars['Boolean']>;
  colour?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  enum?: InputMaybe<Enum_House_Enum>;
  garden?: InputMaybe<Scalars['Boolean']>;
  numberOfStoreys?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  test?: InputMaybe<Scalars['Boolean']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditInvoiceInput = {
  approval_process?: InputMaybe<Scalars['ID']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  dateReceived?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<Scalars['ID']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  invoice_read_model?: InputMaybe<Scalars['ID']>;
  origin?: InputMaybe<Scalars['ID']>;
  pairingSymbol?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['ID']>;
  project?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Invoice_Status>;
  subject?: InputMaybe<Scalars['String']>;
  sum?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Enum_Invoice_Type>;
  updated_by?: InputMaybe<Scalars['ID']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
};

export type EditInvoiceReadModelInput = {
  approvalProcessCurrentStepId?: InputMaybe<Scalars['Int']>;
  approvalProcessCurrentStepType?: InputMaybe<Enum_Invoicereadmodel_Approvalprocesscurrentsteptype>;
  approvalProcessStatus?: InputMaybe<Enum_Invoicereadmodel_Approvalprocessstatus>;
  approvalProcessWaitingOn?: InputMaybe<Scalars['ID']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  dateReceived?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<Scalars['ID']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isAdvance?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<Scalars['ID']>;
  pairingSymbol?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['ID']>;
  project?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  source_entity?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Invoicereadmodel_Status>;
  subject?: InputMaybe<Scalars['String']>;
  sum?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Enum_Invoicereadmodel_Type>;
  updated_by?: InputMaybe<Scalars['ID']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
};

export type EditLocaleInput = {
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditMailModuleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditNotificationInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  read?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<EditComponentNotificationTagInput>>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Notification_Type>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type EditProjectInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  department?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  invoiceMaxSumAllowedForProjectManager?: InputMaybe<Scalars['Float']>;
  invoices?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  mainManager?: InputMaybe<Scalars['ID']>;
  managers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['ID']>;
  projectNumber?: InputMaybe<Scalars['String']>;
  received_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditReceivedMailInput = {
  abilities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignee?: InputMaybe<Scalars['ID']>;
  attachements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contents?: InputMaybe<Enum_Receivedmail_Contents>;
  created_by?: InputMaybe<Scalars['ID']>;
  dateReceived?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  previousNumber?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  processed?: InputMaybe<Scalars['Boolean']>;
  project?: InputMaybe<Scalars['ID']>;
  senderAddress?: InputMaybe<Scalars['ID']>;
  senderPartner?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Enum_Receivedmail_Status>;
  typeOfDelivery?: InputMaybe<Enum_Receivedmail_Typeofdelivery>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditRoleInput = {
  abilities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type EditS3FileInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sent_mail?: InputMaybe<Scalars['ID']>;
  storage_folder?: InputMaybe<Scalars['ID']>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EditSavedFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type EditSentMailInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  assignee?: InputMaybe<Scalars['ID']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contents?: InputMaybe<Enum_Sentmail_Contents>;
  created_by?: InputMaybe<Scalars['ID']>;
  dateSent?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  recipientAddress?: InputMaybe<Scalars['ID']>;
  recipientPartner?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditServiceLogInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  result?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vehicle?: InputMaybe<Scalars['ID']>;
};

export type EditSettingsModuleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditSharedContactPersonInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditStorageFolderInput = {
  child_folders?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isRoot?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_folder?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditTagInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditTravelLogConfigurationInput = {
  Name?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditTravelLogLogInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  blacklistedDates?: InputMaybe<Array<InputMaybe<EditComponentTravelLogDateInput>>>;
  compensationForFuel?: InputMaybe<Scalars['Float']>;
  compensationForTravel?: InputMaybe<Scalars['Float']>;
  created_by?: InputMaybe<Scalars['ID']>;
  destinationLimits?: InputMaybe<Array<InputMaybe<EditComponentTravelLogDestinationTravelLimitInput>>>;
  forMonth?: InputMaybe<Scalars['Date']>;
  legs?: InputMaybe<Array<InputMaybe<EditComponentTravelLogTravelLogLegInput>>>;
  neededKilometers?: InputMaybe<Scalars['Float']>;
  parametersUsedToGenerateLog?: InputMaybe<Scalars['JSON']>;
  priceOfFuel?: InputMaybe<Scalars['Float']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  routes?: InputMaybe<Array<InputMaybe<EditComponentTravelLogRouteInput>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vehicle?: InputMaybe<Scalars['ID']>;
};

export type EditTravelLogModuleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditTravelLogPlaceInput = {
  address?: InputMaybe<Scalars['String']>;
  balancingPlaceToVehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  cityCode?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  defualtDayLimit?: InputMaybe<Scalars['Int']>;
  distances?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  homePlaceToVehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  maxInCityTravel?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  reasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_log_private_vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_log_route_temps?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditTravelLogPlacesDistanceInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  distanceInKm?: InputMaybe<Scalars['Float']>;
  durationInSeconds?: InputMaybe<Scalars['Long']>;
  identifier?: InputMaybe<Scalars['String']>;
  places?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditTravelLogPrivateVehicleInput = {
  balancingPlace?: InputMaybe<Scalars['ID']>;
  created_by?: InputMaybe<Scalars['ID']>;
  fuelConsumption?: InputMaybe<Scalars['Float']>;
  homePlace?: InputMaybe<Scalars['ID']>;
  model?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['ID']>;
  places?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  registrationCertFiles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  registrationCertificate?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  registrationPlate?: InputMaybe<Scalars['String']>;
  routes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tempRoutes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditTravelLogRouteInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  legs?: InputMaybe<Array<InputMaybe<EditComponentTravelLogTravelLogRouteLegInput>>>;
  overallDistance?: InputMaybe<Scalars['Float']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vehicle?: InputMaybe<Scalars['ID']>;
};

export type EditTravelLogRouteReasonInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  routes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
};

export type EditTravelLogRouteTempInput = {
  balancing?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Scalars['ID']>;
  defaultMonthLimit?: InputMaybe<Scalars['Int']>;
  destination?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  vehicle?: InputMaybe<Scalars['ID']>;
};

export type EditTravelLogUserJourneyReasonInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  durationInHoursFrom?: InputMaybe<Scalars['Float']>;
  durationInHoursTo?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  places?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tempRoute?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type EditUserDeviceInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  lastUsed?: InputMaybe<Scalars['DateTime']>;
  owner?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditUserInput = {
  abilities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['ID']>;
  administrator_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  approval_processes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  approvals?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  audit_log_records?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Scalars['ID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  departmentsWhereIsFinancialDecisionMaker?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  departments_where_assistant?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  departments_where_head?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  devices?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  houses?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  image?: InputMaybe<Scalars['ID']>;
  managedProjects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  password?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  provider?: InputMaybe<Scalars['String']>;
  received_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  saved_filters?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sent_mails?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  service_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_log_private_vehicles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  travel_log_user_journey_reasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  watch_lists?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type EditVehicleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  service_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditVersionReleaseInput = {
  content?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['String']>;
  versionNumerically?: InputMaybe<Scalars['Int']>;
};

export type EditWatchListInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  targetModelId?: InputMaybe<Scalars['String']>;
  targetModelName?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UpdateAbilityInput = {
  data?: InputMaybe<EditAbilityInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateAbilityPayload = {
  __typename?: 'updateAbilityPayload';
  ability?: Maybe<Ability>;
};

export type UpdateAddressInput = {
  data?: InputMaybe<EditAddressInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateAddressPayload = {
  __typename?: 'updateAddressPayload';
  address?: Maybe<Address>;
};

export type UpdateAnnouncmentInput = {
  data?: InputMaybe<EditAnnouncmentInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateAnnouncmentPayload = {
  __typename?: 'updateAnnouncmentPayload';
  announcment?: Maybe<Announcment>;
};

export type UpdateApprovalProcessDisputeResolutionOptionInput = {
  data?: InputMaybe<EditApprovalProcessDisputeResolutionOptionInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateApprovalProcessDisputeResolutionOptionPayload = {
  __typename?: 'updateApprovalProcessDisputeResolutionOptionPayload';
  approvalProcessDisputeResolutionOption?: Maybe<ApprovalProcessDisputeResolutionOption>;
};

export type UpdateApprovalProcessInput = {
  data?: InputMaybe<EditApprovalProcessInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateApprovalProcessPayload = {
  __typename?: 'updateApprovalProcessPayload';
  approvalProcess?: Maybe<ApprovalProcess>;
};

export type UpdateApprovalStepInput = {
  data?: InputMaybe<EditApprovalStepInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateApprovalStepPayload = {
  __typename?: 'updateApprovalStepPayload';
  approvalStep?: Maybe<ApprovalStep>;
};

export type UpdateAuditLogRecordInput = {
  data?: InputMaybe<EditAuditLogRecordInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateAuditLogRecordPayload = {
  __typename?: 'updateAuditLogRecordPayload';
  auditLogRecord?: Maybe<AuditLogRecord>;
};

export type UpdateCityInput = {
  data?: InputMaybe<EditCityInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateCityPayload = {
  __typename?: 'updateCityPayload';
  city?: Maybe<City>;
};

export type UpdateCommentInput = {
  data?: InputMaybe<EditCommentInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateCommentPayload = {
  __typename?: 'updateCommentPayload';
  comment?: Maybe<Comment>;
};

export type UpdateCompanyModuleInput = {
  data?: InputMaybe<EditCompanyModuleInput>;
};

export type UpdateCompanyModulePayload = {
  __typename?: 'updateCompanyModulePayload';
  companyModule?: Maybe<CompanyModule>;
};

export type UpdateCompanyPartnerInput = {
  data?: InputMaybe<EditCompanyPartnerInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateCompanyPartnerPayload = {
  __typename?: 'updateCompanyPartnerPayload';
  companyPartner?: Maybe<CompanyPartner>;
};

export type UpdateDepartmentInput = {
  data?: InputMaybe<EditDepartmentInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateDepartmentPayload = {
  __typename?: 'updateDepartmentPayload';
  department?: Maybe<Department>;
};

export type UpdateEventInput = {
  data?: InputMaybe<EditEventInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateEventPayload = {
  __typename?: 'updateEventPayload';
  event?: Maybe<Event>;
};

export type UpdateHouseInput = {
  data?: InputMaybe<EditHouseInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateHousePayload = {
  __typename?: 'updateHousePayload';
  house?: Maybe<House>;
};

export type UpdateInvoiceInput = {
  data?: InputMaybe<EditInvoiceInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateInvoicePayload = {
  __typename?: 'updateInvoicePayload';
  invoice?: Maybe<Invoice>;
};

export type UpdateInvoiceReadModelInput = {
  data?: InputMaybe<EditInvoiceReadModelInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateInvoiceReadModelPayload = {
  __typename?: 'updateInvoiceReadModelPayload';
  invoiceReadModel?: Maybe<InvoiceReadModel>;
};

export type UpdateMailModuleInput = {
  data?: InputMaybe<EditMailModuleInput>;
};

export type UpdateMailModulePayload = {
  __typename?: 'updateMailModulePayload';
  mailModule?: Maybe<MailModule>;
};

export type UpdateNotificationInput = {
  data?: InputMaybe<EditNotificationInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateNotificationPayload = {
  __typename?: 'updateNotificationPayload';
  notification?: Maybe<Notification>;
};

export type UpdateProjectInput = {
  data?: InputMaybe<EditProjectInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateProjectPayload = {
  __typename?: 'updateProjectPayload';
  project?: Maybe<Project>;
};

export type UpdateReceivedMailInput = {
  data?: InputMaybe<EditReceivedMailInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateReceivedMailPayload = {
  __typename?: 'updateReceivedMailPayload';
  receivedMail?: Maybe<ReceivedMail>;
};

export type UpdateRoleInput = {
  data?: InputMaybe<EditRoleInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateS3FileInput = {
  data?: InputMaybe<EditS3FileInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateS3FilePayload = {
  __typename?: 'updateS3FilePayload';
  s3File?: Maybe<S3File>;
};

export type UpdateSavedFilterInput = {
  data?: InputMaybe<EditSavedFilterInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateSavedFilterPayload = {
  __typename?: 'updateSavedFilterPayload';
  savedFilter?: Maybe<SavedFilter>;
};

export type UpdateSentMailInput = {
  data?: InputMaybe<EditSentMailInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateSentMailPayload = {
  __typename?: 'updateSentMailPayload';
  sentMail?: Maybe<SentMail>;
};

export type UpdateServiceLogInput = {
  data?: InputMaybe<EditServiceLogInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateServiceLogPayload = {
  __typename?: 'updateServiceLogPayload';
  serviceLog?: Maybe<ServiceLog>;
};

export type UpdateSettingsModuleInput = {
  data?: InputMaybe<EditSettingsModuleInput>;
};

export type UpdateSettingsModulePayload = {
  __typename?: 'updateSettingsModulePayload';
  settingsModule?: Maybe<SettingsModule>;
};

export type UpdateSharedContactPersonInput = {
  data?: InputMaybe<EditSharedContactPersonInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateSharedContactPersonPayload = {
  __typename?: 'updateSharedContactPersonPayload';
  sharedContactPerson?: Maybe<SharedContactPerson>;
};

export type UpdateStorageFolderInput = {
  data?: InputMaybe<EditStorageFolderInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateStorageFolderPayload = {
  __typename?: 'updateStorageFolderPayload';
  storageFolder?: Maybe<StorageFolder>;
};

export type UpdateTagInput = {
  data?: InputMaybe<EditTagInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTagPayload = {
  __typename?: 'updateTagPayload';
  tag?: Maybe<Tags>;
};

export type UpdateTravelLogConfigurationInput = {
  data?: InputMaybe<EditTravelLogConfigurationInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTravelLogConfigurationPayload = {
  __typename?: 'updateTravelLogConfigurationPayload';
  travelLogConfiguration?: Maybe<TravelLogConfiguration>;
};

export type UpdateTravelLogLogInput = {
  data?: InputMaybe<EditTravelLogLogInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTravelLogLogPayload = {
  __typename?: 'updateTravelLogLogPayload';
  travelLogLog?: Maybe<TravelLogLog>;
};

export type UpdateTravelLogModuleInput = {
  data?: InputMaybe<EditTravelLogModuleInput>;
};

export type UpdateTravelLogModulePayload = {
  __typename?: 'updateTravelLogModulePayload';
  travelLogModule?: Maybe<TravelLogModule>;
};

export type UpdateTravelLogPlaceInput = {
  data?: InputMaybe<EditTravelLogPlaceInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTravelLogPlacePayload = {
  __typename?: 'updateTravelLogPlacePayload';
  travelLogPlace?: Maybe<TravelLogPlace>;
};

export type UpdateTravelLogPlacesDistanceInput = {
  data?: InputMaybe<EditTravelLogPlacesDistanceInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTravelLogPlacesDistancePayload = {
  __typename?: 'updateTravelLogPlacesDistancePayload';
  travelLogPlacesDistance?: Maybe<TravelLogPlacesDistance>;
};

export type UpdateTravelLogPrivateVehicleInput = {
  data?: InputMaybe<EditTravelLogPrivateVehicleInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTravelLogPrivateVehiclePayload = {
  __typename?: 'updateTravelLogPrivateVehiclePayload';
  travelLogPrivateVehicle?: Maybe<TravelLogPrivateVehicle>;
};

export type UpdateTravelLogRouteInput = {
  data?: InputMaybe<EditTravelLogRouteInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTravelLogRoutePayload = {
  __typename?: 'updateTravelLogRoutePayload';
  travelLogRoute?: Maybe<TravelLogRoute>;
};

export type UpdateTravelLogRouteReasonInput = {
  data?: InputMaybe<EditTravelLogRouteReasonInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTravelLogRouteReasonPayload = {
  __typename?: 'updateTravelLogRouteReasonPayload';
  travelLogRouteReason?: Maybe<TravelLogRouteReason>;
};

export type UpdateTravelLogRouteTempInput = {
  data?: InputMaybe<EditTravelLogRouteTempInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTravelLogRouteTempPayload = {
  __typename?: 'updateTravelLogRouteTempPayload';
  travelLogRouteTemp?: Maybe<TravelLogRouteTemp>;
};

export type UpdateTravelLogUserJourneyReasonInput = {
  data?: InputMaybe<EditTravelLogUserJourneyReasonInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTravelLogUserJourneyReasonPayload = {
  __typename?: 'updateTravelLogUserJourneyReasonPayload';
  travelLogUserJourneyReason?: Maybe<TravelLogUserJourneyReason>;
};

export type UpdateUserDeviceInput = {
  data?: InputMaybe<EditUserDeviceInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateUserDevicePayload = {
  __typename?: 'updateUserDevicePayload';
  userDevice?: Maybe<UserDevice>;
};

export type UpdateUserInput = {
  data?: InputMaybe<EditUserInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateVehicleInput = {
  data?: InputMaybe<EditVehicleInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateVehiclePayload = {
  __typename?: 'updateVehiclePayload';
  vehicle?: Maybe<Vehicle>;
};

export type UpdateVersionReleaseInput = {
  data?: InputMaybe<EditVersionReleaseInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateVersionReleasePayload = {
  __typename?: 'updateVersionReleasePayload';
  versionRelease?: Maybe<VersionRelease>;
};

export type UpdateWatchListInput = {
  data?: InputMaybe<EditWatchListInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateWatchListPayload = {
  __typename?: 'updateWatchListPayload';
  watchList?: Maybe<WatchList>;
};

export type GetDisputeResolutionOptionsForModelQueryVariables = Exact<{
  modelName: Scalars['String'];
}>;


export type GetDisputeResolutionOptionsForModelQuery = { __typename?: 'Query', approvalProcessDisputeResolutionOptions?: Array<(
    { __typename?: 'ApprovalProcessDisputeResolutionOption' }
    & DisputeResolutionOptionFragmentFragment
  ) | null | undefined> | null | undefined };

export type DisputeResolutionOptionFragmentFragment = { __typename?: 'ApprovalProcessDisputeResolutionOption', id: string, name?: string | null | undefined, targetModelName?: string | null | undefined, code?: string | null | undefined };

export type ApprovalProcessFragmentFragment = { __typename?: 'ApprovalProcess', status?: Enum_Approvalprocess_Status | null | undefined, startOfCurrentPhaseIndex?: number | null | undefined, steps?: Array<(
    { __typename?: 'ApprovalStep' }
    & ApprovalProcessStepFragment
  ) | null | undefined> | null | undefined };

export type ApproveOrRejectApprovalStepMutationVariables = Exact<{
  input: ApproveOrRejectApprovalStepInput;
}>;


export type ApproveOrRejectApprovalStepMutation = { __typename?: 'Mutation', approveOrRejectApprovalStep?: { __typename?: 'ApprovalProcessUpdateReturn', approval_process?: (
      { __typename?: 'ApprovalProcess' }
      & ApprovalProcessFragmentFragment
    ) | null | undefined } | null | undefined };

export type ResolveDisputeMutationVariables = Exact<{
  input?: InputMaybe<ResolveDisputeInput>;
}>;


export type ResolveDisputeMutation = { __typename?: 'Mutation', resolveDispute?: { __typename?: 'ApprovalProcessUpdateReturn', approval_process?: (
      { __typename?: 'ApprovalProcess' }
      & ApprovalProcessFragmentFragment
    ) | null | undefined } | null | undefined };

export type InitializeApprovalProcessMutationVariables = Exact<{
  input: InitializeApprovalProcessInput;
}>;


export type InitializeApprovalProcessMutation = { __typename?: 'Mutation', initializeApprovalProcess?: boolean | null | undefined };

export type GetApprovalProcessesQueryVariables = Exact<{
  input: Scalars['JSON'];
}>;


export type GetApprovalProcessesQuery = { __typename?: 'Query', approvalProcesses?: Array<(
    { __typename?: 'ApprovalProcess' }
    & ApprovalProcessFragmentFragment
  ) | null | undefined> | null | undefined };

export type ApprovalControlStepDataFragment = { __typename: 'ComponentApprovalProcessApprovalProcessControlStep', id: string, status?: Enum_Componentapprovalprocessapprovalprocesscontrolstep_Status | null | undefined, controlType?: Enum_Componentapprovalprocessapprovalprocesscontrolstep_Controltype | null | undefined, reasonRequired?: string | null | undefined, decisionReason?: string | null | undefined };

export type ApprovalDisputeResolutionDataFragment = { __typename: 'ComponentApprovalProcessDisputeResolutionStep', reinitializeApprovalProcess?: boolean | null | undefined, disputeResolutionStatus?: Enum_Componentapprovalprocessdisputeresolutionstep_Status | null | undefined, resolution?: { __typename?: 'ApprovalProcessDisputeResolutionOption', name?: string | null | undefined } | null | undefined };

export type ApprovalInformStepDataFragment = { __typename: 'ComponentApprovalProcessInformStep', type?: Enum_Componentapprovalprocessinformstep_Type | null | undefined };

export type ApprovalProcessStepFragment = { __typename?: 'ApprovalStep', id: string, updated_at: any, at?: any | null | undefined, note?: string | null | undefined, index?: number | null | undefined, user?: { __typename?: 'UsersPermissionsUser', id: string, name?: string | null | undefined } | null | undefined, data?: Array<(
    { __typename?: 'ComponentApprovalProcessApprovalProcessControlStep' }
    & ApprovalControlStepDataFragment
  ) | (
    { __typename?: 'ComponentApprovalProcessDisputeResolutionStep' }
    & ApprovalDisputeResolutionDataFragment
  ) | (
    { __typename?: 'ComponentApprovalProcessInformStep' }
    & ApprovalInformStepDataFragment
  ) | null | undefined> | null | undefined };

export type GetApprovalStepQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetApprovalStepQuery = { __typename?: 'Query', approvalStep?: { __typename?: 'ApprovalStep', id: string } | null | undefined };

export type AddEntityCommentMutationVariables = Exact<{
  input: AddEntityCommentInput;
}>;


export type AddEntityCommentMutation = { __typename?: 'Mutation', addEntityComment?: { __typename?: 'Comment', id: string } | null | undefined };

export type BasicCommentFragmentFragment = { __typename?: 'Comment', id: string, created_at: any, updated_at: any, content?: string | null | undefined, subcomments?: Array<{ __typename?: 'Comment', id: string } | null | undefined> | null | undefined, author?: { __typename?: 'UsersPermissionsUser', name?: string | null | undefined, email: string, image?: { __typename?: 'UploadFile', previewUrl?: string | null | undefined } | null | undefined } | null | undefined };

export type GetEntityCommentsQueryVariables = Exact<{
  targetModelName: Scalars['String'];
  targetModelId: Scalars['ID'];
}>;


export type GetEntityCommentsQuery = { __typename?: 'Query', comments?: Array<(
    { __typename?: 'Comment' }
    & BasicCommentFragmentFragment
  ) | null | undefined> | null | undefined };

export type GetUsersForMentionQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type GetUsersForMentionQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'UsersPermissionsUser', id: string, name?: string | null | undefined, uuid?: string | null | undefined } | null | undefined> | null | undefined };

export type InvoiceReadModelFragmentFragment = { __typename?: 'InvoiceReadModel', id: string, dateReceived?: any | null | undefined, invoiceNumber?: string | null | undefined, subject?: string | null | undefined, variableSymbol?: string | null | undefined, pairingSymbol?: string | null | undefined, status?: Enum_Invoicereadmodel_Status | null | undefined, type?: Enum_Invoicereadmodel_Type | null | undefined, approvalProcessCurrentStepId?: number | null | undefined, approvalProcessCurrentStepType?: Enum_Invoicereadmodel_Approvalprocesscurrentsteptype | null | undefined, approvalProcessStatus?: Enum_Invoicereadmodel_Approvalprocessstatus | null | undefined, dueDate?: any | null | undefined, sum?: number | null | undefined, source_entity?: { __typename?: 'Invoice', id: string } | null | undefined, approvalProcessWaitingOn?: { __typename?: 'UsersPermissionsUser', name?: string | null | undefined, id: string } | null | undefined, attachments?: Array<{ __typename?: 'S3File', id: string, name?: string | null | undefined, type?: string | null | undefined } | null | undefined> | null | undefined, department?: { __typename?: 'Department', id: string, name?: string | null | undefined } | null | undefined, partner?: { __typename?: 'CompanyPartner', id: string, name?: string | null | undefined } | null | undefined, origin?: { __typename?: 'ReceivedMail', id: string } | null | undefined, project?: { __typename?: 'Project', name?: string | null | undefined, id: string } | null | undefined };

export type GetInvoiceReadModelsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where: Scalars['JSON'];
}>;


export type GetInvoiceReadModelsQuery = { __typename?: 'Query', invoiceReadModelCount: number, invoiceReadModels?: Array<(
    { __typename?: 'InvoiceReadModel' }
    & InvoiceReadModelFragmentFragment
  ) | null | undefined> | null | undefined };

export type ManuallyMarkNotificationAsMutationVariables = Exact<{
  id: InputId;
  read?: InputMaybe<Scalars['Boolean']>;
}>;


export type ManuallyMarkNotificationAsMutation = { __typename?: 'Mutation', updateNotification?: { __typename?: 'updateNotificationPayload', notification?: { __typename?: 'Notification', id: string } | null | undefined } | null | undefined };

export type ReceivedMailEntityFragmentFragment = { __typename?: 'ReceivedMail', id: string, dateReceived?: any | null | undefined, status?: Enum_Receivedmail_Status | null | undefined, contents: Enum_Receivedmail_Contents, typeOfDelivery: Enum_Receivedmail_Typeofdelivery, previousNumber?: string | null | undefined, note?: string | null | undefined, priority?: number | null | undefined, processed?: boolean | null | undefined, senderPartner?: { __typename?: 'CompanyPartner', id: string, name?: string | null | undefined } | null | undefined, senderAddress?: { __typename?: 'Address', id: string, name?: string | null | undefined } | null | undefined, department?: { __typename?: 'Department', id: string, name?: string | null | undefined } | null | undefined, project?: { __typename?: 'Project', id: string, name?: string | null | undefined } | null | undefined, assignee?: { __typename?: 'UsersPermissionsUser', id: string, name?: string | null | undefined } | null | undefined, invoice?: { __typename?: 'Invoice', id: string, invoiceNumber?: string | null | undefined } | null | undefined, attachements?: Array<{ __typename?: 'S3File', id: string, name?: string | null | undefined, type?: string | null | undefined } | null | undefined> | null | undefined };

export type SetMailStatusMutationVariables = Exact<{
  input: SetMailStatusInput;
}>;


export type SetMailStatusMutation = { __typename?: 'Mutation', setMailStatus?: (
    { __typename?: 'ReceivedMail' }
    & ReceivedMailEntityFragmentFragment
  ) | null | undefined };

export type SaveFilterMutationVariables = Exact<{
  input: CreateSavedFilterInput;
}>;


export type SaveFilterMutation = { __typename?: 'Mutation', createSavedFilter?: { __typename?: 'createSavedFilterPayload', savedFilter?: (
      { __typename?: 'SavedFilter' }
      & SavedFilterFragmentFragment
    ) | null | undefined } | null | undefined };

export type UpdateSavedFilterMutationVariables = Exact<{
  input: UpdateSavedFilterInput;
}>;


export type UpdateSavedFilterMutation = { __typename?: 'Mutation', updateSavedFilter?: { __typename?: 'updateSavedFilterPayload', savedFilter?: (
      { __typename?: 'SavedFilter' }
      & SavedFilterFragmentFragment
    ) | null | undefined } | null | undefined };

export type DeleteSavedFilterMutationVariables = Exact<{
  input: DeleteSavedFilterInput;
}>;


export type DeleteSavedFilterMutation = { __typename?: 'Mutation', deleteSavedFilter?: { __typename?: 'deleteSavedFilterPayload', savedFilter?: (
      { __typename?: 'SavedFilter' }
      & SavedFilterFragmentFragment
    ) | null | undefined } | null | undefined };

export type SavedFilterFragmentFragment = { __typename?: 'SavedFilter', id: string, name?: string | null | undefined, filters?: any | null | undefined, targetModelName?: string | null | undefined };

export type MySavedFiltersQueryVariables = Exact<{
  where?: InputMaybe<MyFiltersWhereInput>;
}>;


export type MySavedFiltersQuery = { __typename?: 'Query', myFilters: Array<(
    { __typename?: 'SavedFilter' }
    & SavedFilterFragmentFragment
  ) | null | undefined> };

export type TableServiceLogFragment = { __typename?: 'ServiceLog', id: string, date?: any | null | undefined, description?: string | null | undefined, result?: string | null | undefined, employee?: { __typename?: 'UsersPermissionsUser', name?: string | null | undefined, id: string } | null | undefined, vehicle?: { __typename?: 'Vehicle', registrationNumber?: string | null | undefined } | null | undefined };

export type GetServiceLogsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type GetServiceLogsQuery = { __typename?: 'Query', serviceLogsCount: number, serviceLogs?: Array<(
    { __typename?: 'ServiceLog' }
    & TableServiceLogFragment
  ) | null | undefined> | null | undefined };

export type CreateStorageFolderMutationVariables = Exact<{
  input: CreateStorageFolderInput;
}>;


export type CreateStorageFolderMutation = { __typename?: 'Mutation', createStorageFolder?: { __typename?: 'createStorageFolderPayload', storageFolder?: { __typename?: 'StorageFolder', id: string, name: string } | null | undefined } | null | undefined };

export type CurrentFolderFilesAndFoldersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CurrentFolderFilesAndFoldersQuery = { __typename?: 'Query', storageFolder?: { __typename?: 'StorageFolder', files?: Array<{ __typename?: 'S3File', id: string, type?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined, child_folders?: Array<{ __typename?: 'StorageFolder', id: string, name: string } | null | undefined> | null | undefined } | null | undefined };

export type FolderFragmentFragment = { __typename?: 'StorageFolder', name: string, id: string, path: string, parent_folder?: { __typename?: 'StorageFolder', id: string } | null | undefined };

export type FileFragmentFragment = { __typename?: 'S3File', id: string, name?: string | null | undefined, key?: string | null | undefined, type?: string | null | undefined, uploadedAt?: any | null | undefined };

export type GetFolderByPathQueryVariables = Exact<{
  where: Scalars['JSON'];
}>;


export type GetFolderByPathQuery = { __typename?: 'Query', storageFolders?: Array<(
    { __typename?: 'StorageFolder' }
    & FolderFragmentFragment
  ) | null | undefined> | null | undefined };

export type GetFolderFilesQueryVariables = Exact<{
  where: Scalars['JSON'];
}>;


export type GetFolderFilesQuery = { __typename?: 'Query', s3Files?: Array<(
    { __typename?: 'S3File' }
    & FileFragmentFragment
  ) | null | undefined> | null | undefined };

export type GetFolderSubFoldersQueryVariables = Exact<{
  where: Scalars['JSON'];
}>;


export type GetFolderSubFoldersQuery = { __typename?: 'Query', storageFolders?: Array<(
    { __typename?: 'StorageFolder' }
    & FolderFragmentFragment
  ) | null | undefined> | null | undefined };

export type VehicleRoutesRouteFragment = { __typename?: 'TravelLogRouteTemp', id: string, defaultMonthLimit?: number | null | undefined, reason?: { __typename?: 'TravelLogUserJourneyReason', name?: string | null | undefined, durationInHoursFrom?: number | null | undefined, durationInHoursTo?: number | null | undefined } | null | undefined, destination?: { __typename?: 'TravelLogPlace', id: string, name?: string | null | undefined, cityCode?: string | null | undefined, address?: string | null | undefined } | null | undefined };

export type GetVehicleRoutesQueryVariables = Exact<{
  where: Scalars['JSON'];
}>;


export type GetVehicleRoutesQuery = { __typename?: 'Query', travelLogRouteTemps?: Array<(
    { __typename?: 'TravelLogRouteTemp' }
    & VehicleRoutesRouteFragment
  ) | null | undefined> | null | undefined };

export type CreateVehicleRouteMutationVariables = Exact<{
  input?: InputMaybe<CreateVehicleRouteInput>;
}>;


export type CreateVehicleRouteMutation = { __typename?: 'Mutation', createVehicleRoute?: (
    { __typename?: 'TravelLogRouteTemp' }
    & VehicleRoutesRouteFragment
  ) | null | undefined };

export type DeleteVehicleRouteMutationVariables = Exact<{
  input?: InputMaybe<DeleteTravelLogRouteTempInput>;
}>;


export type DeleteVehicleRouteMutation = { __typename?: 'Mutation', deleteTravelLogRouteTemp?: { __typename?: 'deleteTravelLogRouteTempPayload', travelLogRouteTemp?: { __typename?: 'TravelLogRouteTemp', id: string } | null | undefined } | null | undefined };

export type SimpleUserFragmentFragment = { __typename?: 'UserSimple', id: string, name: string };

export type GetUsersSimpleQueryVariables = Exact<{
  where?: InputMaybe<UsersSimpleWhereInput>;
}>;


export type GetUsersSimpleQuery = { __typename?: 'Query', getUsersSimple: Array<(
    { __typename?: 'UserSimple' }
    & SimpleUserFragmentFragment
  ) | null | undefined> };

export type GetVersionAnnouncmentsAfterVersionQueryVariables = Exact<{
  version?: InputMaybe<Scalars['Int']>;
}>;


export type GetVersionAnnouncmentsAfterVersionQuery = { __typename?: 'Query', versionReleases?: Array<{ __typename?: 'VersionRelease', version?: string | null | undefined, versionNumerically?: number | null | undefined, content?: string | null | undefined } | null | undefined> | null | undefined };

export type WatchListFragmentFragment = { __typename?: 'WatchList', targetModelName?: string | null | undefined, targetModelId?: string | null | undefined, users?: Array<{ __typename?: 'UsersPermissionsUser', id: string, name?: string | null | undefined } | null | undefined> | null | undefined };

export type UpdateWatchListMutationVariables = Exact<{
  input?: InputMaybe<UpdateModelWatchListInput>;
}>;


export type UpdateWatchListMutation = { __typename?: 'Mutation', updateModelWatchList?: (
    { __typename?: 'WatchList' }
    & WatchListFragmentFragment
  ) | null | undefined };

export type GetWatchListForModelQueryVariables = Exact<{
  input?: InputMaybe<TargetEntityDefinitionInput>;
}>;


export type GetWatchListForModelQuery = { __typename?: 'Query', entityWatchList?: (
    { __typename?: 'WatchList' }
    & WatchListFragmentFragment
  ) | null | undefined };

export const DisputeResolutionOptionFragmentFragmentDoc = `
    fragment DisputeResolutionOptionFragment on ApprovalProcessDisputeResolutionOption {
  id
  name
  targetModelName
  code
}
    `;
export const ApprovalControlStepDataFragmentDoc = `
    fragment ApprovalControlStepData on ComponentApprovalProcessApprovalProcessControlStep {
  __typename
  id
  status
  controlType
  reasonRequired
  decisionReason
}
    `;
export const ApprovalDisputeResolutionDataFragmentDoc = `
    fragment ApprovalDisputeResolutionData on ComponentApprovalProcessDisputeResolutionStep {
  __typename
  disputeResolutionStatus: status
  reinitializeApprovalProcess
  resolution {
    name
  }
}
    `;
export const ApprovalInformStepDataFragmentDoc = `
    fragment ApprovalInformStepData on ComponentApprovalProcessInformStep {
  __typename
  type
}
    `;
export const ApprovalProcessStepFragmentDoc = `
    fragment ApprovalProcessStep on ApprovalStep {
  id
  updated_at
  at
  user {
    id
    name
  }
  note
  index
  at
  data {
    ... on ComponentApprovalProcessApprovalProcessControlStep {
      ...ApprovalControlStepData
    }
    ... on ComponentApprovalProcessDisputeResolutionStep {
      ...ApprovalDisputeResolutionData
    }
    ... on ComponentApprovalProcessInformStep {
      ...ApprovalInformStepData
    }
  }
}
    ${ApprovalControlStepDataFragmentDoc}
${ApprovalDisputeResolutionDataFragmentDoc}
${ApprovalInformStepDataFragmentDoc}`;
export const ApprovalProcessFragmentFragmentDoc = `
    fragment ApprovalProcessFragment on ApprovalProcess {
  status
  startOfCurrentPhaseIndex
  steps {
    ... on ApprovalStep {
      ...ApprovalProcessStep
    }
  }
}
    ${ApprovalProcessStepFragmentDoc}`;
export const BasicCommentFragmentFragmentDoc = `
    fragment BasicCommentFragment on Comment {
  id
  created_at
  updated_at
  content
  subcomments {
    id
  }
  author {
    name
    email
    image {
      previewUrl
    }
  }
}
    `;
export const InvoiceReadModelFragmentFragmentDoc = `
    fragment InvoiceReadModelFragment on InvoiceReadModel {
  id
  dateReceived
  invoiceNumber
  subject
  variableSymbol
  pairingSymbol
  status
  type
  approvalProcessCurrentStepId
  approvalProcessCurrentStepType
  source_entity {
    id
  }
  approvalProcessWaitingOn {
    name
    id
  }
  approvalProcessStatus
  attachments {
    id
    name
    type
  }
  department {
    id
    name
  }
  partner {
    id
    name
  }
  dueDate
  origin {
    id
  }
  project {
    name
    id
  }
  sum
}
    `;
export const ReceivedMailEntityFragmentFragmentDoc = `
    fragment ReceivedMailEntityFragment on ReceivedMail {
  id
  senderPartner {
    id
    name
  }
  dateReceived
  status
  senderAddress {
    id
    name
  }
  department {
    id
    name
  }
  project {
    id
    name
  }
  contents
  typeOfDelivery
  previousNumber
  note
  priority
  processed
  assignee {
    id
    name
  }
  invoice {
    id
    invoiceNumber
  }
  attachements {
    id
    name
    type
  }
}
    `;
export const SavedFilterFragmentFragmentDoc = `
    fragment SavedFilterFragment on SavedFilter {
  id
  name
  filters
  targetModelName
}
    `;
export const TableServiceLogFragmentDoc = `
    fragment TableServiceLog on ServiceLog {
  id
  date
  employee {
    name
    id
  }
  description
  result
  vehicle {
    registrationNumber
  }
}
    `;
export const FolderFragmentFragmentDoc = `
    fragment FolderFragment on StorageFolder {
  name
  id
  path
  parent_folder {
    id
  }
}
    `;
export const FileFragmentFragmentDoc = `
    fragment FileFragment on S3File {
  id
  name
  key
  type
  uploadedAt
}
    `;
export const VehicleRoutesRouteFragmentDoc = `
    fragment VehicleRoutesRoute on TravelLogRouteTemp {
  id
  reason {
    name
    durationInHoursFrom
    durationInHoursTo
  }
  destination {
    id
    name
    cityCode
    address
  }
  defaultMonthLimit
}
    `;
export const SimpleUserFragmentFragmentDoc = `
    fragment SimpleUserFragment on UserSimple {
  id
  name
}
    `;
export const WatchListFragmentFragmentDoc = `
    fragment WatchListFragment on WatchList {
  users {
    id
    name
  }
  targetModelName
  targetModelId
}
    `;
export const GetDisputeResolutionOptionsForModelDocument = `
    query getDisputeResolutionOptionsForModel($modelName: String!) {
  approvalProcessDisputeResolutionOptions(where: {targetModelName: $modelName}) {
    ...DisputeResolutionOptionFragment
  }
}
    ${DisputeResolutionOptionFragmentFragmentDoc}`;
export const useGetDisputeResolutionOptionsForModelQuery = <
      TData = GetDisputeResolutionOptionsForModelQuery,
      TError = unknown
    >(
      variables: GetDisputeResolutionOptionsForModelQueryVariables,
      options?: UseQueryOptions<GetDisputeResolutionOptionsForModelQuery, TError, TData>
    ) =>
    useQuery<GetDisputeResolutionOptionsForModelQuery, TError, TData>(
      ['getDisputeResolutionOptionsForModel', variables],
      fetchData<GetDisputeResolutionOptionsForModelQuery, GetDisputeResolutionOptionsForModelQueryVariables>(GetDisputeResolutionOptionsForModelDocument, variables),
      options
    );
useGetDisputeResolutionOptionsForModelQuery.document = GetDisputeResolutionOptionsForModelDocument;


useGetDisputeResolutionOptionsForModelQuery.getKey = (variables: GetDisputeResolutionOptionsForModelQueryVariables) => ['getDisputeResolutionOptionsForModel', variables];
;

useGetDisputeResolutionOptionsForModelQuery.fetcher = (variables: GetDisputeResolutionOptionsForModelQueryVariables) => fetchData<GetDisputeResolutionOptionsForModelQuery, GetDisputeResolutionOptionsForModelQueryVariables>(GetDisputeResolutionOptionsForModelDocument, variables);
export const ApproveOrRejectApprovalStepDocument = `
    mutation approveOrRejectApprovalStep($input: ApproveOrRejectApprovalStepInput!) {
  approveOrRejectApprovalStep(input: $input) {
    approval_process {
      ... on ApprovalProcess {
        ...ApprovalProcessFragment
      }
    }
  }
}
    ${ApprovalProcessFragmentFragmentDoc}`;
export const useApproveOrRejectApprovalStepMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveOrRejectApprovalStepMutation, TError, ApproveOrRejectApprovalStepMutationVariables, TContext>) =>
    useMutation<ApproveOrRejectApprovalStepMutation, TError, ApproveOrRejectApprovalStepMutationVariables, TContext>(
      ['approveOrRejectApprovalStep'],
      (variables?: ApproveOrRejectApprovalStepMutationVariables) => fetchData<ApproveOrRejectApprovalStepMutation, ApproveOrRejectApprovalStepMutationVariables>(ApproveOrRejectApprovalStepDocument, variables)(),
      options
    );
useApproveOrRejectApprovalStepMutation.fetcher = (variables: ApproveOrRejectApprovalStepMutationVariables) => fetchData<ApproveOrRejectApprovalStepMutation, ApproveOrRejectApprovalStepMutationVariables>(ApproveOrRejectApprovalStepDocument, variables);
export const ResolveDisputeDocument = `
    mutation resolveDispute($input: ResolveDisputeInput) {
  resolveDispute(input: $input) {
    approval_process {
      ... on ApprovalProcess {
        ...ApprovalProcessFragment
      }
    }
  }
}
    ${ApprovalProcessFragmentFragmentDoc}`;
export const useResolveDisputeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResolveDisputeMutation, TError, ResolveDisputeMutationVariables, TContext>) =>
    useMutation<ResolveDisputeMutation, TError, ResolveDisputeMutationVariables, TContext>(
      ['resolveDispute'],
      (variables?: ResolveDisputeMutationVariables) => fetchData<ResolveDisputeMutation, ResolveDisputeMutationVariables>(ResolveDisputeDocument, variables)(),
      options
    );
useResolveDisputeMutation.fetcher = (variables?: ResolveDisputeMutationVariables) => fetchData<ResolveDisputeMutation, ResolveDisputeMutationVariables>(ResolveDisputeDocument, variables);
export const InitializeApprovalProcessDocument = `
    mutation initializeApprovalProcess($input: InitializeApprovalProcessInput!) {
  initializeApprovalProcess(input: $input)
}
    `;
export const useInitializeApprovalProcessMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InitializeApprovalProcessMutation, TError, InitializeApprovalProcessMutationVariables, TContext>) =>
    useMutation<InitializeApprovalProcessMutation, TError, InitializeApprovalProcessMutationVariables, TContext>(
      ['initializeApprovalProcess'],
      (variables?: InitializeApprovalProcessMutationVariables) => fetchData<InitializeApprovalProcessMutation, InitializeApprovalProcessMutationVariables>(InitializeApprovalProcessDocument, variables)(),
      options
    );
useInitializeApprovalProcessMutation.fetcher = (variables: InitializeApprovalProcessMutationVariables) => fetchData<InitializeApprovalProcessMutation, InitializeApprovalProcessMutationVariables>(InitializeApprovalProcessDocument, variables);
export const GetApprovalProcessesDocument = `
    query getApprovalProcesses($input: JSON!) {
  approvalProcesses(where: $input) {
    ... on ApprovalProcess {
      ...ApprovalProcessFragment
    }
  }
}
    ${ApprovalProcessFragmentFragmentDoc}`;
export const useGetApprovalProcessesQuery = <
      TData = GetApprovalProcessesQuery,
      TError = unknown
    >(
      variables: GetApprovalProcessesQueryVariables,
      options?: UseQueryOptions<GetApprovalProcessesQuery, TError, TData>
    ) =>
    useQuery<GetApprovalProcessesQuery, TError, TData>(
      ['getApprovalProcesses', variables],
      fetchData<GetApprovalProcessesQuery, GetApprovalProcessesQueryVariables>(GetApprovalProcessesDocument, variables),
      options
    );
useGetApprovalProcessesQuery.document = GetApprovalProcessesDocument;


useGetApprovalProcessesQuery.getKey = (variables: GetApprovalProcessesQueryVariables) => ['getApprovalProcesses', variables];
;

useGetApprovalProcessesQuery.fetcher = (variables: GetApprovalProcessesQueryVariables) => fetchData<GetApprovalProcessesQuery, GetApprovalProcessesQueryVariables>(GetApprovalProcessesDocument, variables);
export const GetApprovalStepDocument = `
    query getApprovalStep($id: ID!) {
  approvalStep(id: $id) {
    id
  }
}
    `;
export const useGetApprovalStepQuery = <
      TData = GetApprovalStepQuery,
      TError = unknown
    >(
      variables: GetApprovalStepQueryVariables,
      options?: UseQueryOptions<GetApprovalStepQuery, TError, TData>
    ) =>
    useQuery<GetApprovalStepQuery, TError, TData>(
      ['getApprovalStep', variables],
      fetchData<GetApprovalStepQuery, GetApprovalStepQueryVariables>(GetApprovalStepDocument, variables),
      options
    );
useGetApprovalStepQuery.document = GetApprovalStepDocument;


useGetApprovalStepQuery.getKey = (variables: GetApprovalStepQueryVariables) => ['getApprovalStep', variables];
;

useGetApprovalStepQuery.fetcher = (variables: GetApprovalStepQueryVariables) => fetchData<GetApprovalStepQuery, GetApprovalStepQueryVariables>(GetApprovalStepDocument, variables);
export const AddEntityCommentDocument = `
    mutation addEntityComment($input: AddEntityCommentInput!) {
  addEntityComment(input: $input) {
    id
  }
}
    `;
export const useAddEntityCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddEntityCommentMutation, TError, AddEntityCommentMutationVariables, TContext>) =>
    useMutation<AddEntityCommentMutation, TError, AddEntityCommentMutationVariables, TContext>(
      ['addEntityComment'],
      (variables?: AddEntityCommentMutationVariables) => fetchData<AddEntityCommentMutation, AddEntityCommentMutationVariables>(AddEntityCommentDocument, variables)(),
      options
    );
useAddEntityCommentMutation.fetcher = (variables: AddEntityCommentMutationVariables) => fetchData<AddEntityCommentMutation, AddEntityCommentMutationVariables>(AddEntityCommentDocument, variables);
export const GetEntityCommentsDocument = `
    query getEntityComments($targetModelName: String!, $targetModelId: ID!) {
  comments(
    sort: "created_at:asc"
    where: {targetModelId: $targetModelId, targetModelName: $targetModelName}
  ) {
    ...BasicCommentFragment
  }
}
    ${BasicCommentFragmentFragmentDoc}`;
export const useGetEntityCommentsQuery = <
      TData = GetEntityCommentsQuery,
      TError = unknown
    >(
      variables: GetEntityCommentsQueryVariables,
      options?: UseQueryOptions<GetEntityCommentsQuery, TError, TData>
    ) =>
    useQuery<GetEntityCommentsQuery, TError, TData>(
      ['getEntityComments', variables],
      fetchData<GetEntityCommentsQuery, GetEntityCommentsQueryVariables>(GetEntityCommentsDocument, variables),
      options
    );
useGetEntityCommentsQuery.document = GetEntityCommentsDocument;


useGetEntityCommentsQuery.getKey = (variables: GetEntityCommentsQueryVariables) => ['getEntityComments', variables];
;

useGetEntityCommentsQuery.fetcher = (variables: GetEntityCommentsQueryVariables) => fetchData<GetEntityCommentsQuery, GetEntityCommentsQueryVariables>(GetEntityCommentsDocument, variables);
export const GetUsersForMentionDocument = `
    query getUsersForMention($name: String) {
  users(where: {name_contains: $name}) {
    id
    name
    uuid
  }
}
    `;
export const useGetUsersForMentionQuery = <
      TData = GetUsersForMentionQuery,
      TError = unknown
    >(
      variables?: GetUsersForMentionQueryVariables,
      options?: UseQueryOptions<GetUsersForMentionQuery, TError, TData>
    ) =>
    useQuery<GetUsersForMentionQuery, TError, TData>(
      variables === undefined ? ['getUsersForMention'] : ['getUsersForMention', variables],
      fetchData<GetUsersForMentionQuery, GetUsersForMentionQueryVariables>(GetUsersForMentionDocument, variables),
      options
    );
useGetUsersForMentionQuery.document = GetUsersForMentionDocument;


useGetUsersForMentionQuery.getKey = (variables?: GetUsersForMentionQueryVariables) => variables === undefined ? ['getUsersForMention'] : ['getUsersForMention', variables];
;

useGetUsersForMentionQuery.fetcher = (variables?: GetUsersForMentionQueryVariables) => fetchData<GetUsersForMentionQuery, GetUsersForMentionQueryVariables>(GetUsersForMentionDocument, variables);
export const GetInvoiceReadModelsDocument = `
    query getInvoiceReadModels($limit: Int, $sort: String, $start: Int, $where: JSON!) {
  invoiceReadModels(where: $where, limit: $limit, start: $start, sort: $sort) {
    ...InvoiceReadModelFragment
  }
  invoiceReadModelCount(where: $where)
}
    ${InvoiceReadModelFragmentFragmentDoc}`;
export const useGetInvoiceReadModelsQuery = <
      TData = GetInvoiceReadModelsQuery,
      TError = unknown
    >(
      variables: GetInvoiceReadModelsQueryVariables,
      options?: UseQueryOptions<GetInvoiceReadModelsQuery, TError, TData>
    ) =>
    useQuery<GetInvoiceReadModelsQuery, TError, TData>(
      ['getInvoiceReadModels', variables],
      fetchData<GetInvoiceReadModelsQuery, GetInvoiceReadModelsQueryVariables>(GetInvoiceReadModelsDocument, variables),
      options
    );
useGetInvoiceReadModelsQuery.document = GetInvoiceReadModelsDocument;


useGetInvoiceReadModelsQuery.getKey = (variables: GetInvoiceReadModelsQueryVariables) => ['getInvoiceReadModels', variables];
;

useGetInvoiceReadModelsQuery.fetcher = (variables: GetInvoiceReadModelsQueryVariables) => fetchData<GetInvoiceReadModelsQuery, GetInvoiceReadModelsQueryVariables>(GetInvoiceReadModelsDocument, variables);
export const ManuallyMarkNotificationAsDocument = `
    mutation manuallyMarkNotificationAs($id: InputID!, $read: Boolean) {
  updateNotification(input: {where: $id, data: {read: $read}}) {
    notification {
      id
    }
  }
}
    `;
export const useManuallyMarkNotificationAsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ManuallyMarkNotificationAsMutation, TError, ManuallyMarkNotificationAsMutationVariables, TContext>) =>
    useMutation<ManuallyMarkNotificationAsMutation, TError, ManuallyMarkNotificationAsMutationVariables, TContext>(
      ['manuallyMarkNotificationAs'],
      (variables?: ManuallyMarkNotificationAsMutationVariables) => fetchData<ManuallyMarkNotificationAsMutation, ManuallyMarkNotificationAsMutationVariables>(ManuallyMarkNotificationAsDocument, variables)(),
      options
    );
useManuallyMarkNotificationAsMutation.fetcher = (variables: ManuallyMarkNotificationAsMutationVariables) => fetchData<ManuallyMarkNotificationAsMutation, ManuallyMarkNotificationAsMutationVariables>(ManuallyMarkNotificationAsDocument, variables);
export const SetMailStatusDocument = `
    mutation setMailStatus($input: SetMailStatusInput!) {
  setMailStatus(input: $input) {
    ...ReceivedMailEntityFragment
  }
}
    ${ReceivedMailEntityFragmentFragmentDoc}`;
export const useSetMailStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetMailStatusMutation, TError, SetMailStatusMutationVariables, TContext>) =>
    useMutation<SetMailStatusMutation, TError, SetMailStatusMutationVariables, TContext>(
      ['setMailStatus'],
      (variables?: SetMailStatusMutationVariables) => fetchData<SetMailStatusMutation, SetMailStatusMutationVariables>(SetMailStatusDocument, variables)(),
      options
    );
useSetMailStatusMutation.fetcher = (variables: SetMailStatusMutationVariables) => fetchData<SetMailStatusMutation, SetMailStatusMutationVariables>(SetMailStatusDocument, variables);
export const SaveFilterDocument = `
    mutation saveFilter($input: createSavedFilterInput!) {
  createSavedFilter(input: $input) {
    savedFilter {
      ...SavedFilterFragment
    }
  }
}
    ${SavedFilterFragmentFragmentDoc}`;
export const useSaveFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveFilterMutation, TError, SaveFilterMutationVariables, TContext>) =>
    useMutation<SaveFilterMutation, TError, SaveFilterMutationVariables, TContext>(
      ['saveFilter'],
      (variables?: SaveFilterMutationVariables) => fetchData<SaveFilterMutation, SaveFilterMutationVariables>(SaveFilterDocument, variables)(),
      options
    );
useSaveFilterMutation.fetcher = (variables: SaveFilterMutationVariables) => fetchData<SaveFilterMutation, SaveFilterMutationVariables>(SaveFilterDocument, variables);
export const UpdateSavedFilterDocument = `
    mutation updateSavedFilter($input: updateSavedFilterInput!) {
  updateSavedFilter(input: $input) {
    savedFilter {
      ...SavedFilterFragment
    }
  }
}
    ${SavedFilterFragmentFragmentDoc}`;
export const useUpdateSavedFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSavedFilterMutation, TError, UpdateSavedFilterMutationVariables, TContext>) =>
    useMutation<UpdateSavedFilterMutation, TError, UpdateSavedFilterMutationVariables, TContext>(
      ['updateSavedFilter'],
      (variables?: UpdateSavedFilterMutationVariables) => fetchData<UpdateSavedFilterMutation, UpdateSavedFilterMutationVariables>(UpdateSavedFilterDocument, variables)(),
      options
    );
useUpdateSavedFilterMutation.fetcher = (variables: UpdateSavedFilterMutationVariables) => fetchData<UpdateSavedFilterMutation, UpdateSavedFilterMutationVariables>(UpdateSavedFilterDocument, variables);
export const DeleteSavedFilterDocument = `
    mutation deleteSavedFilter($input: deleteSavedFilterInput!) {
  deleteSavedFilter(input: $input) {
    savedFilter {
      ...SavedFilterFragment
    }
  }
}
    ${SavedFilterFragmentFragmentDoc}`;
export const useDeleteSavedFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSavedFilterMutation, TError, DeleteSavedFilterMutationVariables, TContext>) =>
    useMutation<DeleteSavedFilterMutation, TError, DeleteSavedFilterMutationVariables, TContext>(
      ['deleteSavedFilter'],
      (variables?: DeleteSavedFilterMutationVariables) => fetchData<DeleteSavedFilterMutation, DeleteSavedFilterMutationVariables>(DeleteSavedFilterDocument, variables)(),
      options
    );
useDeleteSavedFilterMutation.fetcher = (variables: DeleteSavedFilterMutationVariables) => fetchData<DeleteSavedFilterMutation, DeleteSavedFilterMutationVariables>(DeleteSavedFilterDocument, variables);
export const MySavedFiltersDocument = `
    query mySavedFilters($where: MyFiltersWhereInput) {
  myFilters(where: $where) {
    ...SavedFilterFragment
  }
}
    ${SavedFilterFragmentFragmentDoc}`;
export const useMySavedFiltersQuery = <
      TData = MySavedFiltersQuery,
      TError = unknown
    >(
      variables?: MySavedFiltersQueryVariables,
      options?: UseQueryOptions<MySavedFiltersQuery, TError, TData>
    ) =>
    useQuery<MySavedFiltersQuery, TError, TData>(
      variables === undefined ? ['mySavedFilters'] : ['mySavedFilters', variables],
      fetchData<MySavedFiltersQuery, MySavedFiltersQueryVariables>(MySavedFiltersDocument, variables),
      options
    );
useMySavedFiltersQuery.document = MySavedFiltersDocument;


useMySavedFiltersQuery.getKey = (variables?: MySavedFiltersQueryVariables) => variables === undefined ? ['mySavedFilters'] : ['mySavedFilters', variables];
;

useMySavedFiltersQuery.fetcher = (variables?: MySavedFiltersQueryVariables) => fetchData<MySavedFiltersQuery, MySavedFiltersQueryVariables>(MySavedFiltersDocument, variables);
export const GetServiceLogsDocument = `
    query getServiceLogs($limit: Int, $start: Int, $where: JSON, $sort: String) {
  serviceLogs(limit: $limit, start: $start, where: $where, sort: $sort) {
    ...TableServiceLog
  }
  serviceLogsCount(where: $where)
}
    ${TableServiceLogFragmentDoc}`;
export const useGetServiceLogsQuery = <
      TData = GetServiceLogsQuery,
      TError = unknown
    >(
      variables?: GetServiceLogsQueryVariables,
      options?: UseQueryOptions<GetServiceLogsQuery, TError, TData>
    ) =>
    useQuery<GetServiceLogsQuery, TError, TData>(
      variables === undefined ? ['getServiceLogs'] : ['getServiceLogs', variables],
      fetchData<GetServiceLogsQuery, GetServiceLogsQueryVariables>(GetServiceLogsDocument, variables),
      options
    );
useGetServiceLogsQuery.document = GetServiceLogsDocument;


useGetServiceLogsQuery.getKey = (variables?: GetServiceLogsQueryVariables) => variables === undefined ? ['getServiceLogs'] : ['getServiceLogs', variables];
;

useGetServiceLogsQuery.fetcher = (variables?: GetServiceLogsQueryVariables) => fetchData<GetServiceLogsQuery, GetServiceLogsQueryVariables>(GetServiceLogsDocument, variables);
export const CreateStorageFolderDocument = `
    mutation createStorageFolder($input: createStorageFolderInput!) {
  createStorageFolder(input: $input) {
    storageFolder {
      id
      name
    }
  }
}
    `;
export const useCreateStorageFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateStorageFolderMutation, TError, CreateStorageFolderMutationVariables, TContext>) =>
    useMutation<CreateStorageFolderMutation, TError, CreateStorageFolderMutationVariables, TContext>(
      ['createStorageFolder'],
      (variables?: CreateStorageFolderMutationVariables) => fetchData<CreateStorageFolderMutation, CreateStorageFolderMutationVariables>(CreateStorageFolderDocument, variables)(),
      options
    );
useCreateStorageFolderMutation.fetcher = (variables: CreateStorageFolderMutationVariables) => fetchData<CreateStorageFolderMutation, CreateStorageFolderMutationVariables>(CreateStorageFolderDocument, variables);
export const CurrentFolderFilesAndFoldersDocument = `
    query currentFolderFilesAndFolders($id: ID!) {
  storageFolder(id: $id) {
    files {
      id
      type
      name
    }
    child_folders {
      id
      name
    }
  }
}
    `;
export const useCurrentFolderFilesAndFoldersQuery = <
      TData = CurrentFolderFilesAndFoldersQuery,
      TError = unknown
    >(
      variables: CurrentFolderFilesAndFoldersQueryVariables,
      options?: UseQueryOptions<CurrentFolderFilesAndFoldersQuery, TError, TData>
    ) =>
    useQuery<CurrentFolderFilesAndFoldersQuery, TError, TData>(
      ['currentFolderFilesAndFolders', variables],
      fetchData<CurrentFolderFilesAndFoldersQuery, CurrentFolderFilesAndFoldersQueryVariables>(CurrentFolderFilesAndFoldersDocument, variables),
      options
    );
useCurrentFolderFilesAndFoldersQuery.document = CurrentFolderFilesAndFoldersDocument;


useCurrentFolderFilesAndFoldersQuery.getKey = (variables: CurrentFolderFilesAndFoldersQueryVariables) => ['currentFolderFilesAndFolders', variables];
;

useCurrentFolderFilesAndFoldersQuery.fetcher = (variables: CurrentFolderFilesAndFoldersQueryVariables) => fetchData<CurrentFolderFilesAndFoldersQuery, CurrentFolderFilesAndFoldersQueryVariables>(CurrentFolderFilesAndFoldersDocument, variables);
export const GetFolderByPathDocument = `
    query getFolderByPath($where: JSON!) {
  storageFolders(where: $where) {
    ...FolderFragment
  }
}
    ${FolderFragmentFragmentDoc}`;
export const useGetFolderByPathQuery = <
      TData = GetFolderByPathQuery,
      TError = unknown
    >(
      variables: GetFolderByPathQueryVariables,
      options?: UseQueryOptions<GetFolderByPathQuery, TError, TData>
    ) =>
    useQuery<GetFolderByPathQuery, TError, TData>(
      ['getFolderByPath', variables],
      fetchData<GetFolderByPathQuery, GetFolderByPathQueryVariables>(GetFolderByPathDocument, variables),
      options
    );
useGetFolderByPathQuery.document = GetFolderByPathDocument;


useGetFolderByPathQuery.getKey = (variables: GetFolderByPathQueryVariables) => ['getFolderByPath', variables];
;

useGetFolderByPathQuery.fetcher = (variables: GetFolderByPathQueryVariables) => fetchData<GetFolderByPathQuery, GetFolderByPathQueryVariables>(GetFolderByPathDocument, variables);
export const GetFolderFilesDocument = `
    query getFolderFiles($where: JSON!) {
  s3Files(where: $where) {
    ...FileFragment
  }
}
    ${FileFragmentFragmentDoc}`;
export const useGetFolderFilesQuery = <
      TData = GetFolderFilesQuery,
      TError = unknown
    >(
      variables: GetFolderFilesQueryVariables,
      options?: UseQueryOptions<GetFolderFilesQuery, TError, TData>
    ) =>
    useQuery<GetFolderFilesQuery, TError, TData>(
      ['getFolderFiles', variables],
      fetchData<GetFolderFilesQuery, GetFolderFilesQueryVariables>(GetFolderFilesDocument, variables),
      options
    );
useGetFolderFilesQuery.document = GetFolderFilesDocument;


useGetFolderFilesQuery.getKey = (variables: GetFolderFilesQueryVariables) => ['getFolderFiles', variables];
;

useGetFolderFilesQuery.fetcher = (variables: GetFolderFilesQueryVariables) => fetchData<GetFolderFilesQuery, GetFolderFilesQueryVariables>(GetFolderFilesDocument, variables);
export const GetFolderSubFoldersDocument = `
    query getFolderSubFolders($where: JSON!) {
  storageFolders(where: $where) {
    ...FolderFragment
  }
}
    ${FolderFragmentFragmentDoc}`;
export const useGetFolderSubFoldersQuery = <
      TData = GetFolderSubFoldersQuery,
      TError = unknown
    >(
      variables: GetFolderSubFoldersQueryVariables,
      options?: UseQueryOptions<GetFolderSubFoldersQuery, TError, TData>
    ) =>
    useQuery<GetFolderSubFoldersQuery, TError, TData>(
      ['getFolderSubFolders', variables],
      fetchData<GetFolderSubFoldersQuery, GetFolderSubFoldersQueryVariables>(GetFolderSubFoldersDocument, variables),
      options
    );
useGetFolderSubFoldersQuery.document = GetFolderSubFoldersDocument;


useGetFolderSubFoldersQuery.getKey = (variables: GetFolderSubFoldersQueryVariables) => ['getFolderSubFolders', variables];
;

useGetFolderSubFoldersQuery.fetcher = (variables: GetFolderSubFoldersQueryVariables) => fetchData<GetFolderSubFoldersQuery, GetFolderSubFoldersQueryVariables>(GetFolderSubFoldersDocument, variables);
export const GetVehicleRoutesDocument = `
    query getVehicleRoutes($where: JSON!) {
  travelLogRouteTemps(where: $where, limit: 300) {
    ...VehicleRoutesRoute
  }
}
    ${VehicleRoutesRouteFragmentDoc}`;
export const useGetVehicleRoutesQuery = <
      TData = GetVehicleRoutesQuery,
      TError = unknown
    >(
      variables: GetVehicleRoutesQueryVariables,
      options?: UseQueryOptions<GetVehicleRoutesQuery, TError, TData>
    ) =>
    useQuery<GetVehicleRoutesQuery, TError, TData>(
      ['getVehicleRoutes', variables],
      fetchData<GetVehicleRoutesQuery, GetVehicleRoutesQueryVariables>(GetVehicleRoutesDocument, variables),
      options
    );
useGetVehicleRoutesQuery.document = GetVehicleRoutesDocument;


useGetVehicleRoutesQuery.getKey = (variables: GetVehicleRoutesQueryVariables) => ['getVehicleRoutes', variables];
;

useGetVehicleRoutesQuery.fetcher = (variables: GetVehicleRoutesQueryVariables) => fetchData<GetVehicleRoutesQuery, GetVehicleRoutesQueryVariables>(GetVehicleRoutesDocument, variables);
export const CreateVehicleRouteDocument = `
    mutation createVehicleRoute($input: CreateVehicleRouteInput) {
  createVehicleRoute(input: $input) {
    ...VehicleRoutesRoute
  }
}
    ${VehicleRoutesRouteFragmentDoc}`;
export const useCreateVehicleRouteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateVehicleRouteMutation, TError, CreateVehicleRouteMutationVariables, TContext>) =>
    useMutation<CreateVehicleRouteMutation, TError, CreateVehicleRouteMutationVariables, TContext>(
      ['createVehicleRoute'],
      (variables?: CreateVehicleRouteMutationVariables) => fetchData<CreateVehicleRouteMutation, CreateVehicleRouteMutationVariables>(CreateVehicleRouteDocument, variables)(),
      options
    );
useCreateVehicleRouteMutation.fetcher = (variables?: CreateVehicleRouteMutationVariables) => fetchData<CreateVehicleRouteMutation, CreateVehicleRouteMutationVariables>(CreateVehicleRouteDocument, variables);
export const DeleteVehicleRouteDocument = `
    mutation deleteVehicleRoute($input: deleteTravelLogRouteTempInput) {
  deleteTravelLogRouteTemp(input: $input) {
    travelLogRouteTemp {
      id
    }
  }
}
    `;
export const useDeleteVehicleRouteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteVehicleRouteMutation, TError, DeleteVehicleRouteMutationVariables, TContext>) =>
    useMutation<DeleteVehicleRouteMutation, TError, DeleteVehicleRouteMutationVariables, TContext>(
      ['deleteVehicleRoute'],
      (variables?: DeleteVehicleRouteMutationVariables) => fetchData<DeleteVehicleRouteMutation, DeleteVehicleRouteMutationVariables>(DeleteVehicleRouteDocument, variables)(),
      options
    );
useDeleteVehicleRouteMutation.fetcher = (variables?: DeleteVehicleRouteMutationVariables) => fetchData<DeleteVehicleRouteMutation, DeleteVehicleRouteMutationVariables>(DeleteVehicleRouteDocument, variables);
export const GetUsersSimpleDocument = `
    query getUsersSimple($where: UsersSimpleWhereInput) {
  getUsersSimple(where: $where) {
    ...SimpleUserFragment
  }
}
    ${SimpleUserFragmentFragmentDoc}`;
export const useGetUsersSimpleQuery = <
      TData = GetUsersSimpleQuery,
      TError = unknown
    >(
      variables?: GetUsersSimpleQueryVariables,
      options?: UseQueryOptions<GetUsersSimpleQuery, TError, TData>
    ) =>
    useQuery<GetUsersSimpleQuery, TError, TData>(
      variables === undefined ? ['getUsersSimple'] : ['getUsersSimple', variables],
      fetchData<GetUsersSimpleQuery, GetUsersSimpleQueryVariables>(GetUsersSimpleDocument, variables),
      options
    );
useGetUsersSimpleQuery.document = GetUsersSimpleDocument;


useGetUsersSimpleQuery.getKey = (variables?: GetUsersSimpleQueryVariables) => variables === undefined ? ['getUsersSimple'] : ['getUsersSimple', variables];
;

useGetUsersSimpleQuery.fetcher = (variables?: GetUsersSimpleQueryVariables) => fetchData<GetUsersSimpleQuery, GetUsersSimpleQueryVariables>(GetUsersSimpleDocument, variables);
export const GetVersionAnnouncmentsAfterVersionDocument = `
    query getVersionAnnouncmentsAfterVersion($version: Int) {
  versionReleases(where: {versionNumerically_gt: $version}) {
    version
    versionNumerically
    content
  }
}
    `;
export const useGetVersionAnnouncmentsAfterVersionQuery = <
      TData = GetVersionAnnouncmentsAfterVersionQuery,
      TError = unknown
    >(
      variables?: GetVersionAnnouncmentsAfterVersionQueryVariables,
      options?: UseQueryOptions<GetVersionAnnouncmentsAfterVersionQuery, TError, TData>
    ) =>
    useQuery<GetVersionAnnouncmentsAfterVersionQuery, TError, TData>(
      variables === undefined ? ['getVersionAnnouncmentsAfterVersion'] : ['getVersionAnnouncmentsAfterVersion', variables],
      fetchData<GetVersionAnnouncmentsAfterVersionQuery, GetVersionAnnouncmentsAfterVersionQueryVariables>(GetVersionAnnouncmentsAfterVersionDocument, variables),
      options
    );
useGetVersionAnnouncmentsAfterVersionQuery.document = GetVersionAnnouncmentsAfterVersionDocument;


useGetVersionAnnouncmentsAfterVersionQuery.getKey = (variables?: GetVersionAnnouncmentsAfterVersionQueryVariables) => variables === undefined ? ['getVersionAnnouncmentsAfterVersion'] : ['getVersionAnnouncmentsAfterVersion', variables];
;

useGetVersionAnnouncmentsAfterVersionQuery.fetcher = (variables?: GetVersionAnnouncmentsAfterVersionQueryVariables) => fetchData<GetVersionAnnouncmentsAfterVersionQuery, GetVersionAnnouncmentsAfterVersionQueryVariables>(GetVersionAnnouncmentsAfterVersionDocument, variables);
export const UpdateWatchListDocument = `
    mutation updateWatchList($input: UpdateModelWatchListInput) {
  updateModelWatchList(input: $input) {
    ...WatchListFragment
  }
}
    ${WatchListFragmentFragmentDoc}`;
export const useUpdateWatchListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWatchListMutation, TError, UpdateWatchListMutationVariables, TContext>) =>
    useMutation<UpdateWatchListMutation, TError, UpdateWatchListMutationVariables, TContext>(
      ['updateWatchList'],
      (variables?: UpdateWatchListMutationVariables) => fetchData<UpdateWatchListMutation, UpdateWatchListMutationVariables>(UpdateWatchListDocument, variables)(),
      options
    );
useUpdateWatchListMutation.fetcher = (variables?: UpdateWatchListMutationVariables) => fetchData<UpdateWatchListMutation, UpdateWatchListMutationVariables>(UpdateWatchListDocument, variables);
export const GetWatchListForModelDocument = `
    query getWatchListForModel($input: TargetEntityDefinitionInput) {
  entityWatchList(input: $input) {
    ...WatchListFragment
  }
}
    ${WatchListFragmentFragmentDoc}`;
export const useGetWatchListForModelQuery = <
      TData = GetWatchListForModelQuery,
      TError = unknown
    >(
      variables?: GetWatchListForModelQueryVariables,
      options?: UseQueryOptions<GetWatchListForModelQuery, TError, TData>
    ) =>
    useQuery<GetWatchListForModelQuery, TError, TData>(
      variables === undefined ? ['getWatchListForModel'] : ['getWatchListForModel', variables],
      fetchData<GetWatchListForModelQuery, GetWatchListForModelQueryVariables>(GetWatchListForModelDocument, variables),
      options
    );
useGetWatchListForModelQuery.document = GetWatchListForModelDocument;


useGetWatchListForModelQuery.getKey = (variables?: GetWatchListForModelQueryVariables) => variables === undefined ? ['getWatchListForModel'] : ['getWatchListForModel', variables];
;

useGetWatchListForModelQuery.fetcher = (variables?: GetWatchListForModelQueryVariables) => fetchData<GetWatchListForModelQuery, GetWatchListForModelQueryVariables>(GetWatchListForModelDocument, variables);